// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fonts imported in public/index.html */

:root {
  /* Unity Bank Color Scheme - Changed to Black */
  --primary: #000000;
  --primary-dark: #000000;
  --primary-darker: #000000;
  --primary-light: #000000;
  --primary-lighter: #000000;

  /* Secondary Colors */
  --secondary: #111111;
  --secondary-dark: #000000;

  /* Accent Colors */
  --accent-gold: #000000;
  --accent-gold-dark: #000000;

  /* Text Colors */
  --text-strong: #0b0b0b;
  --text-muted: #4a4a4a;

  /* Surface Colors */
  --surface: #ffffff;
  --surface-alt: #fff8e6;
  --surface-soft: #fffdf5;
  --surface-dark: #111111;

  /* Borders */
  --border-soft: rgba(17, 17, 17, 0.08);
  --border-strong: rgba(17, 17, 17, 0.16);

  /* Shadows */
  --shadow-soft: 0 25px 65px rgba(17, 17, 17, 0.12);
  --shadow-gold: 0 20px 50px rgba(247, 189, 32, 0.25);

  /* Premium Multi-Tone Gradients */

  /* Main Background Gradient - Visible Yellow (Light to Dark) */
  --gradient-background: linear-gradient(to right,
      #fef3c7 0%,
      #fde68a 50%,
      #fbbf24 100%);

  /* Hero Section - Warm yellow glow */
  --gradient-hero: linear-gradient(to right,
      rgba(254, 243, 199, 0.3) 0%,
      rgba(253, 230, 138, 0.3) 50%,
      rgba(251, 191, 36, 0.3) 100%);

  /* Primary Gradient - Warm orange to peachy coral */
  --gradient-primary: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);

  /* Accent Gradient - Orange with subtle rose gold */
  --gradient-accent: linear-gradient(120deg,
      #f7bd20 0%,
      #f4ad26 20%,
      #f19d2b 40%,
      #ed8f30 60%,
      #e88132 80%,
      #d89515 100%);

  /* Sophisticated Dark - Deep blacks with subtle blue undertone */
  --gradient-dark: linear-gradient(135deg,
      #1a1a1a 0%,
      #111111 50%,
      #0a0a0a 100%);

  /* New Premium Gradients */

  /* Radial glow for cards and highlights */
  --gradient-glow: radial-gradient(circle at top right,
      rgba(247, 189, 32, 0.15) 0%,
      rgba(247, 189, 32, 0.05) 40%,
      rgba(247, 189, 32, 0) 70%);

  /* Mesh gradient for modern backgrounds */
  --gradient-mesh: linear-gradient(135deg,
      rgba(247, 189, 32, 0.1) 0%,
      rgba(255, 255, 255, 0) 30%,
      rgba(238, 174, 50, 0.08) 60%,
      rgba(255, 255, 255, 0) 100%);

  /* Button hover - more vibrant */
  --gradient-button-hover: linear-gradient(135deg,
      #faca3d 0%,
      #f7bd20 50%,
      #e8a91a 100%);

  /* Subtle card background */
  --gradient-card: linear-gradient(to right,
      #FFF9E6 0%,
      #FFE082 35%,
      #D4A017 100%);

  /* Premium overlay for sections */
  --gradient-overlay: linear-gradient(180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(247, 189, 32, 0.03) 50%,
      rgba(255, 255, 255, 0) 100%);

  /* Typography - Poppins as primary font (matching Unity Bank) */
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  color: #0b0b0b;
  color: var(--text-strong);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

/* ===== Global responsive utilities ===== */
html,
body,
.App {
  overflow-x: hidden;
}

img,
picture,
video,
iframe {
  max-width: 100%;
  height: auto;
  display: block;
}

/* prevent very long words or unbroken content from causing horizontal scroll */
* {
  word-wrap: break-word;
  -ms-word-break: break-word;
  word-break: break-word;
  -webkit-hyphens: auto;
          hyphens: auto;
}

/* ===== Generic card/grid/container fixes (improve mobile layout) ===== */
.container,
.page,
.footer-inner,
.header-shell,
.main-content {
  box-sizing: border-box;
  padding-left: 1rem;
  padding-right: 1rem;
}

.card,
.value-card,
.stat-card-new,
.document-card,
.feature-bento-card,
.product-card,
.office-card,
.step-card,
.calc-side-card,
.feature-bento-business {
  width: 100% !important;
  max-width: 100% !important;
}

/* make common grids more fluid by default */
[class*="-grid"],
.grid,
.cards-grid,
.feature-grid,
.offering-grid,
.testimonial-track {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

/* Modals and overlays should be responsive */
.modal,
.dialog,
.drawer {
  max-width: 95vw;
}

/* Inputs - prevent iOS zoom and ensure legible size */
input,
textarea,
select,
button {
  font-size: 16px;
}

/* small screens: ensure stacked layout for complex grids */
@media (max-width: 900px) {

  [class*="-grid"],
  .grid {
    grid-template-columns: 1fr !important;
  }

  .header-shell,
  .footer-inner {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}


html {
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  background-attachment: fixed;
  min-height: 100vh;
}

body {
  margin: 0;
  font-family: inherit;
  color: #0b0b0b;
  color: var(--text-strong);
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  background-attachment: fixed;
  min-height: 100vh;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Performance optimizations */
  text-rendering: optimizeSpeed;
  -webkit-tap-highlight-color: transparent;
}

body.nav-open {
  overflow: hidden;
}

a {
  color: inherit;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
}

.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding-top: 80px;
}

@media (max-width: 640px) {
  .main-content {
    padding-top: 70px;
  }
}

.page {
  /* Full width background like footer */
  width: 100%;
  max-width: none;
  margin: 0;
  padding-bottom: 0;
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  background-attachment: fixed;
  min-height: calc(100vh - 80px);
}

/* Center content inside pages */
.page>section,
.page>div:not(.hero-block):not(.admin-dashboard-layout) {
  max-width: 1240px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 3vw;
  padding-right: 3vw;
}

.fibe-home {
  padding-top: 1.5rem;
  min-height: 100vh;
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  background-attachment: fixed;
  /* Override .page width to extend full width like footer */
  width: 100% !important;
  max-width: none !important;
  margin: 0 !important;
  padding-bottom: 0 !important;
  /* Remove bottom padding to eliminate gap with footer */
}

/* Container for centered content inside fibe-home */
.fibe-home>section,
.fibe-home>.hero-block {
  max-width: 1240px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 3vw;
  padding-right: 3vw;
}

.eyebrow {
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  font-size: 0.78rem;
  font-weight: 600;
  color: #000000;
  color: var(--primary-dark);
}

.primary-btn,
.ghost-btn {
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.75rem 1.75rem;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.3s ease;
}

.primary-btn {
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  color: #111111;
  color: var(--secondary);
  box-shadow: 0 20px 50px rgba(247, 189, 32, 0.25);
  box-shadow: var(--shadow-gold);
  text-decoration: none;
}

.primary-btn:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg,
      #faca3d 0%,
      #f7bd20 50%,
      #e8a91a 100%);
  background: var(--gradient-button-hover);
  box-shadow: 0 25px 60px rgba(246, 183, 9, 0.928);
}

.ghost-btn {
  background: transparent;
  color: #111111;
  color: var(--secondary);
  border: 2px solid rgba(247, 189, 32, 0.4);
  text-decoration: none;
}

.ghost-btn:hover {
  transform: translateY(-2px);
  background: rgba(247, 189, 32, 0.08);
  border-color: #000000;
  border-color: var(--primary);
}

.primary-link {
  color: #000000;
  color: var(--primary-dark);
  font-weight: 600;
  text-decoration: none;
}

.hero-block {
  margin-top: 2rem;
  padding: 3rem;
  border-radius: 40px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 26px 80px rgba(15, 23, 42, 0.12);
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
}

.hero-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 3rem;
  gap: 3rem;
  align-items: center;
}

.hero-content h1 {
  font-size: clamp(2.4rem, 4vw, 3.6rem);
  line-height: 1.1;
  margin: 0.4rem 0 1rem;
}

.hero-content h1 span {
  color: #000000;
  color: var(--primary-dark);
}

.hero-content p {
  font-size: 1.05rem;
  line-height: 1.7;
  color: #4a4a4a;
  color: var(--text-muted);
}

.hero-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 1.5rem 0;
}

.hero-form {
  background: rgba(255, 255, 255, 0.25);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  padding: 1.5rem;
  border-radius: 24px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.12);
}

.hero-form label {
  display: block;
  font-weight: 600;
  margin-bottom: 0.8rem;
}

.hero-form-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.hero-form input {
  flex: 1 1;
  min-width: 200px;
  border-radius: 16px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.9rem 1.1rem;
  font-size: 1rem;
}

.hero-form button {
  background: #111111;
  background: var(--secondary);
  color: #000000;
  color: var(--primary);
  border: 1px solid #000000;
  border: 1px solid var(--primary-dark);
  border-radius: 16px;
  padding: 0.9rem 1.5rem;
  font-weight: 600;
}

.form-success {
  margin: 0.75rem 0 0;
  font-size: 0.95rem;
  color: #0f9d58;
}

.hero-badges {
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  font-weight: 600;
  color: #4a4a4a;
  color: var(--text-muted);
}

.hero-visual {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.landing-carousel {
  position: relative;
  width: 100%;
  height: 450px;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.15);
}

.landing-carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}

.landing-carousel-slide.active {
  opacity: 1;
}

.landing-carousel-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 24px;
}

.landing-carousel-dots {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.landing-carousel-dots .dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  border: 2px solid rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.landing-carousel-dots .dot.active {
  background: #ffffff;
  width: 14px;
  height: 14px;
}

.landing-carousel-dots .dot:hover {
  background: rgba(255, 255, 255, 0.8);
  transform: scale(1.1);
}

.hero-insight {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 32px;
  padding: 1.75rem;
  box-shadow: 0 35px 65px rgba(15, 23, 42, 0.12);
  position: relative;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.hero-insight.primary {
  background: rgba(255, 255, 255, 0.15);
}

.hero-pill {
  display: inline-flex;
  padding: 0.35rem 0.9rem;
  border-radius: 999px;
  background: rgba(247, 189, 32, 0.18);
  color: #111111;
  color: var(--secondary);
  font-weight: 600;
  font-size: 0.9rem;
}

.hero-snapshot h3 {
  font-size: 2.2rem;
  margin: 0.4rem 0 1rem;
}

.hero-snapshot ul {
  list-style: none;
  padding: 0;
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.8;
}

.hero-note {
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.hero-mini-cards {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 1rem;
  gap: 1rem;
}

.hero-mini-cards div {
  background: rgba(255, 255, 255, 0.25);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.9rem 1.1rem;
  min-height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.hero-mini-cards span {
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 0.85rem;
}

.stats-bar {
  margin: 3rem 0;
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  border-radius: 24px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  text-align: center;
  padding: 1.5rem;
  grid-gap: 1rem;
  gap: 1rem;
}

.stats-bar strong {
  display: block;
  font-size: 1.8rem;
}

.section-block {
  margin: 4rem 0;
}

.section-heading {
  text-align: center;
  max-width: 760px;
  margin: 0 auto 3rem;
}

.section-heading h2 {
  margin: 0.75rem 0;
  font-size: clamp(2rem, 3vw, 2.8rem);
}

.section-heading p {
  color: #4a4a4a;
  color: var(--text-muted);
  margin: 0 auto;
  line-height: 1.7;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.product-card {
  background: linear-gradient(to right,
      #FFF9E6 0%,
      #FFE082 35%,
      #D4A017 100%);
  background: var(--gradient-card);
  border-radius: 24px;
  padding: 1.5rem;
  border: 1px solid transparent;
  text-decoration: none;
  color: inherit;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.3s ease;
  position: relative;
  overflow: hidden;
}

.product-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle at top right,
      rgba(247, 189, 32, 0.15) 0%,
      rgba(247, 189, 32, 0.05) 40%,
      rgba(247, 189, 32, 0) 70%);
  background: var(--gradient-glow);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.product-card img {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin-bottom: 1rem;
}

.product-card:hover {
  border-color: rgba(247, 189, 32, 0.4);
  transform: translateY(-4px);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.product-card:hover::before {
  opacity: 1;
}

.product-card p {
  color: #4a4a4a;
  color: var(--text-muted);
}

.steps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.steps-grid article {
  background: #fff;
  padding: 1.75rem;
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  position: relative;
}

.step-index {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(247, 189, 32, 0.18);
  color: #111111;
  color: var(--secondary);
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.calculator-block {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 2.5rem;
  gap: 2.5rem;
  align-items: flex-start;
}

.calculator-copy {
  background: #fff;
  border-radius: 28px;
  padding: 2rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.calculator-tools {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.tool-card {
  background: #fffdf5;
  background: var(--surface-soft);
  border-radius: 18px;
  padding: 1.25rem;
  text-decoration: none;
  color: inherit;
  border: 1px solid transparent;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.tool-card:hover {
  border-color: rgba(247, 189, 32, 0.45);
  transform: translateY(-3px);
}

.tool-card p {
  color: #4a4a4a;
  color: var(--text-muted);
}

.tool-card span {
  color: #000000;
  color: var(--primary-dark);
  font-weight: 600;
}

.calculator-widget .loan-calculator {
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.loan-calculator {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  padding: 2rem;
}

.loan-calculator__inputs {
  flex: 1.4 1;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  min-width: 260px;
}

.slider-field {
  padding: 1.25rem 1.5rem;
  border-radius: 22px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  background: #fffdf5;
  background: var(--surface-soft);
}

.slider-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.9rem;
}

.slider-heading label {
  font-weight: 600;
  font-size: 1rem;
}

.value-chip {
  background: #fff;
  border-radius: 12px;
  padding: 0.4rem 0.95rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  font-weight: 600;
  font-size: 0.95rem;
}

.slider-field input[type='range'] {
  width: 100%;
  accent-color: #000000;
  accent-color: var(--primary);
}

.range-extents {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #4a4a4a;
  color: var(--text-muted);
  margin-top: 0.35rem;
}

.loan-calculator__summary {
  flex: 1 1;
  min-width: 260px;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2rem;
  background: linear-gradient(180deg, #fffef7 0%, #fff8df 100%);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.emi-highlight {
  background: #111111;
  background: var(--secondary);
  border-radius: 20px;
  padding: 1.5rem;
  text-align: center;
  color: #000000;
  color: var(--primary);
}

.emi-highlight p {
  margin: 0 0 0.4rem;
  font-weight: 600;
  color: #ffffff;
  color: var(--surface);
}

.emi-highlight strong {
  font-size: 2rem;
  color: #000000;
  color: var(--primary);
}

.summary-grid {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.summary-row strong {
  font-size: 1.1rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.summary-row.total {
  border-top: 1px dashed rgba(17, 17, 17, 0.08);
  border-top: 1px dashed var(--border-soft);
  padding-top: 0.85rem;
  margin-top: 0.3rem;
  font-weight: 600;
  color: #0b0b0b;
  color: var(--text-strong);
}

.loan-calculator__summary .primary-btn {
  width: 100%;
  justify-content: center;
}

.card-footnote {
  font-size: 0.82rem;
  color: #4a4a4a;
  color: var(--text-muted);
  margin: 0;
}

/* Loan calculator - responsive tweaks */
@media (max-width: 900px) {
  .loan-calculator {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .loan-calculator__inputs,
  .loan-calculator__summary {
    min-width: auto;
    width: 100%;
    padding: 1rem;
  }

  .slider-field {
    padding: 0.9rem 1rem;
    border-radius: 14px;
  }

  .slider-heading label {
    font-size: 0.95rem;
  }

  .emi-highlight strong {
    font-size: 1.6rem;
  }

  .loan-calculator__summary {
    border-radius: 18px;
  }

  .loan-calculator__summary .primary-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .loan-calculator {
    padding: 0.75rem;
  }

  .slider-heading label {
    font-size: 0.9rem;
  }

  .emi-highlight strong {
    font-size: 1.4rem;
  }
}

.offerings-block {
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  border-radius: 34px;
  padding: 3rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.offering-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.offering-card {
  padding: 1.5rem;
  border-radius: 20px;
  background: #fffdf5;
  background: var(--surface-soft);
  border: 1px solid transparent;
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  transition: border-color 0.2s ease, transform 0.2s ease;
}

.offering-card img {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.offering-card:hover {
  border-color: rgba(247, 189, 32, 0.4);
  transform: translateY(-2px);
}

.offering-card span {
  display: inline-block;
  margin-top: 0.5rem;
  color: #000000;
  color: var(--primary-dark);
  font-weight: 600;
}

.why-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.why-grid article {
  padding: 1.75rem;
  border-radius: 24px;
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  min-height: 200px;
}

.awards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.awards-grid article {
  padding: 1.5rem;
  border-radius: 24px;
  background: #fffdf5;
  background: var(--surface-soft);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.why-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
  margin: 1rem 0 1.25rem;
}

.why-metrics div {
  background: linear-gradient(135deg, #fffdf5, #fff6d6);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 18px;
  padding: 1rem;
  text-align: center;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);
}

.why-metrics strong {
  display: block;
  font-size: 1.2rem;
}

.why-card {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.85rem;
  gap: 0.85rem;
  align-items: flex-start;
  padding: 1.5rem;
  border-radius: 24px;
  background: linear-gradient(135deg, #ffffff, #fff7da);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.why-icon {
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background: #fffdf5;
  background: var(--surface-soft);
  display: grid;
  place-items: center;
  font-size: 1.4rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.testimonials-block blockquote {
  background: #fff;
  padding: 2rem;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 260px;
}

.testimonial-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.testimonials-carousel {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}

.testimonials-carousel-track {
  position: relative;
  min-height: 280px;
}

.testimonial-card {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  transform: translateX(20px);
  transition: all 0.6s ease-in-out;
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 1.5rem;
  gap: 1.5rem;
  align-items: start;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.testimonial-card.active {
  opacity: 1;
  transform: translateX(0);
  position: relative;
}

.testimonials-carousel-dots {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 2rem;
}

.testimonials-carousel-dots .dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(247, 189, 32, 0.3);
  border: 2px solid rgba(247, 189, 32, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 0;
}

.testimonials-carousel-dots .dot.active {
  background: #000000;
  background: var(--primary-dark);
  border-color: #000000;
  border-color: var(--primary-dark);
  width: 14px;
  height: 14px;
  box-shadow: 0 4px 12px rgba(247, 189, 32, 0.4);
}

.testimonials-carousel-dots .dot:hover {
  background: rgba(247, 189, 32, 0.6);
  transform: scale(1.15);
}

.testimonial-avatar {
  width: 72px;
  height: 72px;
  border-radius: 14px;
  overflow: hidden;
  background: #fffdf5;
  background: var(--surface-soft);
  display: grid;
  place-items: center;
  flex-shrink: 0;
}

.testimonial-avatar.round {
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.8);
}

.testimonial-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.testimonial-text {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.testimonial-text p {
  margin: 0;
  font-size: 1.05rem;
  line-height: 1.6;
  color: #0b0b0b;
  color: var(--text-strong);
}

.testimonial-meta {
  display: grid;
  grid-gap: 0.25rem;
  gap: 0.25rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.testimonial-meta strong {
  color: #0b0b0b;
  color: var(--text-strong);
  font-size: 1rem;
}

.testimonial-meta span {
  font-size: 0.9rem;
}

.quote-tag {
  font-size: 0.85rem;
  font-weight: 700;
  color: #000000;
  color: var(--primary-dark);
  text-transform: uppercase;
}

blockquote p {
  margin: 0;
  color: #0b0b0b;
  color: var(--text-strong);
  line-height: 1.6;
}

blockquote cite {
  font-style: normal;
  color: #4a4a4a;
  color: var(--text-muted);
}

.download-block {
  margin-top: 5rem;
}

.download-card {
  padding: 3rem;
  border-radius: 36px;
  background: linear-gradient(120deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem;
}

.download-card .store-badge {
  border: 1px solid rgba(17, 17, 17, 0.12);
}

.store-badges {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
}

.store-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
}

.store-badge img {
  width: 140px;
  height: auto;
  display: block;
  border-radius: 8px;
}

.store-badge img {
  width: 135px;
  height: auto;
  display: block;
}

.hero-store-badges {
  margin-top: 1rem;
}

.download-card .store-badges {
  justify-content: flex-start;
}

/* Modern Homepage Styles */
.highlight-text {
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-visual {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.hero-stats-card {
  background: linear-gradient(135deg, #ffffff, #fff7da);
  border-radius: 24px;
  padding: 2rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  border: 1px solid rgba(247, 189, 32, 0.2);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.stat-item-hero {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 16px;
  border: 1px solid rgba(247, 189, 32, 0.15);
}

.stat-icon {
  font-size: 2rem;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  border-radius: 14px;
  box-shadow: 0 8px 20px rgba(247, 189, 32, 0.3);
}

.stat-item-hero strong {
  font-size: 1.8rem;
  color: #111111;
  color: var(--secondary);
  display: block;
  line-height: 1;
}

.stat-item-hero p {
  margin: 0.3rem 0 0;
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 0.9rem;
}

.hero-form-card {
  background: #fff;
  border-radius: 24px;
  padding: 2rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.hero-form-card h3 {
  margin: 0 0 0.5rem;
  font-size: 1.4rem;
  color: #111111;
  color: var(--secondary);
}

.hero-form-card>p {
  margin: 0 0 1.5rem;
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 0.95rem;
}

.store-badges-inline {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(17, 17, 17, 0.08);
  border-top: 1px solid var(--border-soft);
}

.store-badges-inline .store-badge img {
  width: 120px;
}

/* Why Choose Us Section */
.why-choose-section {
  background: linear-gradient(135deg, #fff7da, #ffffff);
  border-radius: 40px;
  padding: 3rem;
  box-shadow: 0 20px 60px rgba(17, 17, 17, 0.08);
}

.why-choose-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.why-card {
  background: #fff;
  padding: 2rem;
  border-radius: 20px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  display: flex;
  gap: 1rem;
  align-items: flex-start;
  transition: all 0.3s ease;
}

.why-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  border-color: rgba(247, 189, 32, 0.3);
}

.why-icon {
  font-size: 2.5rem;
  line-height: 1;
}

.why-card h3 {
  margin: 0 0 0.5rem;
  font-size: 1.1rem;
  color: #111111;
  color: var(--secondary);
}

.why-card p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 0.95rem;
  line-height: 1.5;
}

/* Modern Product Cards */
.product-card.modern {
  position: relative;
  overflow: hidden;
}

.product-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.product-badge {
  display: inline-block;
  padding: 0.35rem 0.85rem;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  color: #111111;
  color: var(--secondary);
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 700;
  width: -webkit-fit-content;
  width: fit-content;
}

.product-arrow {
  color: #000000;
  color: var(--primary-dark);
  font-weight: 600;
  font-size: 0.95rem;
}

.product-card.modern:hover .product-arrow {
  transform: translateX(4px);
  display: inline-block;
  transition: transform 0.3s ease;
}

/* CTA Section */
.cta-section {
  margin: 4rem 0 2rem;
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  border-radius: 40px;
  padding: 4rem 3rem;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.cta-section::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -20%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(247, 189, 32, 0.15) 0%, transparent 70%);
  border-radius: 50%;
}

.cta-section::after {
  content: '';
  position: absolute;
  bottom: -40%;
  right: -15%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(255, 193, 7, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.cta-content {
  position: relative;
  z-index: 1;
  max-width: 700px;
  margin: 0 auto;
}

.cta-section h2 {
  color: #000000 !important;
  font-size: clamp(2rem, 4vw, 3rem);
  margin: 0 0 1rem;
  font-weight: 800;
}

.cta-section p {
  color: #000000 !important;
  font-size: 1.2rem;
  margin: 0 0 2rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-section .primary-btn,
.cta-section .ghost-btn {
  color: #000000 !important;
}

.primary-btn.large,
.ghost-btn.large {
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  color: #000000 !important;
}

.ghost-btn.large {
  background: rgba(255, 255, 255, 0.15);
  color: #000000 !important;
  border-color: rgba(0, 0, 0, 0.3);
}

.ghost-btn.large:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: #000000;
  color: #000000 !important;
}



.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.blog-grid article {
  background: #fff;
  border-radius: 24px;
  padding: 1.75rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.blog-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.blog-grid h3 {
  margin: 0;
}

.blogs-page {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 3rem;
}

.blogs-hero {
  background:
    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.18), transparent 50%),
    radial-gradient(circle at 90% 10% 0%, rgba(232, 169, 26, 0.18), transparent 50%),
    linear-gradient(120deg, #ffffff, #fff8e0);
  color: #111111;
  color: var(--secondary);
  border-radius: 32px;
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
  align-items: start;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.blogs-hero__copy {
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.blogs-hero__copy p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.6;
}

.blogs-hero__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.blogs-hero__meta span {
  border-radius: 999px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.35rem 0.75rem;
  background: #ffffff;
  background: var(--surface);
  font-weight: 700;
  font-size: 0.9rem;
}

.blogs-filters {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
}

.blogs-filters button {
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  background: rgba(0, 0, 0, 0.02);
  color: #111111;
  color: var(--secondary);
  border-radius: 999px;
  padding: 0.45rem 0.9rem;
  cursor: pointer;
  font-weight: 700;
}

.blogs-filters button.selected {
  background: linear-gradient(135deg, #000000, #000000);
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  border-color: transparent;
  color: #111111;
  color: var(--secondary);
  box-shadow: 0 12px 26px rgba(17, 17, 17, 0.12);
}

.blogs-featured {
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 22px;
  padding: 1.4rem;
  display: grid;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.blogs-featured__badge {
  align-self: flex-start;
  padding: 0.35rem 0.8rem;
  background: linear-gradient(135deg, #000000, #000000);
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: #111111;
  color: var(--secondary);
  border-radius: 12px;
  font-weight: 800;
  width: -webkit-fit-content;
  width: fit-content;
}

.blogs-featured h2 {
  margin: 0.25rem 0 0.25rem;
}

.blog-meta-row {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  color: #4a4a4a;
  color: var(--text-muted);
  font-weight: 700;
}

.blogs-featured .ghost-btn {
  justify-self: flex-start;
}

.blogs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.blog-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
  display: grid;
  grid-gap: 0.5rem;
  gap: 0.5rem;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.blog-card__badge {
  display: inline-flex;
  padding: 0.35rem 0.75rem;
  border-radius: 12px;
  background: #fffdf5;
  background: var(--surface-soft);
  font-weight: 800;
  color: #111111;
  color: var(--secondary);
  width: -webkit-fit-content;
  width: fit-content;
}

.blog-card h3 {
  margin: 0;
}

.blog-card p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.blog-card .blog-meta-row {
  color: #4a4a4a;
  color: var(--text-muted);
}

.calculator-page {
  padding-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.calculator-hero {
  background: linear-gradient(135deg, #f7f3ff, #e9ffff, #fff2e1);
  border-radius: 36px;
  padding: 2.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.calculator-hero.enhanced {
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  background: radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.18), transparent 50%),
    radial-gradient(circle at 80% 20% 0%, rgba(232, 169, 26, 0.12), transparent 45%),
    linear-gradient(120deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  position: relative;
  overflow: hidden;
}

.calculator-hero.enhanced::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 0%, rgba(255, 255, 255, 0.08) 0%, transparent 55%);
  pointer-events: none;
}

.calc-hero-copy {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.calc-hero-copy h1 {
  margin: 0.25rem 0;
}

.calc-hero-copy p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.6;
}

.calc-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  margin-top: 0.5rem;
}

.calc-chip {
  display: inline-flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.65rem 0.9rem;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  min-width: 150px;
}

.calc-chip strong {
  font-size: 1.1rem;
}

.calc-chip small {
  color: rgba(255, 255, 255, 0.78);
}

.calc-hero-panel {
  position: relative;
  z-index: 1;
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 22px;
  padding: 1.5rem;
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.calc-hero-stat p {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 700;
  color: #4a4a4a;
  color: var(--text-muted);
}

.calc-hero-stat strong {
  display: block;
  font-size: 1.4rem;
}

.calc-hero-stat span {
  color: #4a4a4a;
  color: var(--text-muted);
}

.calc-hero-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-gap: 0.6rem;
  gap: 0.6rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.calc-hero-cta {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.support-page {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding-top: 3rem;
}

.contact-stack {
  background: linear-gradient(135deg, #ffffff, #fff8df);
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
  align-items: start;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.contact-stack__left,
.contact-stack__right {
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
}

.contact-stack-head h2 {
  margin: 0.25rem 0 0.3rem;
}

.contact-stack-lead {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.contact-assurance {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.contact-assurance span {
  border-radius: 14px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.55rem 0.85rem;
  background: #fff;
  font-weight: 700;
  display: inline-flex;
  flex-direction: column;
  gap: 0.1rem;
}

.contact-hero {
  background:
    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.2), transparent 45%),
    radial-gradient(circle at 80% 20% 0%, rgba(17, 17, 17, 0.12), transparent 55%),
    linear-gradient(120deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  border-radius: 36px;
  padding: 2.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
  align-items: center;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  position: relative;
  overflow: hidden;
}

.contact-hero-copy h1 {
  margin: 0.2rem 0 0.4rem;
}

.contact-hero-copy p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.6;
}

.contact-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 1rem 0 0.5rem;
}

.contact-badges span {
  border-radius: 14px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  background: #ffffff;
  background: var(--surface);
  padding: 0.6rem 0.85rem;
  display: inline-flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 130px;
}

.contact-badges strong {
  font-size: 1.05rem;
}

.contact-badges small {
  color: #4a4a4a;
  color: var(--text-muted);
}

.contact-quick {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-top: 1rem;
}

.contact-hero-visual {
  position: relative;
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
  justify-items: center;
}

.contact-hero-card {
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 22px;
  padding: 1.4rem;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.contact-hero-card h3 {
  margin: 0.3rem 0 0.35rem;
}

.contact-hero-note {
  margin: 0 0 0.65rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.support-highlight-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.support-highlight-card {
  background: linear-gradient(135deg, #ffffff, #f5f8ff);
  border-radius: 20px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.2rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.75rem;
  gap: 0.75rem;
  align-items: center;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.support-info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.support-info-card {
  border-radius: 22px;
  padding: 1.4rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.8rem;
  gap: 0.8rem;
  align-items: start;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  color: #111111;
  color: var(--secondary);
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff, #fff7da);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.support-info-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 15% 15% 0%, rgba(255, 255, 255, 0.12), transparent 55%);
  pointer-events: none;
}

.support-info-card.blue {
  background: linear-gradient(135deg, #ffffff, #fff7da);
}

.support-info-card.teal {
  background: linear-gradient(135deg, #ffffff, #fff7da);
}

.support-info-card.amber {
  background: linear-gradient(135deg, #ffffff, #fff7da);
}

.support-info-card ul {
  margin: 0.2rem 0 0;
  padding-left: 1.1rem;
  color: #4a4a4a;
  color: var(--text-muted);
  display: grid;
  grid-gap: 0.35rem;
  gap: 0.35rem;
}

.support-info-card h3 {
  margin: 0;
}

.support-faqs {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
}

.faq-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.faq-card {
  background: #fffdf5;
  background: var(--surface-soft);
  border-radius: 16px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.9rem 1rem;
}

.faq-card summary {
  cursor: pointer;
  font-weight: 700;
}

.faq-card p {
  margin: 0.5rem 0 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.calculator-hero.eligibility-hero {
  background:
    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.2), transparent 50%),
    radial-gradient(circle at 80% 20% 0%, rgba(232, 169, 26, 0.16), transparent 55%),
    linear-gradient(120deg, #ffffff, #fff8e0);
  color: #111111;
  color: var(--secondary);
  position: relative;
  overflow: hidden;
}

.calculator-hero.credit-hero {
  background:
    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.2), transparent 55%),
    radial-gradient(circle at 80% 20% 0%, rgba(17, 17, 17, 0.12), transparent 55%),
    linear-gradient(120deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  position: relative;
  overflow: hidden;
}

.eligibility-hero-card {
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 22px;
  padding: 1.5rem;
  display: grid;
  grid-gap: 0.65rem;
  gap: 0.65rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  position: relative;
  overflow: hidden;
}

.eligibility-hero-card h3 {
  margin: 0.2rem 0 0.1rem;
}

.credit-hero-card {
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 22px;
  padding: 1.5rem;
  display: grid;
  grid-gap: 0.65rem;
  gap: 0.65rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  position: relative;
  overflow: hidden;
}

.credit-hero-card h3 {
  margin: 0.2rem 0 0.1rem;
}

.doodle-bubbles {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.bubble.mini {
  position: absolute;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(247, 189, 32, 0.26), transparent 70%);
  top: 12%;
  right: 18%;
}

.sparkle {
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(17, 17, 17, 0.12), transparent 65%);
  bottom: 10%;
  left: 10%;
}

.calculator-hero.two-wheeler-hero {
  background:
    radial-gradient(circle at 0% 0%, rgba(247, 189, 32, 0.22) 0%, transparent 45%),
    radial-gradient(circle at 80% 20%, rgba(17, 17, 17, 0.12) 0%, transparent 50%),
    linear-gradient(120deg, #ffffff, #fff8df);
  color: #111111;
  color: var(--secondary);
  overflow: hidden;
  position: relative;
}

.two-wheeler-hero-visual {
  position: relative;
  min-height: 260px;
  display: grid;
  place-items: center;
}

.two-wheeler-hero-card {
  background: rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 24px;
  padding: 1.6rem;
  width: 100%;
  max-width: 360px;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  position: relative;
  z-index: 1;
}

.two-wheeler-hero-card h3 {
  margin: 0.35rem 0 0.25rem;
}

.calc-hero-note {
  margin: 0 0 0.75rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.hero-mini-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  grid-gap: 0.5rem;
  gap: 0.5rem;
}

.hero-mini-stats div {
  background: rgba(0, 0, 0, 0.04);
  border-radius: 14px;
  padding: 0.7rem 0.9rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  text-align: center;
}

.doodle-bubble {
  position: absolute;
  border-radius: 50%;
  filter: blur(0);
  z-index: 0;
}

.bubble-a {
  width: 160px;
  height: 160px;
  background: radial-gradient(circle, rgba(247, 189, 32, 0.26), transparent 70%);
  top: 10%;
  right: 12%;
}

.bubble-b {
  width: 220px;
  height: 220px;
  background: radial-gradient(circle, rgba(17, 17, 17, 0.12), transparent 70%);
  bottom: 5%;
  left: 5%;
}

.hero-facts {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.hero-facts li {
  background: #fff;
  border-radius: 20px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.hero-facts.compact {
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
}

.calculator-body {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(220px, 1fr);
  grid-gap: 2rem;
  gap: 2rem;
}

.calculator-body.modern {
  background: #fff;
  border-radius: 32px;
  padding: 1.5rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  align-items: start;
}

.calculator-main-card {
  background: linear-gradient(180deg, #ffffff 0%, #f7f9ff 100%);
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
}

.calculator-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 1rem;
  align-items: flex-start;
}

.calculator-subhead {
  margin: 0.35rem 0 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.calculator-meta-tags {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.calculator-meta-tags span {
  border-radius: 999px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.35rem 0.75rem;
  background: #fff;
  font-weight: 700;
  font-size: 0.9rem;
}

.calculator-aside {
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
}

.calculator-body.stacked {
  grid-template-columns: 1fr;
}

.calc-side-card {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.calc-side-card ul,
.calc-side-card ol {
  margin: 0;
  padding-left: 1.2rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.calc-side-card .note {
  margin: 0;
  font-size: 0.9rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.calculator-visual-shell {
  background: #fff;
  border-radius: 28px;
  padding: 1.25rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
  position: relative;
}

.calculator-carousel {
  overflow: hidden;
  border-radius: 22px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  background: #fffdf5;
  background: var(--surface-soft);
  position: relative;
}

.calculator-carousel__track {
  display: flex;
  transition: transform 0.4s ease;
}

.calculator-carousel__slide {
  min-width: 100%;
}

.calculator-carousel__slide img {
  width: 100%;
  display: block;
}

.compact-carousel .calculator-carousel {
  max-height: 360px;
}

.compact-carousel .calculator-carousel__slide img {
  max-height: 320px;
  object-fit: cover;
}

.calculator-carousel__dots {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.9);
}

.calculator-carousel__dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
}

.calculator-carousel__dot.is-active {
  background: #111111;
  background: var(--secondary);
  border-color: #111111;
  border-color: var(--secondary);
  transform: scale(1.05);
}

.carousel-tags {
  display: flex;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.carousel-tags span {
  border-radius: 999px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.35rem 0.8rem;
  background: #fffdf5;
  background: var(--surface-soft);
  font-weight: 700;
  font-size: 0.9rem;
}

.carousel-doodle .doodle-dot,
.carousel-doodle .doodle-line {
  position: absolute;
  display: inline-block;
  background: linear-gradient(135deg, rgba(247, 189, 32, 0.28), rgba(17, 17, 17, 0.12));
  filter: blur(0);
  opacity: 0.8;
}

.carousel-doodle .doodle-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  top: 6%;
  right: 10%;
}

.carousel-doodle .doodle-line {
  width: 120px;
  height: 10px;
  border-radius: 999px;
  bottom: 8%;
  left: 6%;
}

.calc-side-card.tinted {
  background: linear-gradient(180deg, #fffdf5, #fff);
}

.calc-side-card.compact ul {
  padding-left: 1.1rem;
  margin: 0;
  display: grid;
  grid-gap: 0.35rem;
  gap: 0.35rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.calc-bullet-list {
  list-style: disc;
}

.calc-side-card ol {
  display: grid;
  grid-gap: 0.6rem;
  gap: 0.6rem;
  padding-left: 1.2rem;
}

.calc-side-card ol strong {
  display: block;
}

.calc-grid-section {
  display: grid;
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.calc-scenario-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.calc-scenario-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.calc-scenario-card h3 {
  margin: 0.35rem 0;
}

.calc-scenario-card p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.calc-scenario-card .ghost-btn {
  width: -webkit-fit-content;
  width: fit-content;
}

.calc-scenario-kicker {
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.85rem;
  font-weight: 700;
  color: #000000;
  color: var(--primary-dark);
  margin: 0;
}

.apply-page {
  padding-top: 4rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
}

.apply-hero {
  background: linear-gradient(120deg, #f7f3ff, #fff2e1);
  border-radius: 36px;
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.apply-highlights {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.apply-highlights div {
  background: #fff;
  padding: 1rem;
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.apply-highlights span {
  display: block;
  font-size: 0.85rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.apply-highlights strong {
  font-size: 1.2rem;
}

.apply-content {
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(260px, 1fr);
  grid-gap: 2rem;
  gap: 2rem;
}

.apply-form {
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.form-grid label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-weight: 600;
}

.form-grid input,
.form-grid select {
  border-radius: 14px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
}

.slider-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.slider-grid>div {
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 20px;
  padding: 1rem 1.25rem;
  background: #fffdf5;
  background: var(--surface-soft);
}

.slider-heading {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.slider-grid input[type='range'] {
  width: 100%;
  accent-color: #000000;
  accent-color: var(--primary);
}

.apply-form .primary-btn {
  width: max(240px, 40%);
}

.form-note {
  font-size: 0.9rem;
  color: #4a4a4a;
  color: var(--text-muted);
  margin: 0;
}

.form-note.success {
  color: #0f9d58;
  font-weight: 600;
}

.apply-summary {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.summary-card,
.contact-card {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.75rem;
}

.summary-card h2 {
  margin-top: 0;
}

.summary-card div {
  display: flex;
  justify-content: space-between;
  margin-top: 0.75rem;
  font-size: 0.95rem;
}

.summary-card div strong {
  color: #0b0b0b;
  color: var(--text-strong);
}

.contact-card a {
  display: block;
  color: #111111;
  color: var(--secondary);
  font-weight: 600;
  text-decoration: none;
  margin-top: 0.35rem;
}

.company-overview {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.company-card {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2rem;
}

.fact-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.fact-grid div {
  border-radius: 20px;
  border: 1px dashed rgba(17, 17, 17, 0.08);
  border: 1px dashed var(--border-soft);
  padding: 1rem 1.25rem;
  background: #fffdf5;
  background: var(--surface-soft);
}

.mission-list {
  list-style: disc;
  padding-left: 1.2rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.office-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.contact-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.contact-strip div {
  flex: 1 1;
  min-width: 200px;
  border-radius: 20px;
  padding: 1rem 1.25rem;
  background: linear-gradient(135deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
}

.contact-channel-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.contact-channel {
  border-radius: 22px;
  padding: 1.25rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.8rem;
  gap: 0.8rem;
  align-items: start;
  position: relative;
  overflow: hidden;
  color: #111111;
  color: var(--secondary);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.contact-channel::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 10% 10% 0%, rgba(255, 255, 255, 0.12), transparent 55%);
  pointer-events: none;
}

.contact-channel:nth-child(1) {
  background: linear-gradient(135deg, #ffffff, #fff7da);
}

.contact-channel:nth-child(2) {
  background: linear-gradient(135deg, #ffffff, #fff7da);
}

.contact-channel:nth-child(3) {
  background: linear-gradient(135deg, #ffffff, #fff7da);
}

.contact-icon {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.16);
  display: grid;
  place-items: center;
  font-size: 1.35rem;
}

.contact-channel h3 {
  margin: 0;
}

.contact-channel p {
  margin: 0.35rem 0 0.5rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.contact-channel .primary-link {
  color: #000000;
  color: var(--primary-dark);
  font-weight: 700;
}

.careers-page,
.newsroom-page {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding-top: 3rem;
}

.benefit-card {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
}

.roles-section .roles-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.role-card {
  background: #fff;
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.tag-row {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.tag-row span {
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  background: #fffdf5;
  background: var(--surface-soft);
  font-size: 0.85rem;
}

.roles-section .ghost-btn {
  align-self: flex-start;
}

.career-form-card {
  margin-top: 1.5rem;
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.career-form {
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
}

.career-form .form-grid label,
.career-message {
  font-weight: 600;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.career-form input,
.career-form textarea {
  border-radius: 14px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.75rem 0.95rem;
  font-size: 0.95rem;
  font-family: inherit;
  background: #ffffff;
  background: var(--surface);
}

.career-form input[type='file'] {
  padding: 0.6rem;
}

.career-form textarea {
  resize: vertical;
}

.section-note {
  text-align: center;
  color: #4a4a4a;
  color: var(--text-muted);
  margin-top: 1rem;
}

.newsroom-page .press-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.press-card {
  background: #fff;
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.media-kit {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.tag-row.wrap {
  flex-wrap: wrap;
}

.timeline-section {
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2.5rem;
}

.timeline-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
  margin-top: 1.5rem;
}

.timeline-grid article {
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
  background: #fffdf5;
  background: var(--surface-soft);
}

.testimonials-section .testimonial-grid.wide {
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.contact-cta {
  background: linear-gradient(135deg, #ffffff, #fff7da);
  border-radius: 32px;
  padding: 2.5rem;
  color: #111111;
  color: var(--secondary);
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  align-items: center;
  justify-content: space-between;
}

.contact-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.contact-cta .ghost-btn {
  border-color: rgba(247, 189, 32, 0.5);
  color: #111111;
  color: var(--secondary);
}

.contact-form-shell {
  background: linear-gradient(135deg, #f5f7ff, #fff7ef);
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.contact-form-card {
  background: linear-gradient(180deg, #ffffff 0%, #f7f9ff 100%);
  border-radius: 26px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
}

.contact-form-card h2 {
  margin: 0.35rem 0 0.75rem;
}

.contact-form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 0.9rem 1rem;
  gap: 0.9rem 1rem;
}

.contact-form-grid label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-weight: 600;
}

.contact-form-grid input,
.contact-form-grid select,
.contact-form-grid textarea {
  border-radius: 14px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.75rem 0.95rem;
  font-size: 0.95rem;
  font-family: inherit;
}

.contact-form-grid textarea {
  resize: vertical;
}

.contact-form-grid .span-2 {
  grid-column: 1 / -1;
}

.contact-info-card {
  background: linear-gradient(135deg, #ffffff, #fff7da);
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
  display: grid;
  grid-gap: 0.8rem;
  gap: 0.8rem;
  color: #111111;
  color: var(--secondary);
}

.contact-info-card ul {
  margin: 0;
  padding-left: 1.15rem;
  color: #4a4a4a;
  color: var(--text-muted);
  display: grid;
  grid-gap: 0.35rem;
  gap: 0.35rem;
}

.contact-quick-links {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  align-items: center;
}

.contact-info-card .ghost-btn,
.support-cta-band .ghost-btn {
  border-color: rgba(247, 189, 32, 0.5);
  color: #111111;
  color: var(--secondary);
}

.contact-info-card .primary-link {
  color: #000000;
  color: var(--primary-dark);
  font-weight: 700;
}

.support-cta-band {
  background: linear-gradient(120deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  border-radius: 28px;
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
  align-items: center;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.support-cta-band p {
  margin: 0.4rem 0 0.75rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.support-cta-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.support-info-cards+.branch-locator {
  margin-top: 1rem;
}

.branch-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.branch-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.1rem;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
  display: grid;
  grid-gap: 0.4rem;
  gap: 0.4rem;
}

.branch-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.8rem;
  border-radius: 999px;
  background: #fffdf5;
  background: var(--surface-soft);
  font-weight: 700;
}

.policy-card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.policy-card {
  background: linear-gradient(135deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  border-radius: 20px;
  padding: 1.2rem;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.policy-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20% 0%, rgba(255, 255, 255, 0.1), transparent 55%);
  pointer-events: none;
}

.policy-card h3 {
  margin: 0.35rem 0 0.25rem;
}

.policy-card p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.policy-tag {
  display: inline-flex;
  padding: 0.3rem 0.75rem;
  border-radius: 12px;
  background: rgba(247, 189, 32, 0.16);
  border: 1px solid rgba(17, 17, 17, 0.08);
  font-weight: 700;
  font-size: 0.85rem;
}

.support-timeline {
  background: linear-gradient(135deg, #f7f9ff, #fff8ef);
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.75rem;
  display: grid;
  grid-gap: 1.1rem;
  gap: 1.1rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.timeline-head h2 {
  margin: 0.35rem 0 0.25rem;
}

.timeline-flow {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
  position: relative;
}

.timeline-node {
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.1rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.8rem;
  gap: 0.8rem;
  align-items: start;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
}

.timeline-connector {
  display: none;
}

.timeline-node h3 {
  margin: 0 0 0.35rem;
}

.timeline-node p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.timeline-node .step-number {
  background: #000000;
  background: var(--primary);
  color: #111111;
  color: var(--secondary);
  border-radius: 12px;
  width: 42px;
  height: 42px;
  display: grid;
  place-items: center;
  font-weight: 800;
  box-shadow: 0 12px 28px rgba(247, 189, 32, 0.35);
}

@media (min-width: 900px) {
  .timeline-flow {
    grid-template-columns: repeat(3, 1fr);
  }

  .timeline-connector {
    display: block;
    height: 2px;
    background: linear-gradient(90deg, rgba(6, 148, 254, 0.25), rgba(246, 130, 31, 0.25));
    align-self: center;
  }
}

.eligibility-calculator {
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.eligibility-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.eligibility-grid label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-weight: 600;
}

.eligibility-grid input[type='number'],
.eligibility-grid input[type='date'],
.eligibility-grid input[type='text'] {
  border-radius: 14px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.75rem 1rem;
  font-size: 0.95rem;
}

.eligibility-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
  background: #fffdf5;
  background: var(--surface-soft);
  border-radius: 24px;
  padding: 1.5rem;
}

.eligibility-summary div {
  background: #fff;
  border-radius: 20px;
  padding: 1rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.eligibility-summary p {
  grid-column: 1 / -1;
  margin: 0;
  font-size: 0.9rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.credit-score-widget {
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
}

.credit-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.credit-form label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  font-weight: 600;
}

.credit-form input {
  border-radius: 14px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.75rem 1rem;
}

.credit-form button {
  grid-column: 1 / -1;
  width: -webkit-fit-content;
  width: fit-content;
}

.credit-score-result {
  background: linear-gradient(165deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  border-radius: 28px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
}

.score-circle {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 6px solid rgba(247, 189, 32, 0.45);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
}

.score-circle span {
  font-size: 1rem;
}

.success-banner {
  background: rgba(247, 189, 32, 0.2);
  border-radius: 999px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
}


.info-page {
  padding-top: 3rem;
}

.info-hero {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 2.5rem;
  gap: 2.5rem;
  align-items: stretch;
  margin-bottom: 2.5rem;
}

.info-copy {
  border-radius: 32px;
  padding: 2.5rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  background: #fff;
}

.info-hero-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #fff4e7 0%, #eef4ff 100%);
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.12);
}

.info-hero-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20% 0%, rgba(246, 130, 31, 0.16), transparent 50%);
  pointer-events: none;
}

.info-hero-card h1 {
  margin: 0.35rem 0 0.75rem;
}

.info-hero-card p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.7;
}

.info-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.9rem;
  border-radius: 999px;
  background: rgba(6, 148, 254, 0.1);
  color: #111111;
  color: var(--secondary);
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.info-highlight-chips {
  margin-top: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.info-highlight-chips span {
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 999px;
  padding: 0.55rem 0.95rem;
  font-weight: 700;
  color: #0b0b0b;
  color: var(--text-strong);
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);
}

.info-speed-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  grid-gap: 0.6rem;
  gap: 0.6rem;
  margin-top: 1rem;
}

.info-speed-row div {
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 14px;
  padding: 0.65rem 0.9rem;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.info-speed-row strong {
  display: block;
  font-size: 1.05rem;
}

.info-speed-row span {
  color: #4a4a4a;
  color: var(--text-muted);
  font-weight: 600;
}

.info-helper {
  margin: 0.9rem 0 0;
  color: #4a4a4a;
  color: var(--text-muted);
  font-weight: 600;
}

.info-cta {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin: 1.5rem 0;
}

.info-visual {
  display: flex;
}

.info-hero-visual {
  position: relative;
}

.info-visual-card {
  background: linear-gradient(145deg, #ffffff, #fff7da);
  border-radius: 28px;
  padding: 1.75rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  position: relative;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
}

.info-visual-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  pointer-events: none;
}

.info-visual img {
  width: 100%;
  max-width: 320px;
  display: block;
  margin: 0 auto;
  filter: drop-shadow(0 18px 35px rgba(0, 0, 0, 0.25));
}

.info-hero.theme-cash .info-hero-card {
  background: linear-gradient(135deg, #fffdf5, #fff7da);
  border: 1px solid rgba(247, 189, 32, 0.35);
}

.info-hero.theme-cash .info-visual-card {
  background: linear-gradient(145deg, #ffffff, #fff7da);
  border-color: rgba(17, 17, 17, 0.08);
  border-color: var(--border-soft);
}

.info-hero.theme-cash .info-speed-row div {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(247, 189, 32, 0.35);
}

.info-visual-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
  grid-gap: 0.75rem;
  gap: 0.75rem;
  width: 100%;
}

.info-visual-stats div {
  background: #ffffff;
  background: var(--surface);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 16px;
  padding: 0.9rem 1rem;
  text-align: center;
  color: #111111;
  color: var(--secondary);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.info-visual-stats strong {
  display: block;
  color: #111111;
  color: var(--secondary);
  font-size: 1.4rem;
}

.info-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
  background: linear-gradient(135deg, #f7f9ff, #fff7ef);
  border-radius: 24px;
  padding: 1.5rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.info-stats div {
  text-align: center;
}

.info-stats strong {
  display: block;
  font-size: 1.6rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.info-section {
  margin: 2.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.info-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.info-action-card {
  background: linear-gradient(135deg, #ffffff, #f7f9ff);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 18px;
  padding: 1.1rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.75rem;
  gap: 0.75rem;
  align-items: start;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);
}

.info-action-icon {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: #fffdf5;
  background: var(--surface-soft);
  display: grid;
  place-items: center;
  font-size: 1.2rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.info-value-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.info-value-card {
  background: #fff;
  border-radius: 22px;
  padding: 1.5rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.info-value-index {
  font-size: 0.85rem;
  letter-spacing: 0.08em;
  color: #111111;
  color: var(--secondary);
  font-weight: 800;
}

.info-value-card h3 {
  margin: 0;
}

.info-value-card p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.info-step-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.info-step {
  background: linear-gradient(180deg, #ffffff 0%, #f6fbff 100%);
  border-radius: 20px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);
  padding: 1.3rem 1.4rem;
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.info-step-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #000000;
  background: var(--primary);
  color: #111111;
  color: var(--secondary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  box-shadow: 0 10px 20px rgba(247, 189, 32, 0.35);
}

.info-step h3 {
  margin: 0 0 0.35rem;
}

.info-step p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.info-guardrail {
  background: linear-gradient(135deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  border-radius: 26px;
  padding: 1.75rem;
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.info-guardrail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.info-guardrail-item {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  padding: 0.85rem 1rem;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.info-bullet-dot {
  width: 12px;
  height: 12px;
  background: linear-gradient(135deg, #000000, #000000);
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  border-radius: 50%;
  display: inline-flex;
  margin-top: 0.2rem;
  flex-shrink: 0;
}

.info-guardrail-item strong {
  display: block;
  margin-bottom: 0.25rem;
}

.info-guardrail-item p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.info-faq .faq-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.faq-grid details {
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1rem 1.15rem;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.faq-grid summary {
  cursor: pointer;
  font-weight: 700;
}

.faq-grid p {
  margin: 0.6rem 0 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.site-footer {
  margin-top: 0;
  /* Remove gap above footer */
  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);
  color: #0b0b0b;
  color: var(--text-strong, #0b0b0b);
  padding: clamp(3rem, 8vw, 4.5rem) clamp(1.5rem, 8vw, 5rem);
  position: relative;
  overflow: hidden;
}

.site-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
}

.footer-inner {
  display: flex;
  flex-direction: column;
  gap: clamp(1.5rem, 3vw, 2.75rem);
  align-items: stretch;
  position: relative;
  z-index: 1;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  gap: clamp(1.25rem, 2.5vw, 3rem);
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(17, 17, 17, 0.12);
}

.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.footer-brand .brand {
  font-size: 1.35rem;
}

.footer-brand img {
  height: 100px;
  width: auto;
  max-width: 200px;
  object-fit: contain;
  transform: scale(1.1);
  transform-origin: left center;
}

.footer-brand p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted, #4a4a4a);
  line-height: 1.6;
}

.footer-brand,
.footer-links,
.footer-visit {
  flex: 1 1 240px;
}

.footer-social {
  display: flex;
  gap: 0.6rem;
}

.footer-social a {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(247, 189, 32, 0.1);
  border: 1px solid rgba(247, 189, 32, 0.3);
  transition: transform 0.2s ease, background 0.2s ease;
  text-decoration: none;
  font-size: 1.1rem;
}

.footer-social img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.footer-social a:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  grid-gap: 1rem 1.5rem;
  gap: 1rem 1.5rem;
}

.footer-links-column {
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
}

.footer-links-title {
  margin: 0;
  letter-spacing: 0.12em;
  font-size: 0.85rem;
  text-transform: uppercase;
  color: #111111;
  color: var(--secondary, #111);
  font-weight: 700;
}

.footer-links-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.footer-link {
  font-weight: 500;
  font-size: 0.95rem;
  color: #4a4a4a;
  color: var(--text-muted, #4a4a4a);
  padding: 0.2rem 0;
  transition: color 0.2s ease;
  text-decoration: none;
}

.footer-link:hover,
.footer-link.active {
  color: #000000;
  color: var(--primary-dark, #e8a91a);
}

.footer-map {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(247, 189, 32, 0.2);
  min-height: 320px;
  height: clamp(280px, 35vw, 360px);
  width: 100%;
}

.footer-visit {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.footer-visit h3 {
  margin: 0;
  font-size: 1.6rem;
  color: #111111;
  color: var(--secondary, #111);
}

.footer-visit p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted, #4a4a4a);
}

.footer-address-secondary {
  margin-top: 1.25rem !important;
  padding-top: 1.25rem;
  border-top: 1px solid rgba(247, 189, 32, 0.2);
}

.footer-map iframe {
  width: 100%;
  height: 100%;
  min-height: 320px;
  border: 0;
  display: block;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-weight: 600;
  color: #111111;
  color: var(--secondary, #111);
}

.footer-cta {
  margin-top: 0.75rem;
  align-self: flex-start;
  padding: 0.65rem 1.6rem;
  border-radius: 999px;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  color: #111111;
  color: var(--secondary, #111);
  font-weight: 700;
  box-shadow: 0 16px 36px rgba(247, 189, 32, 0.35);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  text-decoration: none;
}

.footer-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 22px 44px rgba(247, 189, 32, 0.45);
}

.footer-bottom {
  margin-top: clamp(2rem, 5vw, 2.75rem);
  padding-top: 1.5rem;
  border-top: 1px solid rgba(17, 17, 17, 0.1);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  color: #4a4a4a;
  color: var(--text-muted, #4a4a4a);
  position: relative;
  z-index: 1;
}

.footer-bottom-links {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.footer-bottom-links a {
  color: #4a4a4a;
  color: var(--text-muted, #4a4a4a);
  font-size: 0.9rem;
  transition: color 0.2s ease;
  text-decoration: none;
}

.footer-bottom-links a:hover {
  color: #000000;
  color: var(--primary-dark, #e8a91a);
}

/* Responsive */
@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
  }

  .footer-brand,
  .footer-links,
  .footer-visit {
    flex: 1 1 100%;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}


.solutions-page {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 2.5rem;
}

.solutions-hero {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
  align-items: center;
  padding: 2.5rem;
  border-radius: 28px;
  background:
    radial-gradient(circle at 10% 10% 0%, rgba(245, 180, 0, 0.22), transparent 45%),
    linear-gradient(135deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.solutions-hero__content h1 {
  margin: 0.25rem 0 0.75rem;
  font-size: clamp(2rem, 3vw, 2.8rem);
}

.solutions-hero__content p {
  margin: 0 0 1rem;
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.6;
}

.audience-pills {
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;
  margin: 1rem 0;
}

.audience-pills button {
  border-radius: 999px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  background: rgba(0, 0, 0, 0.03);
  color: #111111;
  color: var(--secondary);
  padding: 0.45rem 0.95rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.audience-pills button.selected {
  border-color: rgba(247, 189, 32, 0.6);
  background: linear-gradient(135deg, #000000, #000000);
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: #111111;
  color: var(--secondary);
  font-weight: 700;
}

.solution-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  grid-gap: 0.75rem;
  gap: 0.75rem;
  margin-top: 1rem;
}

.solution-metrics div {
  background: #ffffff;
  background: var(--surface);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 14px;
  padding: 0.85rem 1rem;
  display: grid;
  grid-gap: 0.25rem;
  gap: 0.25rem;
  text-align: left;
}

.solutions-hero__visual {
  position: relative;
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
  justify-items: center;
}

.solutions-hero__tile {
  width: 100%;
  max-width: 320px;
  border-radius: 14px;
  padding: 1rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  background: #ffffff;
  background: var(--surface);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.solutions-hero__tile strong {
  font-size: 1.8rem;
}

.solutions-section {
  padding: 1rem 0 0;
}

.solution-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.solution-card {
  background: linear-gradient(135deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  border-radius: 20px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  display: grid;
  grid-gap: 0.6rem;
  gap: 0.6rem;
}

.solution-card__meta {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  font-size: 0.9rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.solution-card ul {
  margin: 0.25rem 0 0;
  padding-left: 1rem;
  color: #4a4a4a;
  color: var(--text-muted);
  display: grid;
  grid-gap: 0.25rem;
  gap: 0.25rem;
}

.solution-card__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.4rem;
  color: #000000;
  color: var(--primary-dark);
}

.industry-grid,
.journey-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.industry-card,
.journey-grid article {
  background: #fff;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 18px;
  padding: 1.2rem;
  box-shadow: 0 14px 35px rgba(13, 15, 20, 0.08);
}

.journey-grid article span {
  display: inline-block;
  background: #fffdf5;
  background: var(--surface-soft);
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  font-weight: 700;
}

.journey-grid article ul {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
  color: #4a4a4a;
  color: var(--text-muted);
  display: grid;
  grid-gap: 0.25rem;
  gap: 0.25rem;
}

.partner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.partner-grid strong {
  display: block;
  margin-bottom: 0.35rem;
}

.partner-grid span {
  display: inline-block;
  margin: 0.15rem 0.35rem 0.15rem 0;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  background: #fffdf5;
  background: var(--surface-soft);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .solutions-hero {
    padding: 1.75rem;
  }

  .solution-card {
    padding: 1rem;
  }
}

.footer-map-col {
  justify-self: end;
  align-self: start;
  max-width: 400px;
  width: 100%;
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.footer-links-grid h4 {
  margin: 0 0 0.8rem;
}

.footer-links-grid ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.footer-links-grid a {
  color: #4a4a4a;
  color: var(--text-muted);
  text-decoration: none;
}


@media (max-width: 768px) {
  .hero-block {
    padding: 2rem;
    margin-top: 1.5rem;
  }

  .hero-form-row {
    flex-direction: column;
  }

  .calculator-block {
    grid-template-columns: 1fr;
  }

  .download-card {
    padding: 2.5rem;
  }

  .offerings-block {
    padding: 2rem;
  }

  .apply-content {
    grid-template-columns: 1fr;
  }

  .apply-form {
    padding: 1.75rem;
  }

  .apply-hero {
    padding: 2rem;
  }

  .calculator-body {
    grid-template-columns: 1fr;
  }

  .hero-visual {
    grid-template-columns: 1fr;
  }

  .calculator-hero {
    padding: 2rem;
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .calculator-hero.credit-hero {
    grid-template-columns: 1fr;
    padding: 1.5rem;
    border-radius: 24px;
  }

  .calc-hero-copy {
    order: 1;
  }

  .credit-hero-card {
    width: 100%;
    max-width: 100%;
    order: 2;
    margin: 0;
    box-sizing: border-box;
  }

  .hero-mini-stats {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .credit-score-widget {
    padding: 1.75rem;
  }

  .contact-cta {
    flex-direction: column;
    align-items: flex-start;
  }

  .carousel {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 520px) {
  .hero-grid {
    gap: 1.5rem;
  }

  .stats-bar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .steps-grid article,
  .why-grid article,
  .product-card,
  .offering-card,
  .tool-card,
  .blog-grid article {
    padding: 1.25rem;
  }

  .apply-form .primary-btn {
    width: 100%;
  }

  .calculator-hero,
  .calc-side-card,
  .eligibility-calculator {
    padding: 1.5rem;
  }

  .calculator-hero.credit-hero {
    padding: 1.25rem;
  }

  .credit-hero-card {
    padding: 1.25rem;
  }

  .calc-hero-copy {
    gap: 0.5rem;
  }

  .calc-chip-row {
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .calc-chip {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 0.5rem);
    min-width: calc(50% - 0.5rem);
  }

  .credit-form {
    grid-template-columns: 1fr;
  }

  .contact-buttons {
    width: 100%;
    flex-direction: column;
  }

  .contact-buttons .primary-btn,
  .contact-buttons .ghost-btn {
    width: 100%;
    justify-content: center;
  }
}

.about-hero {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
  padding: 3rem;
  border-radius: 36px;
  background: linear-gradient(120deg, #e9ffff, #fff2e1, #fef0f4);
  align-items: center;
}

.about-hero-illustration {
  justify-self: center;
}

.hero-stat-grid {
  list-style: none;
  padding: 0;
  margin: 2rem 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.hero-stat-grid li {
  background: #fff;
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
}

.hero-stat-grid strong {
  display: block;
  font-size: 1.4rem;
}

.pillars-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
  margin-top: 1.25rem;
}

.pillar-card {
  background: #fff;
  border-radius: 20px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.1rem;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.pillar-card h3 {
  margin: 0 0 0.35rem;
}

.pillar-card p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.about-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.insight-card {
  background: #fffdf5;
  background: var(--surface-soft);
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.75rem;
}

.insight-card ul {
  padding-left: 1.2rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.mission-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.mission-card {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.75rem;
}

.impact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
  margin: 1rem 0 2rem;
}

.impact-grid article {
  background: linear-gradient(135deg, #f7f9ff, #fff7ef);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 18px;
  padding: 1rem;
  text-align: center;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.impact-grid strong {
  display: block;
  font-size: 1.4rem;
}

.leadership-grid {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.leadership-head h2 {
  margin: 0.3rem 0 0.2rem;
}

.leader-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 0.9rem;
  gap: 0.9rem;
}

.leader-card {
  background: #fffdf5;
  background: var(--surface-soft);
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1rem;
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.8rem;
  gap: 0.8rem;
  align-items: center;
}

.leader-avatar {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: linear-gradient(135deg, #000000, #000000);
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: #111111;
  color: var(--secondary);
  display: grid;
  place-items: center;
  font-weight: 800;
}

.leader-card h3 {
  margin: 0;
}

.leader-card p {
  margin: 0;
  font-weight: 700;
}

.leader-card span {
  color: #4a4a4a;
  color: var(--text-muted);
}

.quiz-page {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding-top: 3rem;
}

.quiz-hero {
  background:
    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.18), transparent 50%),
    radial-gradient(circle at 90% 10% 0%, rgba(232, 169, 26, 0.16), transparent 50%),
    linear-gradient(120deg, #ffffff, #fff8e0);
  color: #111111;
  color: var(--secondary);
  border-radius: 32px;
  padding: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
  align-items: start;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.quiz-hero__copy {
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.quiz-hero__copy p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.6;
}

.quiz-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.quiz-badges span {
  background: #ffffff;
  background: var(--surface);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.55rem 0.85rem;
  border-radius: 14px;
  display: inline-flex;
  flex-direction: column;
  gap: 0.1rem;
}

.quiz-hero__card {
  background: #ffffff;
  background: var(--surface);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 20px;
  padding: 1.25rem;
  display: grid;
  grid-gap: 0.75rem;
  gap: 0.75rem;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.quiz-stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  grid-gap: 0.6rem;
  gap: 0.6rem;
}

.quiz-stats-row div {
  background: #ffffff;
  background: var(--surface);
  border-radius: 12px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 0.65rem 0.8rem;
  text-align: center;
}

.quiz-note {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.quiz-body {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.quiz-card {
  background: #fff;
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.1);
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
}

.quiz-questions {
  display: grid;
  grid-gap: 1rem;
  gap: 1rem;
}

.quiz-question {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.8rem;
  gap: 0.8rem;
  align-items: start;
}

.quiz-question__index {
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: #000000;
  background: var(--primary);
  color: #111111;
  color: var(--secondary);
  display: grid;
  place-items: center;
  font-weight: 800;
  box-shadow: 0 12px 28px rgba(247, 189, 32, 0.35);
}

.quiz-options {
  display: grid;
  grid-gap: 0.55rem;
  gap: 0.55rem;
}

.quiz-option {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-gap: 0.55rem;
  gap: 0.55rem;
  align-items: center;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  border-radius: 14px;
  padding: 0.65rem 0.8rem;
  background: #fffdf5;
  background: var(--surface-soft);
}

.quiz-option.selected {
  border-color: #111111;
  border-color: var(--secondary);
  background: #eef6ff;
}

.quiz-option input {
  accent-color: #111111;
  accent-color: var(--secondary);
}

.quiz-aside {
  display: grid;
  grid-gap: 0.9rem;
  gap: 0.9rem;
}

.quiz-tip-card {
  background: #fff;
  border-radius: 18px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.1rem;
  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);
}

.quiz-tip-card ul {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
  color: #4a4a4a;
  color: var(--text-muted);
  display: grid;
  grid-gap: 0.35rem;
  gap: 0.35rem;
}

.reach-section .office-card {
  background: #fff;
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
}

.partner-showcase {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
  align-items: stretch;
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2rem;
}

.ally-hero {
  background: linear-gradient(135deg, rgba(233, 255, 255, 0.7), rgba(255, 242, 225, 0.7));
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.ally-list {
  list-style: none;
  padding: 0;
  margin: 1.5rem 0 0;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.ally-list li {
  background: #fffdf5;
  background: var(--surface-soft);
  border-radius: 20px;
  padding: 1rem;
  flex: 1 1;
  min-width: 140px;
  text-align: center;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.ally-carousel {
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1rem;
  background: #fefefe;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
}

.carousel {
  display: grid;
  grid-template-columns: minmax(220px, 1fr) minmax(260px, 1.4fr);
  grid-gap: 1.25rem;
  gap: 1.25rem;
  align-items: stretch;
}

.carousel-visual {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
}

.carousel-slide {
  border-radius: 24px;
  height: 100%;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #111111;
  color: var(--secondary);
  font-weight: 700;
  font-size: 1.6rem;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  box-shadow: inset 0 0 60px rgba(0, 0, 0, 0.25);
  animation: pulseBackground 6s ease-in-out infinite;
}

.about-cta {
  background: linear-gradient(135deg, #ffffff, #fff7da);
  color: #111111;
  color: var(--secondary);
  border-radius: 28px;
  padding: 1.75rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.about-cta p {
  margin: 0.25rem 0;
  color: #4a4a4a;
  color: var(--text-muted);
}

.about-cta-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

@keyframes pulseBackground {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }

  100% {
    transform: scale(1);
  }
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.85);
  color: #0b0b0b;
  color: var(--text-strong);
  font-size: 1.5rem;
  cursor: pointer;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.2);
  transition: transform 0.2s ease;
}

.carousel-control:hover {
  transform: translateY(-50%) scale(1.05);
}

.carousel-control.prev {
  left: 1rem;
}

.carousel-control.next {
  right: 1rem;
}

.carousel-content {
  background: #fff;
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.carousel-content ul {
  margin: 0;
  padding-left: 1.2rem;
  color: #4a4a4a;
  color: var(--text-muted);
}

.carousel-dots {
  grid-column: 1 / -1;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-top: 0.5rem;
}

.carousel-dots button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background: rgba(15, 23, 42, 0.2);
}

.carousel-dots button.active {
  background: #111111;
  background: var(--secondary);
}

.value-blocks {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.value-blocks article {
  background: #fff;
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
  position: relative;
  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.08);
}

.value-blocks article .eyebrow {
  margin-bottom: 0.35rem;
}

.testimonial-showcase {
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.testimonial-header {
  max-width: 720px;
}

.testimonial-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.testimonial-cards article {
  background: #fffdf5;
  background: var(--surface-soft);
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.25rem;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.inclusion-section {
  background: linear-gradient(135deg, #fef6ee, #e9ffff);
  border-radius: 32px;
  padding: 2.5rem;
  display: grid;
  grid-gap: 2rem;
  gap: 2rem;
}

.impact-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  grid-gap: 1rem;
  gap: 1rem;
}

.impact-grid .impact-card {
  padding: 1.5rem;
  border-radius: 24px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: #fff;
  text-align: center;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.governance-section {
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2.5rem;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);
}

.governance-section .journey-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.governance-section .journey-grid article {
  padding: 1.5rem;
  border-radius: 24px;
  background: #fffdf5;
  background: var(--surface-soft);
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.about-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.insight-card {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.75rem;
  box-shadow: 0 10px 32px rgba(15, 23, 42, 0.06);
}

.mission-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.mission-card {
  background: #fff;
  border-radius: 28px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.75rem;
}

.reach-section {
  background: #fff;
  border-radius: 32px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 2.5rem;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.06);
}

.office-card {
  background: #fffdf5;
  background: var(--surface-soft);
  border-radius: 24px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  padding: 1.5rem;
}

/* ===== Personal Loan Page Styles ===== */
.personal-loan-page {
  padding-top: 0;
  background: #fff;
}

/* Hero Section */
.personal-loan-hero {
  background: linear-gradient(135deg, #fffef9 0%, #fff7e6 50%, #ffffff 100%);
  padding: 5rem 0 6rem;
  position: relative;
  overflow: hidden;
  margin-top: 80px;
}

.personal-loan-hero::before {
  content: '';
  position: absolute;
  top: -30%;
  right: -15%;
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(247, 189, 32, 0.12) 0%, transparent 60%);
  border-radius: 50%;
  animation: float 20s ease-in-out infinite;
}

@keyframes float {

  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(-20px, 20px) scale(1.05);
  }
}

.hero-content-wrapper {
  width: min(1240px, 94vw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.3fr 1fr;
  grid-gap: 5rem;
  gap: 5rem;
  align-items: center;
  position: relative;
  z-index: 1;
}

.hero-badge {
  display: inline-block;
  padding: 0.6rem 1.5rem;
  background: linear-gradient(135deg, #f7bd20, #ffed4e);
  color: #111111;
  color: var(--secondary);
  font-weight: 800;
  font-size: 0.85rem;
  border-radius: 999px;
  margin-bottom: 1.75rem;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  box-shadow: 0 4px 15px rgba(247, 189, 32, 0.3);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {

  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }
}

.hero-text h1 {
  font-size: clamp(2.5rem, 5vw, 4rem);
  line-height: 1.15;
  margin: 0 0 1.5rem;
  color: #111111;
  color: var(--secondary);
  font-weight: 800;
  letter-spacing: -0.5px;
}

.hero-description {
  font-size: 1.15rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 2.5rem;
  max-width: 600px;
}

.hero-features {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 2.5rem;
}

.feature-pill {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1.5rem;
  background: #fff;
  border: 2px solid rgba(247, 189, 32, 0.25);
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.95rem;
  color: #111111;
  color: var(--secondary);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.feature-pill:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(247, 189, 32, 0.2);
  border-color: #000000;
  border-color: var(--primary);
}

.feature-pill .icon {
  font-size: 1.3rem;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.loan-highlight-card {
  background: linear-gradient(135deg, #fff 0%, #fffdf5 100%);
  padding: 3rem 2.5rem;
  border-radius: 28px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.12);
  border: 2px solid rgba(247, 189, 32, 0.15);
  position: relative;
  overflow: hidden;
}

.loan-highlight-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
}

.highlight-amount {
  font-size: 3.5rem;
  font-weight: 900;
  background: linear-gradient(135deg, #f7bd20, #ffa500);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 0.5rem;
  line-height: 1;
}

.highlight-label {
  color: #666;
  font-size: 1.05rem;
  margin-bottom: 2.5rem;
  font-weight: 600;
}

.highlight-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 2rem;
  gap: 2rem;
  padding-top: 2rem;
  border-top: 2px solid rgba(247, 189, 32, 0.2);
}

.stat-item {
  text-align: center;
  padding: 1rem;
  background: rgba(247, 189, 32, 0.05);
  border-radius: 12px;
}

.stat-item strong {
  display: block;
  font-size: 1.75rem;
  color: #111111;
  color: var(--secondary);
  margin-bottom: 0.35rem;
  font-weight: 800;
}

.stat-item span {
  color: #666;
  font-size: 0.9rem;
  font-weight: 600;
}

/* Section Block Base */
.section-block {
  padding: 5rem 0;
}

.section-heading {
  text-align: center;
  max-width: 700px;
  margin: 0 auto 3.5rem;
}

.section-heading h2 {
  font-size: clamp(2rem, 4vw, 2.75rem);
  font-weight: 800;
  color: #111111;
  color: var(--secondary);
  margin: 0 0 1rem;
  line-height: 1.2;
}

.section-heading p {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.7;
  margin: 0;
}

/* Eligibility Section */
.eligibility-section {
  background: linear-gradient(to bottom, #fff 0%, #fffef9 100%);
}

.eligibility-grid {
  width: min(1240px, 94vw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 1.75rem;
  gap: 1.75rem;
}

.eligibility-card {
  padding: 2rem 1.75rem;
  background: #fff;
  border-radius: 20px;
  border: 2px solid rgba(247, 189, 32, 0.15);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.eligibility-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  border-radius: 20px 20px 0 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.eligibility-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(247, 189, 32, 0.15);
  border-color: #000000;
  border-color: var(--primary);
}

.eligibility-card:hover::before {
  opacity: 1;
}

.eligibility-label {
  font-size: 0.8rem;
  font-weight: 800;
  color: #000000;
  color: var(--primary-dark);
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 1rem;
}

.eligibility-value {
  font-size: 1.15rem;
  font-weight: 700;
  color: #111111;
  color: var(--secondary);
  line-height: 1.6;
}

/* Documents Section */
.documents-section {
  background: linear-gradient(135deg, #fffef9 0%, #fff7e6 100%);
}

.documents-grid {
  width: min(1240px, 94vw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
}

.document-card {
  padding: 2.25rem 2rem;
  background: #fff;
  border-radius: 20px;
  border: 2px solid rgba(17, 17, 17, 0.06);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.document-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);
  border-color: rgba(247, 189, 32, 0.3);
}

.document-icon {
  font-size: 2.75rem;
  margin-bottom: 1.25rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.document-card h3 {
  font-size: 1.15rem;
  margin: 0 0 1.25rem;
  color: #111111;
  color: var(--secondary);
  font-weight: 800;
}

.document-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.document-card li {
  padding: 0.65rem 0;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.5;
  border-bottom: 1px solid rgba(17, 17, 17, 0.06);
  font-weight: 500;
}

.document-card li:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.document-card li::before {
  content: '✓';
  color: #000000;
  color: var(--primary-dark);
  font-weight: bold;
  margin-right: 0.75rem;
}

/* Fees Section */
.fees-section {
  background: #fff;
}

.fees-table-wrapper {
  width: min(1240px, 94vw);
  margin: 0 auto;
  overflow-x: auto;
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);
  border: 2px solid rgba(247, 189, 32, 0.15);
}

.fees-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.fees-table thead {
  background: linear-gradient(135deg, #f7bd20, #ffed4e);
}

.fees-table th {
  padding: 1.5rem 1.75rem;
  text-align: left;
  font-weight: 800;
  color: #111111;
  color: var(--secondary);
  font-size: 1rem;
  letter-spacing: 0.3px;
}

.fees-table td {
  padding: 1.5rem 1.75rem;
  border-bottom: 1px solid rgba(17, 17, 17, 0.06);
}

.fees-table tbody tr:last-child td {
  border-bottom: none;
}

.fee-type {
  font-weight: 700;
  color: #111111;
  color: var(--secondary);
  width: 35%;
  font-size: 0.95rem;
}

.fee-charge {
  color: #555;
  line-height: 1.7;
  font-size: 0.95rem;
}

.fees-table tbody tr {
  transition: background 0.2s ease;
}

.fees-table tbody tr:hover {
  background: rgba(247, 189, 32, 0.04);
}

/* Apply Steps Section */
.apply-steps-section {
  background: linear-gradient(to bottom, #fffef9 0%, #fff 100%);
}

.steps-timeline {
  width: min(1240px, 94vw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 2.5rem;
  gap: 2.5rem;
}

.step-card {
  padding: 2.5rem 2rem;
  background: #fff;
  border-radius: 20px;
  border: 2px solid rgba(247, 189, 32, 0.15);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  position: relative;
  transition: all 0.3s ease;
}

.step-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 16px 40px rgba(247, 189, 32, 0.2);
}

.step-number {
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #f7bd20, #ffed4e);
  color: #111111;
  color: var(--secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 6px 20px rgba(247, 189, 32, 0.3);
}

.step-card h3 {
  margin: 0 0 1rem;
  font-size: 1.35rem;
  color: #111111;
  color: var(--secondary);
  font-weight: 800;
}

.step-card p {
  margin: 0;
  color: #555;
  line-height: 1.7;
  font-size: 1rem;
}

/* CTA Section */
.personal-loan-cta {
  background: linear-gradient(135deg, #fffef9 0%, #fff7e6 50%, #ffffff 100%);
  text-align: center;
  padding: 5rem 2rem;
  position: relative;
  overflow: hidden;
}

.personal-loan-cta::before {
  content: '';
  position: absolute;
  top: -50%;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(247, 189, 32, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}

.cta-content {
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.cta-content h2 {
  font-size: clamp(2rem, 4vw, 3rem);
  margin: 0 0 1rem;
  font-weight: 800;
  color: #f7bd20;
}

.cta-content p {
  font-size: 1.2rem;
  color: #f7bd20;
  margin: 0 0 2.5rem;
  line-height: 1.7;
}

.cta-buttons {
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;
  justify-content: center;
}

/* Button size variants */
.primary-btn.large,
.ghost-btn.large {
  padding: 1.1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 700;
  border-radius: 999px;
  box-shadow: 0 6px 24px rgba(247, 189, 32, 0.25);
  transition: all 0.3s ease;
}

.primary-btn.large:hover {
  transform: translateY(-3px);
  box-shadow: 0 12px 32px rgba(247, 189, 32, 0.35);
}

.ghost-btn.large:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

/* Responsive */
@media (max-width: 1024px) {
  .hero-content-wrapper {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .loan-highlight-card {
    max-width: 450px;
    margin: 0 auto;
  }

  .section-block {
    padding: 4rem 0;
  }
}

@media (max-width: 768px) {
  .personal-loan-hero {
    padding: 3rem 0 4rem;
  }

  .hero-text h1 {
    font-size: 2.25rem;
  }

  .hero-description {
    font-size: 1.05rem;
  }

  .eligibility-grid,
  .documents-grid,
  .steps-timeline {
    grid-template-columns: 1fr;
  }

  .fees-table-wrapper {
    font-size: 0.9rem;
    border-radius: 12px;
  }

  .fees-table th,
  .fees-table td {
    padding: 1rem;
  }

  .hero-actions,
  .cta-buttons {
    flex-direction: column;
  }

  .hero-actions .primary-btn,
  .hero-actions .ghost-btn,
  .cta-buttons .primary-btn,
  .cta-buttons .ghost-btn {
    width: 100%;
  }

  .section-heading h2 {
    font-size: 1.75rem;
  }

  .section-block {
    padding: 3.5rem 0;
  }
}

*/ .personal-loan-page {
  padding-top: 0;
}

/* Hero Section */
.personal-loan-hero {
  background: linear-gradient(135deg, #fff6d6, #fffbea, #ffffff);
  padding: 4rem 0;
  position: relative;
  overflow: hidden;
}

.personal-loan-hero::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(247, 189, 32, 0.15) 0%, transparent 70%);
  border-radius: 50%;
}

.hero-content-wrapper {
  width: min(1240px, 94vw);
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  grid-gap: 4rem;
  gap: 4rem;
  align-items: center;
}

.hero-badge {
  display: inline-block;
  padding: 0.5rem 1.25rem;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  color: #111111;
  color: var(--secondary);
  font-weight: 700;
  font-size: 0.9rem;
  border-radius: 999px;
  margin-bottom: 1.5rem;
}

.hero-text h1 {
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  line-height: 1.1;
  margin: 0 0 1.5rem;
  color: #111111;
  color: var(--secondary);
}

.hero-description {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #4a4a4a;
  color: var(--text-muted);
  margin-bottom: 2rem;
}

.hero-features {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.feature-pill {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.25rem;
  background: rgba(247, 189, 32, 0.1);
  border: 1px solid rgba(247, 189, 32, 0.3);
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.9rem;
}

.feature-pill .icon {
  font-size: 1.2rem;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.loan-highlight-card {
  background: #fff;
  padding: 2.5rem;
  border-radius: 24px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(247, 189, 32, 0.2);
}

.highlight-amount {
  font-size: 3rem;
  font-weight: 800;
  color: #000000;
  color: var(--primary-dark);
  margin-bottom: 0.5rem;
}

.highlight-label {
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 1rem;
  margin-bottom: 2rem;
}

.highlight-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1.5rem;
  gap: 1.5rem;
  padding-top: 2rem;
  border-top: 1px solid rgba(17, 17, 17, 0.1);
}

.stat-item {
  text-align: center;
}

.stat-item strong {
  display: block;
  font-size: 1.5rem;
  color: #111111;
  color: var(--secondary);
  margin-bottom: 0.25rem;
}

.stat-item span {
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 0.85rem;
}

/* Eligibility Section */
.eligibility-section {
  background: #fff;
}

.eligibility-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.eligibility-card {
  padding: 1.75rem;
  background: linear-gradient(135deg, #ffffff, #fff7da);
  border-radius: 16px;
  border: 1px solid rgba(247, 189, 32, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.eligibility-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);
}

.eligibility-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: #000000;
  color: var(--primary-dark);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;
}

.eligibility-value {
  font-size: 1.1rem;
  font-weight: 600;
  color: #111111;
  color: var(--secondary);
  line-height: 1.5;
}

/* Documents Section */
.documents-section {
  background: linear-gradient(135deg, #fffdf5, #fff7da);
}

.documents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.document-card {
  padding: 2rem;
  background: #fff;
  border-radius: 16px;
  border: 1px solid rgba(17, 17, 17, 0.08);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.document-icon {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.document-card h3 {
  font-size: 1.1rem;
  margin: 0 0 1rem;
  color: #111111;
  color: var(--secondary);
}

.document-card ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.document-card li {
  padding: 0.5rem 0;
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 0.95rem;
  border-bottom: 1px solid rgba(17, 17, 17, 0.05);
}

.document-card li:last-child {
  border-bottom: none;
}

/* Fees Section */
.fees-section {
  background: #fff;
}

.fees-table-wrapper {
  overflow-x: auto;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.fees-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.fees-table thead {
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
}

.fees-table th {
  padding: 1.25rem;
  text-align: left;
  font-weight: 700;
  color: #111111;
  color: var(--secondary);
  font-size: 1rem;
}

.fees-table td {
  padding: 1.25rem;
  border-bottom: 1px solid rgba(17, 17, 17, 0.05);
}

.fees-table tbody tr:last-child td {
  border-bottom: none;
}

.fee-type {
  font-weight: 600;
  color: #111111;
  color: var(--secondary);
  width: 30%;
}

.fee-charge {
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.6;
}

.fees-table tbody tr:hover {
  background: rgba(247, 189, 32, 0.05);
}

/* Apply Steps Section */
.apply-steps-section {
  background: linear-gradient(135deg, #fff6d6, #fffbea);
}

.steps-timeline {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
}

.step-card {
  padding: 2rem;
  background: #fff;
  border-radius: 16px;
  border: 1px solid rgba(247, 189, 32, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  position: relative;
}

.step-number {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  color: #111111;
  color: var(--secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.25rem;
  margin-bottom: 1.25rem;
}

.step-card h3 {
  margin: 0 0 0.75rem;
  font-size: 1.25rem;
  color: #111111;
  color: var(--secondary);
}

.step-card p {
  margin: 0;
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.6;
}

/* CTA Section */
.personal-loan-cta {
  background: linear-gradient(135deg, #ffffff, #fff7da);
  text-align: center;
  padding: 4rem 2rem;
}

/* Responsive */
@media (max-width: 1024px) {
  .hero-content-wrapper {
    grid-template-columns: 1fr;
    gap: 3rem;
  }

  .loan-highlight-card {
    max-width: 400px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .personal-loan-hero {
    padding: 3rem 0;
  }

  .hero-text h1 {
    font-size: 2rem;
  }

  .eligibility-grid,
  .documents-grid,
  .steps-timeline {
    grid-template-columns: 1fr;
  }

  .fees-table-wrapper {
    font-size: 0.9rem;
  }

  .fees-table th,
  .fees-table td {
    padding: 0.875rem;
  }

  .hero-actions {
    flex-direction: column;
  }

  .hero-actions .primary-btn,
  .hero-actions .ghost-btn {
    width: 100%;
  }
}

/* Button size variants */
.primary-btn.large,
.ghost-btn.large {
  padding: 1rem 2rem;
  font-size: 1.1rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

.cta-content {
  max-width: 800px;
  margin: 0 auto;
}

.cta-content h2 {
  font-size: 2.5rem;
  margin: 0 0 1rem;
}

.cta-content p {
  font-size: 1.1rem;
  color: #f7bd20;
  margin: 0 0 2rem;
}

/* Additional Visual Enhancements for Personal Loan Page */
.card-icon {
  font-size: 4rem;
  text-align: center;
  margin-bottom: 1.5rem;
  filter: drop-shadow(0 4px 8px rgba(247, 189, 32, 0.3));
  animation: float-icon 3s ease-in-out infinite;
}

@keyframes float-icon {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

.stat-icon {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.trust-badges {
  display: flex;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid rgba(247, 189, 32, 0.2);
}

.badge-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #111111;
  color: var(--secondary);
}

.badge-icon {
  font-size: 1.2rem;
}

.section-icon {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  filter: drop-shadow(0 4px 8px rgba(247, 189, 32, 0.2));
}

.card-number {
  position: absolute;
  top: -15px;
  right: 20px;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #f7bd20, #ffed4e);
  color: #111111;
  color: var(--secondary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 900;
  font-size: 1.1rem;
  box-shadow: 0 4px 12px rgba(247, 189, 32, 0.4);
}

/* Improve fees table visual */
.fees-table thead th:first-child {
  border-radius: 20px 0 0 0;
}

.fees-table thead th:last-child {
  border-radius: 0 20px 0 0;
}

/* Add more visual appeal */
.loan-highlight-card {
  animation: card-float 6s ease-in-out infinite;
}

@keyframes card-float {

  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }

  50% {
    transform: translateY(-8px) rotate(1deg);
  }
}

/* Illustration Styles */
.hero-illustration {
  margin-bottom: 1.5rem;
  text-align: center;
}

.hero-illustration img {
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 20px;
  box-shadow: 0 12px 40px rgba(247, 189, 32, 0.2);
  animation: float-illustration 4s ease-in-out infinite;
}

@keyframes float-illustration {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-15px);
  }
}

.section-illustration {
  margin-bottom: 2rem;
  text-align: center;
}

.section-illustration img {
  width: 100%;
  max-width: 280px;
  height: auto;
  filter: drop-shadow(0 8px 24px rgba(247, 189, 32, 0.15));
  animation: subtle-float 6s ease-in-out infinite;
}

@keyframes subtle-float {

  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-8px);
  }
}

.hero-visual {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
}

@media (max-width: 768px) {
  .hero-illustration img {
    max-width: 300px;
  }

  .section-illustration img {
    max-width: 200px;
  }
}

/* ==========================================
   About Page Styles - Modern & Clean
   ========================================== */

/* About Hero Section */
.about-hero-modern {
  margin-top: 2rem;
  padding: 4rem 3rem;
  border-radius: 40px;
  background: linear-gradient(135deg,
      rgba(255, 251, 234, 0.95) 0%,
      rgba(255, 248, 225, 0.85) 50%,
      rgba(255, 243, 214, 0.75) 100%);
  box-shadow: 0 26px 80px rgba(15, 23, 42, 0.12);
  position: relative;
  overflow: hidden;
}

.about-hero-content {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
}

.about-hero-content .hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1.25rem;
  background: rgba(247, 189, 32, 0.2);
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.9rem;
  color: #111111;
  color: var(--secondary);
  margin-bottom: 1.5rem;
}

.about-hero-content h1 {
  font-size: clamp(2.4rem, 5vw, 4rem);
  line-height: 1.15;
  margin: 0 0 1.5rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.about-hero-content .gradient-text {
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.about-hero-content .hero-subtitle {
  font-size: 1.1rem;
  line-height: 1.7;
  color: #4a4a4a;
  color: var(--text-muted);
  margin-bottom: 2rem;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.hero-cta-group {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 3rem;
}

.about-hero-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-gap: 1.5rem;
  gap: 1.5rem;
  margin-top: 3rem;
}

.stat-card {
  background: rgba(255, 255, 255, 0.7);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 1.5rem;
  text-align: center;
  border: 1px solid rgba(247, 189, 32, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.15);
}

.stat-value {
  font-size: 2.5rem;
  font-weight: 700;
  color: #000000;
  color: var(--primary-dark);
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.95rem;
  color: #4a4a4a;
  color: var(--text-muted);
  font-weight: 500;
}

/* Values Section */
.values-section {
  margin-top: 5rem;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
}

.value-card {
  background: white;
  border-radius: 24px;
  padding: 2rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  position: relative;
  overflow: hidden;
}

.value-card::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle at top right,
      rgba(247, 189, 32, 0.15) 0%,
      rgba(247, 189, 32, 0.05) 40%,
      rgba(247, 189, 32, 0) 70%);
  background: var(--gradient-glow);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.value-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  border-color: rgba(247, 189, 32, 0.4);
}

.value-card:hover::before {
  opacity: 1;
}

.value-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  display: block;
}

.value-card h3 {
  font-size: 1.4rem;
  margin: 0 0 0.75rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.value-card p {
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.7;
  margin: 0;
}

/* Journey Timeline Section */
.journey-section {
  margin-top: 5rem;
}

.journey-timeline {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 0;
}

.timeline-item {
  display: grid;
  grid-template-columns: 80px 1fr;
  grid-gap: 2rem;
  gap: 2rem;
  margin-bottom: 3rem;
  position: relative;
}

.timeline-marker {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.timeline-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  border: 4px solid rgba(247, 189, 32, 0.2);
  z-index: 2;
  flex-shrink: 0;
}

.timeline-line {
  width: 2px;
  height: 100%;
  background: linear-gradient(to bottom, rgba(247, 189, 32, 0.3), rgba(247, 189, 32, 0.1));
  margin-top: 0.5rem;
  flex-grow: 1;
}

.timeline-content {
  background: white;
  border-radius: 20px;
  padding: 1.75rem 2rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.timeline-content:hover {
  transform: translateX(6px);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);
}

.timeline-year {
  display: inline-block;
  padding: 0.35rem 1rem;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  color: #111111;
  color: var(--secondary);
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

.timeline-content h3 {
  font-size: 1.4rem;
  margin: 0 0 0.75rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.timeline-content p {
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.7;
  margin: 0;
}

/* Mission & Vision Section */
.mission-vision-section {
  margin-top: 5rem;
}

.mission-vision-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  grid-gap: 2.5rem;
  gap: 2.5rem;
}

.mission-card.modern,
.vision-card.modern {
  background: linear-gradient(135deg, #ffffff 0%, #fff9e6 100%);
  border-radius: 32px;
  padding: 3rem 2.5rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.mission-card.modern:hover,
.vision-card.modern:hover {
  transform: translateY(-4px);
  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.15);
}

.mission-card .card-badge,
.vision-card .card-badge {
  display: inline-block;
  padding: 0.4rem 1rem;
  background: rgba(247, 189, 32, 0.15);
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.85rem;
  color: #111111;
  color: var(--secondary);
  margin-bottom: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.mission-card h2,
.vision-card h2 {
  font-size: 1.9rem;
  margin: 0 0 1.25rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.mission-card p,
.vision-card p {
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.8;
  margin: 0;
  font-size: 1.05rem;
}

/* Leadership Team Section */
.leadership-section {
  margin-top: 5rem;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
}

.team-card {
  background: white;
  border-radius: 24px;
  padding: 2rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  display: flex;
  align-items: center;
  gap: 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.team-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  border-color: rgba(247, 189, 32, 0.4);
}

.team-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg,
      #f7bd20 0%,
      #f5a623 25%,
      #f39c21 50%,
      #f18e1f 75%,
      #e8a91a 100%);
  background: var(--gradient-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 700;
  color: #111111;
  color: var(--secondary);
  flex-shrink: 0;
}

.team-info h3 {
  font-size: 1.3rem;
  margin: 0 0 0.35rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.team-role {
  color: #000000;
  color: var(--primary-dark);
  font-weight: 600;
  font-size: 0.95rem;
  margin: 0 0 0.5rem;
}

.team-focus {
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}

/* Legal & Compliance Section */
.legal-section {
  margin-top: 5rem;
}

.legal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
}

.legal-card {
  background: white;
  border-radius: 24px;
  padding: 2.5rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.legal-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
}

.legal-card h3 {
  font-size: 1.5rem;
  margin: 0 0 1.5rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.legal-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(17, 17, 17, 0.08);
  border-bottom: 1px solid var(--border-soft);
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 0.95rem;
  font-weight: 500;
}

.info-value {
  color: #0b0b0b;
  color: var(--text-strong);
  font-weight: 600;
  text-align: right;
}

.certification-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.certification-list li {
  padding: 0.75rem 0;
  color: #4a4a4a;
  color: var(--text-muted);
  font-size: 1rem;
  border-bottom: 1px solid rgba(17, 17, 17, 0.08);
  border-bottom: 1px solid var(--border-soft);
}

.certification-list li:last-child {
  border-bottom: none;
}

/* Office Locations Section */
.office-section {
  margin-top: 5rem;
}

.office-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
  margin-bottom: 3rem;
}

.office-card.modern {
  background: white;
  border-radius: 24px;
  padding: 2.5rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.office-card.modern:hover {
  transform: translateY(-4px);
  box-shadow: 0 25px 65px rgba(17, 17, 17, 0.12);
  box-shadow: var(--shadow-soft);
  border-color: rgba(247, 189, 32, 0.4);
}

.office-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.office-card h3 {
  font-size: 1.3rem;
  margin: 0 0 1rem;
  color: #0b0b0b;
  color: var(--text-strong);
}

.office-address {
  color: #4a4a4a;
  color: var(--text-muted);
  line-height: 1.6;
  margin: 0 0 0.5rem;
}

.office-city {
  color: #0b0b0b;
  color: var(--text-strong);
  font-weight: 600;
  margin: 0;
}

.contact-info-section {
  background: linear-gradient(135deg, #fff 0%, #fff9e6 100%);
  border-radius: 24px;
  padding: 2.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
  border: 1px solid rgba(17, 17, 17, 0.08);
  border: 1px solid var(--border-soft);
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.contact-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.contact-item>div {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.contact-label {
  font-size: 0.85rem;
  color: #4a4a4a;
  color: var(--text-muted);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.contact-value {
  font-size: 1.1rem;
  color: #0b0b0b;
  color: var(--text-strong);
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}

.contact-value:hover {
  color: #000000;
  color: var(--primary-dark);
}

/* About Page CTA */
.about-cta {
  margin-top: 5rem;
  padding: 4rem 3rem;
  background: linear-gradient(135deg,
      #1a1a1a 0%,
      #111111 50%,
      #0a0a0a 100%);
  background: var(--gradient-dark);
  border-radius: 40px;
  text-align: center;
}

.about-cta .cta-content h2 {
  color: #f7bd20;
  font-size: clamp(2rem, 4vw, 3rem);
  margin-bottom: 1rem;
}

.about-cta .cta-content p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

.about-cta .cta-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .about-hero-modern {
    padding: 2.5rem 1.5rem;
  }

  .about-hero-stats {
    grid-template-columns: repeat(2, 1fr);
  }

  .mission-vision-grid {
    grid-template-columns: 1fr;
  }

  .timeline-item {
    grid-template-columns: 60px 1fr;
    gap: 1rem;
  }

  .team-card {
    flex-direction: column;
    text-align: center;
  }

  .contact-info-section {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .about-hero-stats {
    grid-template-columns: 1fr;
  }

  .stat-value {
    font-size: 2rem;
  }

  .hero-cta-group {
    flex-direction: column;
    width: 100%;
  }

  .hero-cta-group .primary-btn,
  .hero-cta-group .ghost-btn {
    width: 100%;
    justify-content: center;
  }
}

/* ============================================
   COMPREHENSIVE MOBILE RESPONSIVE STYLES
   ============================================ */

/* Mobile-First Product Card Background Fix */
.product-card {
  background: rgba(255, 255, 255, 0.95) !important;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08);
}

.product-card.modern {
  background: rgba(255, 255, 255, 0.98) !important;
}

/* Section Block Mobile Optimization */
@media (max-width: 1024px) {
  .section-block {
    margin: 3rem 0;
  }

  .product-grid {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 1.25rem;
  }

  .page {
    width: min(1240px, 92vw);
  }
}

/* Tablet Responsive Styles */
@media (max-width: 768px) {

  /* Hero Section */
  .hero-block {
    margin-top: 1rem;
    padding: 2rem 1.5rem;
    border-radius: 32px;
  }

  .hero-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .hero-content h1 {
    font-size: clamp(1.8rem, 5vw, 2.5rem);
  }

  .hero-content p {
    font-size: 1rem;
  }

  .hero-cta {
    flex-direction: column;
    gap: 0.75rem;
  }

  .hero-cta .primary-btn,
  .hero-cta .ghost-btn {
    width: 100%;
    text-align: center;
    justify-content: center;
    display: flex;
  }

  .hero-carousel {
    height: 300px;
  }

  /* Section Headings */
  .section-heading {
    max-width: 100%;
    margin: 0 auto 2rem;
  }

  .section-heading h2 {
    font-size: clamp(1.6rem, 4vw, 2.2rem);
  }

  .section-heading p {
    font-size: 0.95rem;
  }

  .eyebrow {
    font-size: 0.7rem;
  }

  /* Product Grid */
  .product-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .product-card {
    min-height: 180px;
    padding: 1.25rem;
    border-radius: 20px;
  }

  .product-card img {
    width: 56px;
    height: 56px;
  }

  .product-card h3 {
    font-size: 1.1rem;
  }

  .product-card p {
    font-size: 0.9rem;
  }

  .product-badge {
    font-size: 0.8rem;
    padding: 0.3rem 0.7rem;
  }

  /* Stats Bar */
  .stats-bar {
    grid-template-columns: repeat(2, 1fr);
    padding: 1.25rem;
    gap: 0.75rem;
    margin: 2rem 0;
  }

  .stats-bar strong {
    font-size: 1.5rem;
  }

  /* Calculator Block */
  .calculator-block {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .loan-calculator {
    padding: 1.5rem;
    gap: 1.5rem;
  }

  .loan-calculator__inputs,
  .loan-calculator__summary {
    min-width: 100%;
  }

  /* Steps Grid */
  .steps-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .steps-grid article {
    padding: 1.5rem;
  }

  /* Offerings */
  .offerings-block {
    padding: 2rem 1.5rem;
    border-radius: 28px;
  }

  .offering-grid {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 1rem;
  }

  /* CTA Section */
  .cta-section {
    padding: 2rem 1.5rem;
  }

  .cta-buttons {
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
  }

  .cta-buttons .primary-btn,
  .cta-buttons .ghost-btn {
    width: 100%;
    text-align: center;
    justify-content: center;
    display: flex;
  }

  /* Testimonials */
  .testimonials-carousel {
    padding: 1rem;
  }

  .testimonial-card {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1.5rem;
    text-align: center;
  }

  .testimonial-avatar {
    width: 60px;
    height: 60px;
    margin: 0 auto;
  }

  .testimonials-carousel-track {
    min-height: 320px;
  }
}

/* Mobile Phone Responsive Styles */
@media (max-width: 480px) {

  /* Page Container */
  .page {
    width: min(1240px, 90vw);
    padding-bottom: 3rem;
  }

  .fibe-home {
    padding-top: 1rem;
  }

  /* Hero Section */
  .hero-block {
    padding: 1.5rem 1rem;
    border-radius: 24px;
    margin-top: 0.5rem;
  }

  .hero-content h1 {
    font-size: 1.75rem;
    line-height: 1.2;
  }

  .hero-content p {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .hero-badges {
    flex-direction: column;
    gap: 0.5rem;
    font-size: 0.85rem;
  }

  .hero-carousel {
    height: 250px;
    border-radius: 20px;
  }

  /* Buttons */
  .primary-btn,
  .ghost-btn {
    font-size: 0.9rem;
    padding: 0.7rem 1.5rem;
  }

  .primary-btn.large,
  .ghost-btn.large {
    font-size: 1rem;
    padding: 0.85rem 1.75rem;
  }

  /* Section Headings */
  .section-block {
    margin: 2.5rem 0;
  }

  .section-heading {
    margin: 0 auto 1.5rem;
  }

  .section-heading h2 {
    font-size: 1.5rem;
    margin: 0.5rem 0;
  }

  .section-heading p {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .eyebrow {
    font-size: 0.65rem;
    letter-spacing: 0.12em;
  }

  /* Product Cards */
  .product-grid {
    gap: 0.875rem;
  }

  .product-card {
    padding: 1.125rem;
    min-height: 160px;
    border-radius: 18px;
  }

  .product-card img {
    width: 48px;
    height: 48px;
    margin-bottom: 0.75rem;
  }

  .product-card h3 {
    font-size: 1rem;
    margin: 0.5rem 0;
  }

  .product-card p {
    font-size: 0.85rem;
    line-height: 1.5;
  }

  .product-badge {
    font-size: 0.75rem;
    padding: 0.25rem 0.6rem;
  }

  .product-arrow {
    font-size: 0.85rem;
    margin-top: 0.5rem;
  }

  /* Stats Bar */
  .stats-bar {
    grid-template-columns: 1fr;
    padding: 1rem;
    gap: 0.5rem;
    border-radius: 20px;
    margin: 1.5rem 0;
  }

  .stats-bar strong {
    font-size: 1.35rem;
  }

  .stats-bar span {
    font-size: 0.85rem;
  }

  /* CTA Section */
  .cta-section {
    padding: 1.5rem 1rem;
    margin: 2rem 0;
  }

  .cta-content h2 {
    font-size: 1.5rem;
  }

  .cta-content p {
    font-size: 0.9rem;
  }
}

/* Product Content Improvements */
.product-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1 1;
}

.product-content h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0b0b0b;
  color: var(--text-strong);
}

.product-content p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #4a4a4a;
  color: var(--text-muted);
}

.product-badge {
  display: inline-block;
  padding: 0.35rem 0.85rem;
  background: rgba(247, 189, 32, 0.15);
  color: #111111;
  color: var(--secondary);
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  width: -webkit-fit-content;
  width: fit-content;
}

.product-arrow {
  margin-top: 1rem;
  font-weight: 600;
  color: #000000;
  color: var(--primary-dark);
  font-size: 0.9rem;
}

/* Prevent horizontal scroll */
@media (max-width: 768px) {
  body {
    overflow-x: hidden;
  }

  .App {
    overflow-x: hidden;
  }

  .page {
    overflow-x: hidden;
    padding-top: 90px !important;
    /* Ensure space for fixed header */
  }

  .hero-grid,
  .product-grid,
  .stats-bar,
  .calculator-block,
  .steps-grid,
  .offering-grid {
    width: 100%;
    max-width: 100%;
  }
}

/* ============================================
   MOBILE PAGE SYNC & OPTIMIZATION
   ============================================ */

/* Ensure all pages have proper spacing for fixed header */
.page {
  padding-top: 100px;
  min-height: 100vh;
}

@media (max-width: 900px) {
  .page {
    padding-top: 90px;
  }
}

@media (max-width: 640px) {
  .page {
    padding-top: 85px;
  }
}

/* Global mobile card & background sync */
@media (max-width: 768px) {

  /* Ensure all hero sections have consistent styling */
  [class*="-hero"],
  [class*="hero-"] {
    margin: 1rem 0 2rem !important;
    padding: 2rem 1.5rem !important;
    border-radius: 24px !important;
  }

  /* Ensure all section cards are consistent */
  [class*="-section"],
  [class*="section-"] {
    padding: 2rem 1.5rem;
    border-radius: 20px;
  }

  /* Ensure all content cards are consistent */
  [class*="-card"],
  [class*="card-"] {
    border-radius: 18px !important;
  }

  /* Full width buttons on mobile */
  .hero-cta .primary-btn,
  .hero-cta .ghost-btn,
  [class*="cta"] .primary-btn,
  [class*="cta"] .ghost-btn {
    width: 100%;
    justify-content: center;
    display: flex;
  }

  /* Consistent section heading sizes */
  .section-heading h2,
  [class*="-section"] h2 {
    font-size: clamp(1.6rem, 4vw, 2.2rem) !important;
  }

  /* Consistent eyebrow sizes */
  .eyebrow,
  [class*="eyebrow"] {
    font-size: 0.75rem !important;
  }

  /* Grid mobile optimization */
  [class*="-grid"],
  [class*="grid-"] {
    grid-template-columns: 1fr !important;
    gap: 1.25rem !important;
  }

  /* Ensure no overflow on any container */
  * {
    max-width: 100%;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}

/* Small mobile adjustments */
@media (max-width: 480px) {
  .page {
    width: min(1280px, 94vw) !important;
    padding-top: 80px;
  }

  [class*="-hero"],
  [class*="hero-"] {
    padding: 1.5rem 1rem !important;
    border-radius: 20px !important;
  }

  .section-heading h2,
  [class*="-section"] h2 {
    font-size: 1.5rem !important;
  }

  .primary-btn,
  .ghost-btn {
    font-size: 0.9rem;
    padding: 0.75rem 1.5rem;
  }
}

/* Ensure proper background colors everywhere */
@media (max-width: 768px) {
  body {
    background: linear-gradient(135deg,
        rgba(255, 251, 234, 0.4) 0%,
        rgba(255, 248, 225, 0.3) 25%,
        rgba(255, 243, 214, 0.2) 50%,
        rgba(255, 237, 196, 0.3) 75%,
        rgba(255, 232, 161, 0.4) 100%) !important;
  }
}

/* ============================================
   COMPREHENSIVE DEVICE OPTIMIZATION
   ============================================ */

/* Tablet Specific (iPad, tablets) */
@media (min-width: 769px) and (max-width: 1024px) {
  .page {
    width: min(1280px, 92vw);
  }

  /* Optimize grids for tablet */
  [class*="-grid"]:not(.form-grid),
  [class*="grid-"]:not(.form-grid) {
    grid-template-columns: repeat(2, 1fr) !important;
  }

  /* Form grids stay single column on tablet for better UX */
  .form-grid {
    grid-template-columns: 1fr !important;
  }
}

/* Large Mobile / Small Tablet (iPhone Pro Max, small tablets) */
@media (min-width: 481px) and (max-width: 768px) {
  .page {
    width: 100%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  /* Ensure touch targets are at least 44px */
  button,
  a,
  input,
  select,
  textarea {
    min-height: 44px;
  }
}

/* Small Mobile (iPhone SE, small phones) */
@media (max-width: 480px) {
  .page {
    width: 100% !important;
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-top: 80px;
  }

  /* Reduce font sizes slightly for small screens */
  html {
    font-size: 15px;
  }

  /* Adjust Hero Spacing */
  [class*="-hero"],
  [class*="hero-"] {
    padding: 1.5rem 1rem !important;
    border-radius: 20px !important;
  }

  .hero-content h1 {
    font-size: 2rem !important;
  }

  /* Ensure buttons are easily tappable */
  .primary-btn,
  .ghost-btn,
  button {
    min-height: 48px;
    padding: 0.875rem 1.5rem;
    width: 100%;
    justify-content: center;
    display: flex;
    align-items: center;
  }

  /* Full width tables with scroll */
  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
}

/* Landscape Mode Optimization */
@media (max-height: 500px) and (orientation: landscape) {
  .page {
    padding-top: 70px;
  }

  [class*="-hero"],
  [class*="hero-"] {
    padding: 1.5rem 2rem !important;
  }

  /* Reduce vertical spacing in landscape */
  section {
    margin: 2rem 0;
  }
}

/* High DPI / Retina Displays */
@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 192dpi) {

  /* Ensure images are sharp on retina displays */
  img {
    image-rendering: -webkit-optimize-contrast;
    image-rendering: crisp-edges;
  }
}

/* Touch Device Optimization */
@media (hover: none) and (pointer: coarse) {

  /* Larger touch targets for touch devices */
  a,
  button,
  input,
  select {
    min-height: 44px;
    min-width: 44px;
  }

  /* Remove hover effects on touch devices */
  *:hover {
    transform: none !important;
  }

  /* But keep active states */
  *:active {
    opacity: 0.8;
  }
}

/* Safe Area for Devices with Notches (iPhone X, etc.) */
@supports (padding: max(0px)) {
  .page {
    padding-left: max(1rem, env(safe-area-inset-left)) !important;
    padding-right: max(1rem, env(safe-area-inset-right)) !important;
  }

  .fibe-header {
    padding-left: max(1rem, env(safe-area-inset-left));
    padding-right: max(1rem, env(safe-area-inset-right));
  }
}

/* Ensure Carousel Visibility on Mobile */
@media (max-width: 768px) {
  .hero-visual {
    display: flex !important;
    width: 100%;
    margin-top: 2rem;
    position: relative;
    z-index: 1;
  }

  .hero-carousel {
    display: block !important;
    width: 100% !important;
    height: 300px !important;
    opacity: 1 !important;
    visibility: visible !important;
    overflow: hidden;
    position: relative;
    background: rgba(255, 255, 255, 0.5);
    /* Placeholder background */
  }

  .carousel-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .carousel-track {
    width: 100%;
    height: 100%;
  }

  /* ===== Landing hero - responsive adjustments ===== */
  @media (max-width: 900px) {
    .hero-block {
      padding: 1.5rem;
      border-radius: 20px;
    }

    .hero-grid {
      grid-template-columns: 1fr;
      gap: 1.25rem;
      align-items: start;
    }

    .hero-content h1 {
      font-size: clamp(1.6rem, 6vw, 2.4rem);
      line-height: 1.15;
      margin-bottom: 0.75rem;
    }

    .hero-content p {
      font-size: 0.98rem;
    }

    .hero-visual {
      order: 2;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .hero-carousel {
      height: auto !important;
      min-height: 180px;
    }

    .carousel-image {
      max-width: 420px;
      width: 100%;
      height: auto;
      border-radius: 12px;
    }

    .hero-cta {
      justify-content: center;
    }

    .hero-badges {
      display: flex;
      justify-content: center;
      gap: 0.75rem;
      flex-wrap: wrap;
    }
  }

  @media (max-width: 480px) {
    .hero-block {
      padding: 1rem;
      border-radius: 14px;
    }

    .hero-content h1 {
      font-size: clamp(1.4rem, 7.5vw, 1.9rem);
    }

    .carousel-image {
      max-width: 320px;
    }
  }
}

/* Prevent zoom on input focus (iOS) */
@media (max-width: 768px) {

  input[type="text"],
  input[type="email"],
  input[type="tel"],
  input[type="number"],
  input[type="date"],
  select,
  textarea {
    font-size: 16px !important;
  }
}

/* Ensure smooth scrolling on all devices */
html {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  background: #D4A017;
  min-height: 100vh;
}

/* Optimize for print */
@media print {

  .fibe-header,
  .site-footer,
  .primary-btn,
  .ghost-btn,
  nav,
  [class*="cta"] {
    display: none !important;
  }

  .page {
    padding-top: 0 !important;
  }

  * {
    background: white !important;
    color: black !important;
  }
}

/* Accessibility - Reduced Motion */
@media (prefers-reduced-motion: reduce) {

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* Final Overflow Prevention */
* {
  box-sizing: border-box;
}

html,
body {
  overflow-x: hidden;
  width: 100%;
  position: relative;
}

.page,
section,
div {
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

/* Ensure all images are responsive */
img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* Ensure iframes are responsive */
iframe {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;;EAE1B,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;;EAEzB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;;EAE3B,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;;EAErB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;;EAEvB,YAAY;EACZ,qCAAqC;EACrC,uCAAuC;;EAEvC,YAAY;EACZ,iDAAiD;EACjD,mDAAmD;;EAEnD,iCAAiC;;EAEjC,8DAA8D;EAC9D;;;mBAGiB;;EAEjB,oCAAoC;EACpC;;;mCAGiC;;EAEjC,mDAAmD;EACnD;;;;;mBAKiB;;EAEjB,mDAAmD;EACnD;;;;;;mBAMiB;;EAEjB,gEAAgE;EAChE;;;mBAGiB;;EAEjB,0BAA0B;;EAE1B,yCAAyC;EACzC;;;gCAG8B;;EAE9B,yCAAyC;EACzC;;;;kCAIgC;;EAEhC,gCAAgC;EAChC;;;mBAGiB;;EAEjB,2BAA2B;EAC3B;;;mBAGiB;;EAEjB,iCAAiC;EACjC;;;kCAGgC;;EAEhC,+DAA+D;EAC/D,2GAA2G;EAC3G,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;;;EAGE,kBAAkB;AACpB;;AAEA;;;;EAIE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;EACtB,qBAAa;UAAb,aAAa;AACf;;AAEA,0EAA0E;AAC1E;;;;;EAKE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;;;;EAUE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,4CAA4C;AAC5C;;;;;;EAME,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA,6CAA6C;AAC7C;;;EAGE,eAAe;AACjB;;AAEA,sDAAsD;AACtD;;;;EAIE,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;;EAEE;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;;AAGA;EACE,4EAA4E;EAC5E,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAyB;EAAzB,yBAAyB;EACzB,4EAA4E;EAC5E,4BAA4B;EAC5B,iBAAiB;EACjB,mCAAmC;EACnC,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,4EAA4E;AAC9E;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,4EAA4E;EAC5E,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,4EAA4E;EAC5E,4BAA4B;EAC5B,0DAA0D;EAC1D,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,4BAA4B;EAC5B,uDAAuD;AACzD;;AAEA,oDAAoD;AACpD;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,cAAuB;EAAvB,uBAAuB;EACvB,gDAA8B;EAA9B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B;;;mBAAwC;EAAxC,wCAAwC;EACxC,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,cAAuB;EAAvB,uBAAuB;EACvB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,qBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,cAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAA4B;EAA5B,4BAA4B;EAC5B,cAAqB;EAArB,qBAAqB;EACrB,yBAAqC;EAArC,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4EAA4E;EAC5E,mBAAmB;EACnB,aAAa;EACb,2DAA2D;EAC3D,kBAAkB;EAClB,eAAe;EACf,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE;;;mBAAgC;EAAhC,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mGAAmG;EACnG,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb;;;gCAAgC;EAAhC,gCAAgC;EAChC,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,mBAA+B;EAA/B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,cAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,mBAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAA4B;EAA5B,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,6CAAyC;EAAzC,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,WAAW;IACX,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;EACnB,aAAa;EACb,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAA+B;EAA/B,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,4EAA4E;EAC5E,wCAAoC;EAApC,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAA+B;EAA/B,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,iBAAY;EAAZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,qDAAqD;EACrD,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAA+B;EAA/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,gCAAgC;EAChC,4EAA4E;EAC5E,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,gBAAW;EAAX,WAAW;EACX,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAA+B;EAA/B,+BAA+B;EAC/B,qBAAiC;EAAjC,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAA+B;EAA/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,cAAyB;EAAzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAyB;EAAzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,8CAA8B;EAA9B,8BAA8B;EAC9B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,cAAuB;EAAvB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8CAA8B;EAA9B,8BAA8B;EAC9B,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,4CAAwC;EAAxC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8B;EAA9B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,cAAuB;EAAvB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0BAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,cAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,4EAA4E;EAC5E,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,+EAA+E;EAC/E,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,yBAAyB;AAC3B;;;;AAIA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;;;6CAG2C;EAC3C,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,kBAAkB;EAClB,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,wCAAoC;EAApC,oCAAoC;EACpC,wBAAwB;EACxB,mBAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,wCAAoC;EAApC,oCAAoC;EACpC,+BAA+B;EAC/B,cAAuB;EAAvB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAwE;EAAxE,wEAAwE;EACxE,yBAAyB;EACzB,cAAuB;EAAvB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAW;EAAX,WAAW;EACX,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qDAAwE;EAAxE,wEAAwE;EACxE,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,0BAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,gBAAW;EAAX,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,mBAA+B;EAA/B,+BAA+B;EAC/B,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,0BAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,8DAA8D;EAC9D,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,2DAA2D;EAC3D;;6CAE2C;EAC3C,cAAuB;EAAvB,uBAAuB;EACvB,8CAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4FAA4F;EAC5F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAS;EAAT,SAAS;EACT,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,gBAAW;EAAX,WAAW;EACX,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;EACZ,kBAAkB;EAClB,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;;;6CAG2C;EAC3C,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,mBAAmB;EACnB,8CAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,mBAA0B;EAA1B,0BAA0B;EAC1B,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,iBAAY;EAAZ,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,gBAAW;EAAX,WAAW;EACX,kBAAkB;EAClB,8CAA8B;EAA9B,8BAA8B;EAC9B,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6FAA6F;EAC7F,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAwB;EAAxB,wBAAwB;EACxB,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,8CAA8B;EAA9B,8BAA8B;EAC9B,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,mBAA+B;EAA/B,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE;;;6CAG2C;EAC3C,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;;;6CAG2C;EAC3C,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,8CAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,8CAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,8EAA8E;EAC9E,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4EAA4E;EAC5E,WAAW;EACX,SAAS;AACX;;AAEA;EACE;;;6CAG2C;EAC3C,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,8CAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;EACtB,wCAAoC;EAApC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8EAA8E;EAC9E,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4EAA4E;EAC5E,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,wCAAoC;EAApC,oCAAoC;EACpC,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,oBAAoB;EACpB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8B;EAA9B,8BAA8B;EAC9B,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,mBAA+B;EAA/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAA4B;EAA5B,4BAA4B;EAC5B,qBAA8B;EAA9B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,wCAAoC;EAApC,oCAAoC;EACpC,uBAAuB;EACvB,mBAA+B;EAA/B,+BAA+B;EAC/B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,qFAAqF;EACrF,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAW;EAAX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,0BAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,mBAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAwB;EAAxB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yCAAqC;EAArC,qCAAqC;EACrC,qBAAqB;EACrB,mBAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,gBAAW;EAAX,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6FAA6F;EAC7F,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,cAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,mBAA+B;EAA/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,mBAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,mBAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,cAAuB;EAAvB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;EACZ,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,gBAAW;EAAX,WAAW;EACX,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,cAAwB;EAAxB,wBAAwB;EACxB,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,cAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;EACZ,mBAAmB;EACnB,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,8CAA8C;EAC9C,aAAa;EACb,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,mBAA+B;EAA/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4FAA4F;EAC5F,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,gBAAW;EAAX,WAAW;EACX,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,gBAAW;EAAX,WAAW;EACX,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,mBAA0B;EAA1B,0BAA0B;EAC1B,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,WAAW;IACX,qFAAqF;IACrF,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,mBAA+B;EAA/B,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0BAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4FAA4F;EAC5F,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;EAClC,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,wCAAoC;EAApC,oCAAoC;EACpC,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,cAAyB;EAAzB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,gBAAgB;EAChB,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8B;EAA9B,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4FAA4F;EAC5F,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;EACrD,0CAA0C;AAC5C;;AAEA;EACE,qDAAqD;EACrD,oCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAA0B;EAA1B,0BAA0B;EAC1B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAuB;EAAvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,+BAA+B;EAC/B,iBAAY;EAAZ,YAAY;EACZ,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAA+B;EAA/B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8C;EAC9C,sBAAsB;EACtB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAA0B;EAA1B,0BAA0B;EAC1B,cAAuB;EAAvB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,cAAS;EAAT,SAAS;EACT,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAwE;EAAxE,wEAAwE;EACxE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,4EAA4E;EAC5E,cAAkC;EAAlC,kCAAkC;EAClC,0DAA0D;EAC1D,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;mBAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gCAAgC;EAChC,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,cAAiC;EAAjC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,yCAAyC;EACzC,qDAAqD;EACrD,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B;;;;;mBAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,qBAAgB;EAAhB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,cAA6B;EAA7B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAiC;EAAjC,iCAAiC;EACjC,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;;EAEE,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,yCAAyC;EACzC,iBAAiB;EACjB,iCAAiC;EACjC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,cAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,cAA6B;EAA7B,6BAA6B;EAC7B,gBAAgB;EAChB,gDAAgD;EAChD,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAiC;EAAjC,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAiC;EAAjC,iCAAiC;EACjC,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;EACxB;;EAEA;;;IAGE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB;;6CAE2C;EAC3C,cAAuB;EAAvB,uBAAuB;EACvB,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,wCAAoC;EAApC,oCAAoC;EACpC,+BAA+B;EAC/B,cAAuB;EAAvB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,qDAAwE;EAAxE,wEAAwE;EACxE,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAA0B;EAA1B,0BAA0B;EAC1B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAoC;EAApC,oCAAoC;EACpC,mBAA0B;EAA1B,0BAA0B;EAC1B,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,8CAA8B;EAA9B,8BAA8B;EAC9B,aAAa;EACb,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,cAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,mBAA+B;EAA/B,+BAA+B;EAC/B,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAwB;EAAxB,wBAAwB;EACxB,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,mBAA+B;EAA/B,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,qBAAqB;AACvB;;;AAGA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;IACf,QAAQ;IACR,SAAS;IACT,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,iBAAY;IAAZ,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;;;;;IAME,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,YAA4B;IAA5B,cAA4B;IAA5B,8BAA4B;IAC5B,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,mBAA+B;EAA/B,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,cAAS;EAAT,SAAS;EACT,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,mBAA+B;EAA/B,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,gBAAW;EAAX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAwE;EAAxE,wEAAwE;EACxE,cAAuB;EAAvB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;;;6CAG2C;EAC3C,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,kBAAkB;EAClB,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAA0B;EAA1B,0BAA0B;EAC1B,wCAAoC;EAApC,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAA0B;EAA1B,0BAA0B;EAC1B,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,iBAAY;EAAZ,YAAY;EACZ,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,mBAA0B;EAA1B,0BAA0B;EAC1B,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,6CAA6C;EAC7C,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,gBAAW;EAAX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAA0B;EAA1B,0BAA0B;EAC1B,cAAuB;EAAvB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,iBAAY;EAAZ,YAAY;EACZ,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;EACvB,mBAA+B;EAA/B,+BAA+B;AACjC;;AAEA;EACE,qBAA8B;EAA9B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qBAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAwB;EAAxB,wBAAwB;EACxB,aAAa;EACb,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,uFAAuF;EACvF,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,mBAA+B;EAA/B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,iBAAY;EAAZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,8CAA8C;EAC9C,kDAAkD;AACpD;;AAEA;EACE,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,cAAyB;EAAzB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,6CAA6C;EAC7C,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,mBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,mBAA+B;EAA/B,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAA+B;EAA/B,+BAA+B;EAC/B,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,mBAA+B;EAA/B,+BAA+B;EAC/B,mBAAmB;EACnB,wCAAoC;EAApC,oCAAoC;EACpC,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,0EAA0E;EAC1E,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;;EAEE;;IAEE,mCAAmC;EACrC;;EAEA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,cAAS;EAAT,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;EAC9C,wCAAwC;AAC1C;;AAEA;;EAEE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;EAC1C,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,qBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,0DAA0D;EAC1D,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;mBAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAS;EAAT,SAAS;EACT,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,iBAAY;EAAZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,4BAA4B;EAC5B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;EAChD,qBAA4B;EAA5B,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAA0B;EAA1B,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,0EAA0E;EAC1E,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,gFAAgF;EAChF,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,8DAA8D;EAC9D,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,aAAa;EACb,gCAAgC;EAChC,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAwB;EAAxB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,mCAAmC;EACnC,yCAAyC;EACzC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAW;EAAX,WAAW;EACX,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAuB;EAAvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qDAAqD;EACrD,mBAAmB;EACnB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAwB;EAAxB,wBAAwB;EACxB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;;;;;mBAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,qDAAqD;EACrD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA,yBAAyB;AACzB;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,sDAAsD;EACtD,6CAA6C;AAC/C;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,6CAA6C;AAC/C;;AAEA;;EAEE;;IAEE,qCAAqC;EACvC;;EAEA;IACE,wCAAwC;EAC1C;AACF;;AAEA,wBAAwB;AACxB;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;EAC/C,qDAAqD;AACvD;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,wDAAwD;EACxD,+CAA+C;AACjD;;AAEA;;EAEE;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;+CAE+C;;AAE/C,uBAAuB;AACvB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB;;;qCAGmC;EACnC,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mCAAmC;EACnC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,cAAuB;EAAvB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;EAClB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAwB;EAAxB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAoC;EAApC,oCAAoC;EACpC,6EAA6E;EAC7E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb;;;gCAAgC;EAAhC,gCAAgC;EAChC,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8B;EAA9B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,cAAS;EAAT,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,yCAAyC;EACzC,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,wFAAwF;EACxF,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,wCAAoC;EAApC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,cAAuB;EAAvB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,gBAAW;EAAX,WAAW;AACb;;AAEA;;EAEE,6DAA6D;EAC7D,mBAAmB;EACnB,oBAAoB;EACpB,wCAAoC;EAApC,oCAAoC;EACpC,8CAA8C;EAC9C,qDAAqD;AACvD;;AAEA;;EAEE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;EACpB,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,cAAuB;EAAvB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8B;EAA9B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;;mBAAmC;EAAnC,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAuB;EAAvB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,cAA0B;EAA1B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,wCAAoC;EAApC,oCAAoC;EACpC,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8B;EAA9B,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,+CAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAyB;EAAzB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,eAAe;EACf,+CAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,wCAAoC;EAApC,oCAAoC;EACpC,kBAAkB;EAClB,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8B;EAA9B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAyB;EAAzB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0DAA0D;EAC1D,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,2DAA2D;EAC3D,cAAS;EAAT,SAAS;EACT,wCAAoC;EAApC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAwB;EAAxB,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAyB;EAAzB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAA0B;EAA1B,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB;;;mBAAgC;EAAhC,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,+BAA+B;IAC/B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;;iDAEiD;;AAEjD,6CAA6C;AAC7C;EACE,gDAAgD;EAChD,mCAA2B;UAA3B,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;AAClD;;AAEA,sCAAsC;AACtC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,2DAA2D;IAC3D,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,6BAA6B;AAC7B;;EAEE,iBAAiB;EACjB;IACE,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,qBAAqB;EACrB;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iBAAiB;EACjB;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA,cAAc;EACd;IACE,qCAAqC;IACrC,gBAAgB;IAChB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,qBAAqB;EACrB;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA,cAAc;EACd;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,2DAA2D;IAC3D,SAAS;EACX;;EAEA,gBAAgB;EAChB;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;EACf;;EAEA,iBAAiB;EACjB;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;;EAEE,mBAAmB;EACnB;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,iBAAiB;EACjB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,YAAY;EACZ;;IAEE,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;IACf,wBAAwB;EAC1B;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,kBAAkB;EAClB;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA,cAAc;EACd;IACE,0BAA0B;IAC1B,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,gBAAgB;EAChB;IACE,oBAAoB;IACpB,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAwB;EAAxB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oCAAoC;EACpC,cAAuB;EAAvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0BAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAA0B;EAA1B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;EACpC;;EAEA;;;;;;IAME,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;;iDAEiD;;AAEjD,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,yCAAyC;AACzC;;EAEE,qDAAqD;EACrD;;IAEE,8BAA8B;IAC9B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA,4CAA4C;EAC5C;;IAEE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA,4CAA4C;EAC5C;;IAEE,8BAA8B;EAChC;;EAEA,iCAAiC;EACjC;;;;IAIE,WAAW;IACX,uBAAuB;IACvB,aAAa;EACf;;EAEA,qCAAqC;EACrC;;IAEE,gDAAgD;EAClD;;EAEA,6BAA6B;EAC7B;;IAEE,6BAA6B;EAC/B;;EAEA,6BAA6B;EAC7B;;IAEE,qCAAqC;IACrC,uBAAuB;EACzB;;EAEA,wCAAwC;EACxC;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,mCAAmC;IACnC,iBAAiB;EACnB;;EAEA;;IAEE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;;IAEE,4BAA4B;EAC9B;;EAEA;;IAEE,iBAAiB;IACjB,uBAAuB;EACzB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE;;;;;iDAK6C;EAC/C;AACF;;AAEA;;iDAEiD;;AAEjD,oCAAoC;AACpC;EACE;IACE,wBAAwB;EAC1B;;EAEA,8BAA8B;EAC9B;;IAEE,gDAAgD;EAClD;;EAEA,0DAA0D;EAC1D;IACE,qCAAqC;EACvC;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,WAAW;IACX,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA,2CAA2C;EAC3C;;;;;IAKE,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA,iDAAiD;EACjD;IACE,eAAe;EACjB;;EAEA,wBAAwB;EACxB;;IAEE,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,uCAAuC;EACvC;;;IAGE,gBAAgB;IAChB,wBAAwB;IACxB,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,mBAAmB;EACrB;;EAEA,kCAAkC;EAClC;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,iBAAiB;EACnB;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA,yCAAyC;EACzC;IACE,cAAc;EAChB;AACF;;AAEA,+BAA+B;AAC/B;;;EAGE,+CAA+C;EAC/C;IACE,0CAA0C;IAC1C,4BAA4B;EAC9B;AACF;;AAEA,8BAA8B;AAC9B;;EAEE,2CAA2C;EAC3C;;;;IAIE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,0CAA0C;EAC1C;IACE,0BAA0B;EAC5B;;EAEA,2BAA2B;EAC3B;IACE,YAAY;EACd;AACF;;AAEA,wDAAwD;AACxD;EACE;IACE,6DAA6D;IAC7D,+DAA+D;EACjE;;EAEA;IACE,kDAAkD;IAClD,oDAAoD;EACtD;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,sDAAsD;EACtD;IACE;MACE,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,0BAA0B;MAC1B,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,qCAAqC;MACrC,iBAAiB;MACjB,sBAAsB;IACxB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,QAAQ;MACR,aAAa;MACb,uBAAuB;MACvB,mBAAmB;IACrB;;IAEA;MACE,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,WAAW;MACX,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,uBAAuB;IACzB;;IAEA;MACE,aAAa;MACb,uBAAuB;MACvB,YAAY;MACZ,eAAe;IACjB;EACF;;EAEA;IACE;MACE,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,uCAAuC;IACzC;;IAEA;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA,sCAAsC;AACtC;;EAEE;;;;;;;IAOE,0BAA0B;EAC5B;AACF;;AAEA,2CAA2C;AAC3C;EACE,uBAAuB;EACvB,iCAAiC;EACjC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;;EAEE;;;;;;IAME,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;EACzB;AACF;;AAEA,mCAAmC;AACnC;;EAEE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAEA,8BAA8B;AAC9B;EACE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB","sourcesContent":["/* Fonts imported in public/index.html */\n\n:root {\n  /* Unity Bank Color Scheme - Changed to Black */\n  --primary: #000000;\n  --primary-dark: #000000;\n  --primary-darker: #000000;\n  --primary-light: #000000;\n  --primary-lighter: #000000;\n\n  /* Secondary Colors */\n  --secondary: #111111;\n  --secondary-dark: #000000;\n\n  /* Accent Colors */\n  --accent-gold: #000000;\n  --accent-gold-dark: #000000;\n\n  /* Text Colors */\n  --text-strong: #0b0b0b;\n  --text-muted: #4a4a4a;\n\n  /* Surface Colors */\n  --surface: #ffffff;\n  --surface-alt: #fff8e6;\n  --surface-soft: #fffdf5;\n  --surface-dark: #111111;\n\n  /* Borders */\n  --border-soft: rgba(17, 17, 17, 0.08);\n  --border-strong: rgba(17, 17, 17, 0.16);\n\n  /* Shadows */\n  --shadow-soft: 0 25px 65px rgba(17, 17, 17, 0.12);\n  --shadow-gold: 0 20px 50px rgba(247, 189, 32, 0.25);\n\n  /* Premium Multi-Tone Gradients */\n\n  /* Main Background Gradient - Visible Yellow (Light to Dark) */\n  --gradient-background: linear-gradient(to right,\n      #fef3c7 0%,\n      #fde68a 50%,\n      #fbbf24 100%);\n\n  /* Hero Section - Warm yellow glow */\n  --gradient-hero: linear-gradient(to right,\n      rgba(254, 243, 199, 0.3) 0%,\n      rgba(253, 230, 138, 0.3) 50%,\n      rgba(251, 191, 36, 0.3) 100%);\n\n  /* Primary Gradient - Warm orange to peachy coral */\n  --gradient-primary: linear-gradient(135deg,\n      #f7bd20 0%,\n      #f5a623 25%,\n      #f39c21 50%,\n      #f18e1f 75%,\n      #e8a91a 100%);\n\n  /* Accent Gradient - Orange with subtle rose gold */\n  --gradient-accent: linear-gradient(120deg,\n      #f7bd20 0%,\n      #f4ad26 20%,\n      #f19d2b 40%,\n      #ed8f30 60%,\n      #e88132 80%,\n      #d89515 100%);\n\n  /* Sophisticated Dark - Deep blacks with subtle blue undertone */\n  --gradient-dark: linear-gradient(135deg,\n      #1a1a1a 0%,\n      #111111 50%,\n      #0a0a0a 100%);\n\n  /* New Premium Gradients */\n\n  /* Radial glow for cards and highlights */\n  --gradient-glow: radial-gradient(circle at top right,\n      rgba(247, 189, 32, 0.15) 0%,\n      rgba(247, 189, 32, 0.05) 40%,\n      rgba(247, 189, 32, 0) 70%);\n\n  /* Mesh gradient for modern backgrounds */\n  --gradient-mesh: linear-gradient(135deg,\n      rgba(247, 189, 32, 0.1) 0%,\n      rgba(255, 255, 255, 0) 30%,\n      rgba(238, 174, 50, 0.08) 60%,\n      rgba(255, 255, 255, 0) 100%);\n\n  /* Button hover - more vibrant */\n  --gradient-button-hover: linear-gradient(135deg,\n      #faca3d 0%,\n      #f7bd20 50%,\n      #e8a91a 100%);\n\n  /* Subtle card background */\n  --gradient-card: linear-gradient(to right,\n      #FFF9E6 0%,\n      #FFE082 35%,\n      #D4A017 100%);\n\n  /* Premium overlay for sections */\n  --gradient-overlay: linear-gradient(180deg,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(247, 189, 32, 0.03) 50%,\n      rgba(255, 255, 255, 0) 100%);\n\n  /* Typography - Poppins as primary font (matching Unity Bank) */\n  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  color: var(--text-strong);\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* ===== Global responsive utilities ===== */\nhtml,\nbody,\n.App {\n  overflow-x: hidden;\n}\n\nimg,\npicture,\nvideo,\niframe {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* prevent very long words or unbroken content from causing horizontal scroll */\n* {\n  word-wrap: break-word;\n  -ms-word-break: break-word;\n  word-break: break-word;\n  hyphens: auto;\n}\n\n/* ===== Generic card/grid/container fixes (improve mobile layout) ===== */\n.container,\n.page,\n.footer-inner,\n.header-shell,\n.main-content {\n  box-sizing: border-box;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.card,\n.value-card,\n.stat-card-new,\n.document-card,\n.feature-bento-card,\n.product-card,\n.office-card,\n.step-card,\n.calc-side-card,\n.feature-bento-business {\n  width: 100% !important;\n  max-width: 100% !important;\n}\n\n/* make common grids more fluid by default */\n[class*=\"-grid\"],\n.grid,\n.cards-grid,\n.feature-grid,\n.offering-grid,\n.testimonial-track {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n/* Modals and overlays should be responsive */\n.modal,\n.dialog,\n.drawer {\n  max-width: 95vw;\n}\n\n/* Inputs - prevent iOS zoom and ensure legible size */\ninput,\ntextarea,\nselect,\nbutton {\n  font-size: 16px;\n}\n\n/* small screens: ensure stacked layout for complex grids */\n@media (max-width: 900px) {\n\n  [class*=\"-grid\"],\n  .grid {\n    grid-template-columns: 1fr !important;\n  }\n\n  .header-shell,\n  .footer-inner {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n}\n\n\nhtml {\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  background-attachment: fixed;\n  min-height: 100vh;\n}\n\nbody {\n  margin: 0;\n  font-family: inherit;\n  color: var(--text-strong);\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  background-attachment: fixed;\n  min-height: 100vh;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* Performance optimizations */\n  text-rendering: optimizeSpeed;\n  -webkit-tap-highlight-color: transparent;\n}\n\nbody.nav-open {\n  overflow: hidden;\n}\n\na {\n  color: inherit;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n}\n\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-top: 80px;\n}\n\n@media (max-width: 640px) {\n  .main-content {\n    padding-top: 70px;\n  }\n}\n\n.page {\n  /* Full width background like footer */\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding-bottom: 0;\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  background-attachment: fixed;\n  min-height: calc(100vh - 80px);\n}\n\n/* Center content inside pages */\n.page>section,\n.page>div:not(.hero-block):not(.admin-dashboard-layout) {\n  max-width: 1240px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 3vw;\n  padding-right: 3vw;\n}\n\n.fibe-home {\n  padding-top: 1.5rem;\n  min-height: 100vh;\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  background-attachment: fixed;\n  /* Override .page width to extend full width like footer */\n  width: 100% !important;\n  max-width: none !important;\n  margin: 0 !important;\n  padding-bottom: 0 !important;\n  /* Remove bottom padding to eliminate gap with footer */\n}\n\n/* Container for centered content inside fibe-home */\n.fibe-home>section,\n.fibe-home>.hero-block {\n  max-width: 1240px;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 3vw;\n  padding-right: 3vw;\n}\n\n.eyebrow {\n  display: inline-flex;\n  align-items: center;\n  text-transform: uppercase;\n  letter-spacing: 0.15em;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: var(--primary-dark);\n}\n\n.primary-btn,\n.ghost-btn {\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.95rem;\n  padding: 0.75rem 1.75rem;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.3s ease;\n}\n\n.primary-btn {\n  background: var(--gradient-primary);\n  color: var(--secondary);\n  box-shadow: var(--shadow-gold);\n  text-decoration: none;\n}\n\n.primary-btn:hover {\n  transform: translateY(-2px);\n  background: var(--gradient-button-hover);\n  box-shadow: 0 25px 60px rgba(246, 183, 9, 0.928);\n}\n\n.ghost-btn {\n  background: transparent;\n  color: var(--secondary);\n  border: 2px solid rgba(247, 189, 32, 0.4);\n  text-decoration: none;\n}\n\n.ghost-btn:hover {\n  transform: translateY(-2px);\n  background: rgba(247, 189, 32, 0.08);\n  border-color: var(--primary);\n}\n\n.primary-link {\n  color: var(--primary-dark);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.hero-block {\n  margin-top: 2rem;\n  padding: 3rem;\n  border-radius: 40px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 26px 80px rgba(15, 23, 42, 0.12);\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n}\n\n.hero-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n.hero-content h1 {\n  font-size: clamp(2.4rem, 4vw, 3.6rem);\n  line-height: 1.1;\n  margin: 0.4rem 0 1rem;\n}\n\n.hero-content h1 span {\n  color: var(--primary-dark);\n}\n\n.hero-content p {\n  font-size: 1.05rem;\n  line-height: 1.7;\n  color: var(--text-muted);\n}\n\n.hero-cta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin: 1.5rem 0;\n}\n\n.hero-form {\n  background: rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(10px);\n  padding: 1.5rem;\n  border-radius: 24px;\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.12);\n}\n\n.hero-form label {\n  display: block;\n  font-weight: 600;\n  margin-bottom: 0.8rem;\n}\n\n.hero-form-row {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.hero-form input {\n  flex: 1;\n  min-width: 200px;\n  border-radius: 16px;\n  border: 1px solid var(--border-soft);\n  padding: 0.9rem 1.1rem;\n  font-size: 1rem;\n}\n\n.hero-form button {\n  background: var(--secondary);\n  color: var(--primary);\n  border: 1px solid var(--primary-dark);\n  border-radius: 16px;\n  padding: 0.9rem 1.5rem;\n  font-weight: 600;\n}\n\n.form-success {\n  margin: 0.75rem 0 0;\n  font-size: 0.95rem;\n  color: #0f9d58;\n}\n\n.hero-badges {\n  margin-top: 1rem;\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.hero-visual {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.landing-carousel {\n  position: relative;\n  width: 100%;\n  height: 450px;\n  border-radius: 24px;\n  overflow: hidden;\n  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.15);\n}\n\n.landing-carousel-slide {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  transition: opacity 0.8s ease-in-out;\n}\n\n.landing-carousel-slide.active {\n  opacity: 1;\n}\n\n.landing-carousel-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 24px;\n}\n\n.landing-carousel-dots {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 10px;\n  z-index: 10;\n}\n\n.landing-carousel-dots .dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n  border: 2px solid rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n}\n\n.landing-carousel-dots .dot.active {\n  background: #ffffff;\n  width: 14px;\n  height: 14px;\n}\n\n.landing-carousel-dots .dot:hover {\n  background: rgba(255, 255, 255, 0.8);\n  transform: scale(1.1);\n}\n\n.hero-insight {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 32px;\n  padding: 1.75rem;\n  box-shadow: 0 35px 65px rgba(15, 23, 42, 0.12);\n  position: relative;\n  backdrop-filter: blur(10px);\n}\n\n.hero-insight.primary {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.hero-pill {\n  display: inline-flex;\n  padding: 0.35rem 0.9rem;\n  border-radius: 999px;\n  background: rgba(247, 189, 32, 0.18);\n  color: var(--secondary);\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.hero-snapshot h3 {\n  font-size: 2.2rem;\n  margin: 0.4rem 0 1rem;\n}\n\n.hero-snapshot ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  color: var(--text-muted);\n  line-height: 1.8;\n}\n\n.hero-note {\n  margin-top: 1.5rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n.hero-mini-cards {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n.hero-mini-cards div {\n  background: rgba(255, 255, 255, 0.25);\n  backdrop-filter: blur(10px);\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n  padding: 0.9rem 1.1rem;\n  min-height: 90px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.hero-mini-cards span {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.stats-bar {\n  margin: 3rem 0;\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  border-radius: 24px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  text-align: center;\n  padding: 1.5rem;\n  gap: 1rem;\n}\n\n.stats-bar strong {\n  display: block;\n  font-size: 1.8rem;\n}\n\n.section-block {\n  margin: 4rem 0;\n}\n\n.section-heading {\n  text-align: center;\n  max-width: 760px;\n  margin: 0 auto 3rem;\n}\n\n.section-heading h2 {\n  margin: 0.75rem 0;\n  font-size: clamp(2rem, 3vw, 2.8rem);\n}\n\n.section-heading p {\n  color: var(--text-muted);\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n}\n\n.product-card {\n  background: var(--gradient-card);\n  border-radius: 24px;\n  padding: 1.5rem;\n  border: 1px solid transparent;\n  text-decoration: none;\n  color: inherit;\n  min-height: 220px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease, background 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.product-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 200px;\n  height: 200px;\n  background: var(--gradient-glow);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.product-card img {\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n  margin-bottom: 1rem;\n}\n\n.product-card:hover {\n  border-color: rgba(247, 189, 32, 0.4);\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-soft);\n}\n\n.product-card:hover::before {\n  opacity: 1;\n}\n\n.product-card p {\n  color: var(--text-muted);\n}\n\n.steps-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n}\n\n.steps-grid article {\n  background: #fff;\n  padding: 1.75rem;\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  position: relative;\n}\n\n.step-index {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  background: rgba(247, 189, 32, 0.18);\n  color: var(--secondary);\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.calculator-block {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2.5rem;\n  align-items: flex-start;\n}\n\n.calculator-copy {\n  background: #fff;\n  border-radius: 28px;\n  padding: 2rem;\n  border: 1px solid var(--border-soft);\n}\n\n.calculator-tools {\n  margin-top: 2rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.tool-card {\n  background: var(--surface-soft);\n  border-radius: 18px;\n  padding: 1.25rem;\n  text-decoration: none;\n  color: inherit;\n  border: 1px solid transparent;\n  transition: border-color 0.2s ease, transform 0.2s ease;\n}\n\n.tool-card:hover {\n  border-color: rgba(247, 189, 32, 0.45);\n  transform: translateY(-3px);\n}\n\n.tool-card p {\n  color: var(--text-muted);\n}\n\n.tool-card span {\n  color: var(--primary-dark);\n  font-weight: 600;\n}\n\n.calculator-widget .loan-calculator {\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-soft);\n}\n\n.loan-calculator {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  padding: 2rem;\n}\n\n.loan-calculator__inputs {\n  flex: 1.4;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  min-width: 260px;\n}\n\n.slider-field {\n  padding: 1.25rem 1.5rem;\n  border-radius: 22px;\n  border: 1px solid var(--border-soft);\n  background: var(--surface-soft);\n}\n\n.slider-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 0.9rem;\n}\n\n.slider-heading label {\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.value-chip {\n  background: #fff;\n  border-radius: 12px;\n  padding: 0.4rem 0.95rem;\n  border: 1px solid var(--border-soft);\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.slider-field input[type='range'] {\n  width: 100%;\n  accent-color: var(--primary);\n}\n\n.range-extents {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-top: 0.35rem;\n}\n\n.loan-calculator__summary {\n  flex: 1;\n  min-width: 260px;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 2rem;\n  background: linear-gradient(180deg, #fffef7 0%, #fff8df 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.emi-highlight {\n  background: var(--secondary);\n  border-radius: 20px;\n  padding: 1.5rem;\n  text-align: center;\n  color: var(--primary);\n}\n\n.emi-highlight p {\n  margin: 0 0 0.4rem;\n  font-weight: 600;\n  color: var(--surface);\n}\n\n.emi-highlight strong {\n  font-size: 2rem;\n  color: var(--primary);\n}\n\n.summary-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 1rem;\n  color: var(--text-muted);\n}\n\n.summary-row strong {\n  font-size: 1.1rem;\n  color: var(--text-strong);\n}\n\n.summary-row.total {\n  border-top: 1px dashed var(--border-soft);\n  padding-top: 0.85rem;\n  margin-top: 0.3rem;\n  font-weight: 600;\n  color: var(--text-strong);\n}\n\n.loan-calculator__summary .primary-btn {\n  width: 100%;\n  justify-content: center;\n}\n\n.card-footnote {\n  font-size: 0.82rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* Loan calculator - responsive tweaks */\n@media (max-width: 900px) {\n  .loan-calculator {\n    flex-direction: column;\n    gap: 1rem;\n    padding: 1rem;\n  }\n\n  .loan-calculator__inputs,\n  .loan-calculator__summary {\n    min-width: auto;\n    width: 100%;\n    padding: 1rem;\n  }\n\n  .slider-field {\n    padding: 0.9rem 1rem;\n    border-radius: 14px;\n  }\n\n  .slider-heading label {\n    font-size: 0.95rem;\n  }\n\n  .emi-highlight strong {\n    font-size: 1.6rem;\n  }\n\n  .loan-calculator__summary {\n    border-radius: 18px;\n  }\n\n  .loan-calculator__summary .primary-btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .loan-calculator {\n    padding: 0.75rem;\n  }\n\n  .slider-heading label {\n    font-size: 0.9rem;\n  }\n\n  .emi-highlight strong {\n    font-size: 1.4rem;\n  }\n}\n\n.offerings-block {\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  border-radius: 34px;\n  padding: 3rem;\n  border: 1px solid var(--border-soft);\n}\n\n.offering-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.25rem;\n}\n\n.offering-card {\n  padding: 1.5rem;\n  border-radius: 20px;\n  background: var(--surface-soft);\n  border: 1px solid transparent;\n  text-decoration: none;\n  color: inherit;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  transition: border-color 0.2s ease, transform 0.2s ease;\n}\n\n.offering-card img {\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n}\n\n.offering-card:hover {\n  border-color: rgba(247, 189, 32, 0.4);\n  transform: translateY(-2px);\n}\n\n.offering-card span {\n  display: inline-block;\n  margin-top: 0.5rem;\n  color: var(--primary-dark);\n  font-weight: 600;\n}\n\n.why-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n}\n\n.why-grid article {\n  padding: 1.75rem;\n  border-radius: 24px;\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  border: 1px solid var(--border-soft);\n  min-height: 200px;\n}\n\n.awards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n}\n\n.awards-grid article {\n  padding: 1.5rem;\n  border-radius: 24px;\n  background: var(--surface-soft);\n  border: 1px solid var(--border-soft);\n}\n\n.why-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n  margin: 1rem 0 1.25rem;\n}\n\n.why-metrics div {\n  background: linear-gradient(135deg, #fffdf5, #fff6d6);\n  border: 1px solid var(--border-soft);\n  border-radius: 18px;\n  padding: 1rem;\n  text-align: center;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.08);\n}\n\n.why-metrics strong {\n  display: block;\n  font-size: 1.2rem;\n}\n\n.why-card {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.85rem;\n  align-items: flex-start;\n  padding: 1.5rem;\n  border-radius: 24px;\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  border: 1px solid var(--border-soft);\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.why-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 16px;\n  background: var(--surface-soft);\n  display: grid;\n  place-items: center;\n  font-size: 1.4rem;\n  border: 1px solid var(--border-soft);\n}\n\n.testimonials-block blockquote {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  min-height: 260px;\n}\n\n.testimonial-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.25rem;\n}\n\n.testimonials-carousel {\n  position: relative;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n}\n\n.testimonials-carousel-track {\n  position: relative;\n  min-height: 280px;\n}\n\n.testimonial-card {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0;\n  transform: translateX(20px);\n  transition: all 0.6s ease-in-out;\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 2rem;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 1.5rem;\n  align-items: start;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.testimonial-card.active {\n  opacity: 1;\n  transform: translateX(0);\n  position: relative;\n}\n\n.testimonials-carousel-dots {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 2rem;\n}\n\n.testimonials-carousel-dots .dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(247, 189, 32, 0.3);\n  border: 2px solid rgba(247, 189, 32, 0.5);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  padding: 0;\n}\n\n.testimonials-carousel-dots .dot.active {\n  background: var(--primary-dark);\n  border-color: var(--primary-dark);\n  width: 14px;\n  height: 14px;\n  box-shadow: 0 4px 12px rgba(247, 189, 32, 0.4);\n}\n\n.testimonials-carousel-dots .dot:hover {\n  background: rgba(247, 189, 32, 0.6);\n  transform: scale(1.15);\n}\n\n.testimonial-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--surface-soft);\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n}\n\n.testimonial-avatar.round {\n  border-radius: 50%;\n  border: 3px solid rgba(255, 255, 255, 0.8);\n}\n\n.testimonial-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.testimonial-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.testimonial-text p {\n  margin: 0;\n  font-size: 1.05rem;\n  line-height: 1.6;\n  color: var(--text-strong);\n}\n\n.testimonial-meta {\n  display: grid;\n  gap: 0.25rem;\n  color: var(--text-muted);\n}\n\n.testimonial-meta strong {\n  color: var(--text-strong);\n  font-size: 1rem;\n}\n\n.testimonial-meta span {\n  font-size: 0.9rem;\n}\n\n.quote-tag {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--primary-dark);\n  text-transform: uppercase;\n}\n\nblockquote p {\n  margin: 0;\n  color: var(--text-strong);\n  line-height: 1.6;\n}\n\nblockquote cite {\n  font-style: normal;\n  color: var(--text-muted);\n}\n\n.download-block {\n  margin-top: 5rem;\n}\n\n.download-card {\n  padding: 3rem;\n  border-radius: 36px;\n  background: linear-gradient(120deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 2rem;\n}\n\n.download-card .store-badge {\n  border: 1px solid rgba(17, 17, 17, 0.12);\n}\n\n.store-badges {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.store-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  background: none;\n}\n\n.store-badge img {\n  width: 140px;\n  height: auto;\n  display: block;\n  border-radius: 8px;\n}\n\n.store-badge img {\n  width: 135px;\n  height: auto;\n  display: block;\n}\n\n.hero-store-badges {\n  margin-top: 1rem;\n}\n\n.download-card .store-badges {\n  justify-content: flex-start;\n}\n\n/* Modern Homepage Styles */\n.highlight-text {\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-visual {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.hero-stats-card {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  border-radius: 24px;\n  padding: 2rem;\n  box-shadow: var(--shadow-soft);\n  border: 1px solid rgba(247, 189, 32, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.stat-item-hero {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 16px;\n  border: 1px solid rgba(247, 189, 32, 0.15);\n}\n\n.stat-icon {\n  font-size: 2rem;\n  width: 56px;\n  height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--gradient-primary);\n  border-radius: 14px;\n  box-shadow: 0 8px 20px rgba(247, 189, 32, 0.3);\n}\n\n.stat-item-hero strong {\n  font-size: 1.8rem;\n  color: var(--secondary);\n  display: block;\n  line-height: 1;\n}\n\n.stat-item-hero p {\n  margin: 0.3rem 0 0;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.hero-form-card {\n  background: #fff;\n  border-radius: 24px;\n  padding: 2rem;\n  box-shadow: var(--shadow-soft);\n  border: 1px solid var(--border-soft);\n}\n\n.hero-form-card h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1.4rem;\n  color: var(--secondary);\n}\n\n.hero-form-card>p {\n  margin: 0 0 1.5rem;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\n.store-badges-inline {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--border-soft);\n}\n\n.store-badges-inline .store-badge img {\n  width: 120px;\n}\n\n/* Why Choose Us Section */\n.why-choose-section {\n  background: linear-gradient(135deg, #fff7da, #ffffff);\n  border-radius: 40px;\n  padding: 3rem;\n  box-shadow: 0 20px 60px rgba(17, 17, 17, 0.08);\n}\n\n.why-choose-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n}\n\n.why-card {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 20px;\n  border: 1px solid var(--border-soft);\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n  transition: all 0.3s ease;\n}\n\n.why-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-soft);\n  border-color: rgba(247, 189, 32, 0.3);\n}\n\n.why-icon {\n  font-size: 2.5rem;\n  line-height: 1;\n}\n\n.why-card h3 {\n  margin: 0 0 0.5rem;\n  font-size: 1.1rem;\n  color: var(--secondary);\n}\n\n.why-card p {\n  margin: 0;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n/* Modern Product Cards */\n.product-card.modern {\n  position: relative;\n  overflow: hidden;\n}\n\n.product-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.product-badge {\n  display: inline-block;\n  padding: 0.35rem 0.85rem;\n  background: var(--gradient-primary);\n  color: var(--secondary);\n  border-radius: 999px;\n  font-size: 0.85rem;\n  font-weight: 700;\n  width: fit-content;\n}\n\n.product-arrow {\n  color: var(--primary-dark);\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.product-card.modern:hover .product-arrow {\n  transform: translateX(4px);\n  display: inline-block;\n  transition: transform 0.3s ease;\n}\n\n/* CTA Section */\n.cta-section {\n  margin: 4rem 0 2rem;\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  border-radius: 40px;\n  padding: 4rem 3rem;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.cta-section::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -20%;\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(247, 189, 32, 0.15) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.cta-section::after {\n  content: '';\n  position: absolute;\n  bottom: -40%;\n  right: -15%;\n  width: 500px;\n  height: 500px;\n  background: radial-gradient(circle, rgba(255, 193, 7, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.cta-content {\n  position: relative;\n  z-index: 1;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n.cta-section h2 {\n  color: #000000 !important;\n  font-size: clamp(2rem, 4vw, 3rem);\n  margin: 0 0 1rem;\n  font-weight: 800;\n}\n\n.cta-section p {\n  color: #000000 !important;\n  font-size: 1.2rem;\n  margin: 0 0 2rem;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.cta-section .primary-btn,\n.cta-section .ghost-btn {\n  color: #000000 !important;\n}\n\n.primary-btn.large,\n.ghost-btn.large {\n  padding: 1rem 2.5rem;\n  font-size: 1.1rem;\n  color: #000000 !important;\n}\n\n.ghost-btn.large {\n  background: rgba(255, 255, 255, 0.15);\n  color: #000000 !important;\n  border-color: rgba(0, 0, 0, 0.3);\n}\n\n.ghost-btn.large:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: #000000;\n  color: #000000 !important;\n}\n\n\n\n.blog-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.5rem;\n}\n\n.blog-grid article {\n  background: #fff;\n  border-radius: 24px;\n  padding: 1.75rem;\n  border: 1px solid var(--border-soft);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.blog-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.blog-grid h3 {\n  margin: 0;\n}\n\n.blogs-page {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  padding-top: 3rem;\n}\n\n.blogs-hero {\n  background:\n    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.18), transparent 50%),\n    radial-gradient(circle at 90% 10% 0%, rgba(232, 169, 26, 0.18), transparent 50%),\n    linear-gradient(120deg, #ffffff, #fff8e0);\n  color: var(--secondary);\n  border-radius: 32px;\n  padding: 2rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.5rem;\n  align-items: start;\n  box-shadow: var(--shadow-soft);\n}\n\n.blogs-hero__copy {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.blogs-hero__copy p {\n  margin: 0;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.blogs-hero__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.blogs-hero__meta span {\n  border-radius: 999px;\n  border: 1px solid var(--border-soft);\n  padding: 0.35rem 0.75rem;\n  background: var(--surface);\n  font-weight: 700;\n  font-size: 0.9rem;\n}\n\n.blogs-filters {\n  display: flex;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n}\n\n.blogs-filters button {\n  border: 1px solid var(--border-soft);\n  background: rgba(0, 0, 0, 0.02);\n  color: var(--secondary);\n  border-radius: 999px;\n  padding: 0.45rem 0.9rem;\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.blogs-filters button.selected {\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  border-color: transparent;\n  color: var(--secondary);\n  box-shadow: 0 12px 26px rgba(17, 17, 17, 0.12);\n}\n\n.blogs-featured {\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-soft);\n  border-radius: 22px;\n  padding: 1.4rem;\n  display: grid;\n  gap: 0.5rem;\n  box-shadow: var(--shadow-soft);\n}\n\n.blogs-featured__badge {\n  align-self: flex-start;\n  padding: 0.35rem 0.8rem;\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  color: var(--secondary);\n  border-radius: 12px;\n  font-weight: 800;\n  width: fit-content;\n}\n\n.blogs-featured h2 {\n  margin: 0.25rem 0 0.25rem;\n}\n\n.blog-meta-row {\n  display: flex;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n  color: var(--text-muted);\n  font-weight: 700;\n}\n\n.blogs-featured .ghost-btn {\n  justify-self: flex-start;\n}\n\n.blogs-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.blog-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n  display: grid;\n  gap: 0.5rem;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.blog-card__badge {\n  display: inline-flex;\n  padding: 0.35rem 0.75rem;\n  border-radius: 12px;\n  background: var(--surface-soft);\n  font-weight: 800;\n  color: var(--secondary);\n  width: fit-content;\n}\n\n.blog-card h3 {\n  margin: 0;\n}\n\n.blog-card p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.blog-card .blog-meta-row {\n  color: var(--text-muted);\n}\n\n.calculator-page {\n  padding-top: 4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n}\n\n.calculator-hero {\n  background: linear-gradient(135deg, #f7f3ff, #e9ffff, #fff2e1);\n  border-radius: 36px;\n  padding: 2.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n}\n\n.calculator-hero.enhanced {\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  background: radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.18), transparent 50%),\n    radial-gradient(circle at 80% 20% 0%, rgba(232, 169, 26, 0.12), transparent 45%),\n    linear-gradient(120deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  box-shadow: var(--shadow-soft);\n  position: relative;\n  overflow: hidden;\n}\n\n.calculator-hero.enhanced::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 50% 0%, rgba(255, 255, 255, 0.08) 0%, transparent 55%);\n  pointer-events: none;\n}\n\n.calc-hero-copy {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.calc-hero-copy h1 {\n  margin: 0.25rem 0;\n}\n\n.calc-hero-copy p {\n  margin: 0;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.calc-chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  margin-top: 0.5rem;\n}\n\n.calc-chip {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  padding: 0.65rem 0.9rem;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  min-width: 150px;\n}\n\n.calc-chip strong {\n  font-size: 1.1rem;\n}\n\n.calc-chip small {\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.calc-hero-panel {\n  position: relative;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-soft);\n  border-radius: 22px;\n  padding: 1.5rem;\n  display: grid;\n  gap: 1rem;\n  box-shadow: var(--shadow-soft);\n}\n\n.calc-hero-stat p {\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-weight: 700;\n  color: var(--text-muted);\n}\n\n.calc-hero-stat strong {\n  display: block;\n  font-size: 1.4rem;\n}\n\n.calc-hero-stat span {\n  color: var(--text-muted);\n}\n\n.calc-hero-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  gap: 0.6rem;\n  color: var(--text-muted);\n}\n\n.calc-hero-cta {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.support-page {\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n  padding-top: 3rem;\n}\n\n.contact-stack {\n  background: linear-gradient(135deg, #ffffff, #fff8df);\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.25rem;\n  align-items: start;\n  box-shadow: var(--shadow-soft);\n}\n\n.contact-stack__left,\n.contact-stack__right {\n  display: grid;\n  gap: 1rem;\n}\n\n.contact-stack-head h2 {\n  margin: 0.25rem 0 0.3rem;\n}\n\n.contact-stack-lead {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.contact-assurance {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.contact-assurance span {\n  border-radius: 14px;\n  border: 1px solid var(--border-soft);\n  padding: 0.55rem 0.85rem;\n  background: #fff;\n  font-weight: 700;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.contact-hero {\n  background:\n    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.2), transparent 45%),\n    radial-gradient(circle at 80% 20% 0%, rgba(17, 17, 17, 0.12), transparent 55%),\n    linear-gradient(120deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  border-radius: 36px;\n  padding: 2.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  align-items: center;\n  box-shadow: var(--shadow-soft);\n  position: relative;\n  overflow: hidden;\n}\n\n.contact-hero-copy h1 {\n  margin: 0.2rem 0 0.4rem;\n}\n\n.contact-hero-copy p {\n  margin: 0;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.contact-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin: 1rem 0 0.5rem;\n}\n\n.contact-badges span {\n  border-radius: 14px;\n  border: 1px solid var(--border-soft);\n  background: var(--surface);\n  padding: 0.6rem 0.85rem;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  min-width: 130px;\n}\n\n.contact-badges strong {\n  font-size: 1.05rem;\n}\n\n.contact-badges small {\n  color: var(--text-muted);\n}\n\n.contact-quick {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-top: 1rem;\n}\n\n.contact-hero-visual {\n  position: relative;\n  display: grid;\n  gap: 0.75rem;\n  justify-items: center;\n}\n\n.contact-hero-card {\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-soft);\n  border-radius: 22px;\n  padding: 1.4rem;\n  width: 100%;\n  max-width: 420px;\n  box-shadow: var(--shadow-soft);\n}\n\n.contact-hero-card h3 {\n  margin: 0.3rem 0 0.35rem;\n}\n\n.contact-hero-note {\n  margin: 0 0 0.65rem;\n  color: var(--text-muted);\n}\n\n.support-highlight-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.support-highlight-card {\n  background: linear-gradient(135deg, #ffffff, #f5f8ff);\n  border-radius: 20px;\n  border: 1px solid var(--border-soft);\n  padding: 1.2rem;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.75rem;\n  align-items: center;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.support-info-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.support-info-card {\n  border-radius: 22px;\n  padding: 1.4rem;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.8rem;\n  align-items: start;\n  box-shadow: var(--shadow-soft);\n  color: var(--secondary);\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  border: 1px solid var(--border-soft);\n}\n\n.support-info-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 15% 15% 0%, rgba(255, 255, 255, 0.12), transparent 55%);\n  pointer-events: none;\n}\n\n.support-info-card.blue {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n}\n\n.support-info-card.teal {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n}\n\n.support-info-card.amber {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n}\n\n.support-info-card ul {\n  margin: 0.2rem 0 0;\n  padding-left: 1.1rem;\n  color: var(--text-muted);\n  display: grid;\n  gap: 0.35rem;\n}\n\n.support-info-card h3 {\n  margin: 0;\n}\n\n.support-faqs {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n  box-shadow: var(--shadow-soft);\n  display: grid;\n  gap: 1rem;\n}\n\n.faq-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 0.75rem;\n}\n\n.faq-card {\n  background: var(--surface-soft);\n  border-radius: 16px;\n  border: 1px solid var(--border-soft);\n  padding: 0.9rem 1rem;\n}\n\n.faq-card summary {\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.faq-card p {\n  margin: 0.5rem 0 0;\n  color: var(--text-muted);\n}\n\n.calculator-hero.eligibility-hero {\n  background:\n    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.2), transparent 50%),\n    radial-gradient(circle at 80% 20% 0%, rgba(232, 169, 26, 0.16), transparent 55%),\n    linear-gradient(120deg, #ffffff, #fff8e0);\n  color: var(--secondary);\n  position: relative;\n  overflow: hidden;\n}\n\n.calculator-hero.credit-hero {\n  background:\n    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.2), transparent 55%),\n    radial-gradient(circle at 80% 20% 0%, rgba(17, 17, 17, 0.12), transparent 55%),\n    linear-gradient(120deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  position: relative;\n  overflow: hidden;\n}\n\n.eligibility-hero-card {\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-soft);\n  border-radius: 22px;\n  padding: 1.5rem;\n  display: grid;\n  gap: 0.65rem;\n  box-shadow: var(--shadow-soft);\n  position: relative;\n  overflow: hidden;\n}\n\n.eligibility-hero-card h3 {\n  margin: 0.2rem 0 0.1rem;\n}\n\n.credit-hero-card {\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-soft);\n  border-radius: 22px;\n  padding: 1.5rem;\n  display: grid;\n  gap: 0.65rem;\n  box-shadow: var(--shadow-soft);\n  position: relative;\n  overflow: hidden;\n}\n\n.credit-hero-card h3 {\n  margin: 0.2rem 0 0.1rem;\n}\n\n.doodle-bubbles {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n\n.bubble.mini {\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(247, 189, 32, 0.26), transparent 70%);\n  top: 12%;\n  right: 18%;\n}\n\n.sparkle {\n  position: absolute;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(17, 17, 17, 0.12), transparent 65%);\n  bottom: 10%;\n  left: 10%;\n}\n\n.calculator-hero.two-wheeler-hero {\n  background:\n    radial-gradient(circle at 0% 0%, rgba(247, 189, 32, 0.22) 0%, transparent 45%),\n    radial-gradient(circle at 80% 20%, rgba(17, 17, 17, 0.12) 0%, transparent 50%),\n    linear-gradient(120deg, #ffffff, #fff8df);\n  color: var(--secondary);\n  overflow: hidden;\n  position: relative;\n}\n\n.two-wheeler-hero-visual {\n  position: relative;\n  min-height: 260px;\n  display: grid;\n  place-items: center;\n}\n\n.two-wheeler-hero-card {\n  background: rgba(0, 0, 0, 0.02);\n  border: 1px solid var(--border-soft);\n  border-radius: 24px;\n  padding: 1.6rem;\n  width: 100%;\n  max-width: 360px;\n  box-shadow: var(--shadow-soft);\n  position: relative;\n  z-index: 1;\n}\n\n.two-wheeler-hero-card h3 {\n  margin: 0.35rem 0 0.25rem;\n}\n\n.calc-hero-note {\n  margin: 0 0 0.75rem;\n  color: var(--text-muted);\n}\n\n.hero-mini-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 0.5rem;\n}\n\n.hero-mini-stats div {\n  background: rgba(0, 0, 0, 0.04);\n  border-radius: 14px;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid var(--border-soft);\n  text-align: center;\n}\n\n.doodle-bubble {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(0);\n  z-index: 0;\n}\n\n.bubble-a {\n  width: 160px;\n  height: 160px;\n  background: radial-gradient(circle, rgba(247, 189, 32, 0.26), transparent 70%);\n  top: 10%;\n  right: 12%;\n}\n\n.bubble-b {\n  width: 220px;\n  height: 220px;\n  background: radial-gradient(circle, rgba(17, 17, 17, 0.12), transparent 70%);\n  bottom: 5%;\n  left: 5%;\n}\n\n.hero-facts {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 1rem;\n}\n\n.hero-facts li {\n  background: #fff;\n  border-radius: 20px;\n  border: 1px solid var(--border-soft);\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.hero-facts.compact {\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n}\n\n.calculator-body {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(220px, 1fr);\n  gap: 2rem;\n}\n\n.calculator-body.modern {\n  background: #fff;\n  border-radius: 32px;\n  padding: 1.5rem;\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-soft);\n  align-items: start;\n}\n\n.calculator-main-card {\n  background: linear-gradient(180deg, #ffffff 0%, #f7f9ff 100%);\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n}\n\n.calculator-head {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.calculator-subhead {\n  margin: 0.35rem 0 0;\n  color: var(--text-muted);\n}\n\n.calculator-meta-tags {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.calculator-meta-tags span {\n  border-radius: 999px;\n  border: 1px solid var(--border-soft);\n  padding: 0.35rem 0.75rem;\n  background: #fff;\n  font-weight: 700;\n  font-size: 0.9rem;\n}\n\n.calculator-aside {\n  display: grid;\n  gap: 1rem;\n}\n\n.calculator-body.stacked {\n  grid-template-columns: 1fr;\n}\n\n.calc-side-card {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.calc-side-card ul,\n.calc-side-card ol {\n  margin: 0;\n  padding-left: 1.2rem;\n  color: var(--text-muted);\n}\n\n.calc-side-card .note {\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n.calculator-visual-shell {\n  background: #fff;\n  border-radius: 28px;\n  padding: 1.25rem;\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-soft);\n  display: grid;\n  gap: 0.75rem;\n  position: relative;\n}\n\n.calculator-carousel {\n  overflow: hidden;\n  border-radius: 22px;\n  border: 1px solid var(--border-soft);\n  background: var(--surface-soft);\n  position: relative;\n}\n\n.calculator-carousel__track {\n  display: flex;\n  transition: transform 0.4s ease;\n}\n\n.calculator-carousel__slide {\n  min-width: 100%;\n}\n\n.calculator-carousel__slide img {\n  width: 100%;\n  display: block;\n}\n\n.compact-carousel .calculator-carousel {\n  max-height: 360px;\n}\n\n.compact-carousel .calculator-carousel__slide img {\n  max-height: 320px;\n  object-fit: cover;\n}\n\n.calculator-carousel__dots {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.calculator-carousel__dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 1px solid var(--border-soft);\n  background: #fff;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.calculator-carousel__dot.is-active {\n  background: var(--secondary);\n  border-color: var(--secondary);\n  transform: scale(1.05);\n}\n\n.carousel-tags {\n  display: flex;\n  gap: 0.65rem;\n  flex-wrap: wrap;\n}\n\n.carousel-tags span {\n  border-radius: 999px;\n  border: 1px solid var(--border-soft);\n  padding: 0.35rem 0.8rem;\n  background: var(--surface-soft);\n  font-weight: 700;\n  font-size: 0.9rem;\n}\n\n.carousel-doodle .doodle-dot,\n.carousel-doodle .doodle-line {\n  position: absolute;\n  display: inline-block;\n  background: linear-gradient(135deg, rgba(247, 189, 32, 0.28), rgba(17, 17, 17, 0.12));\n  filter: blur(0);\n  opacity: 0.8;\n}\n\n.carousel-doodle .doodle-dot {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  top: 6%;\n  right: 10%;\n}\n\n.carousel-doodle .doodle-line {\n  width: 120px;\n  height: 10px;\n  border-radius: 999px;\n  bottom: 8%;\n  left: 6%;\n}\n\n.calc-side-card.tinted {\n  background: linear-gradient(180deg, #fffdf5, #fff);\n}\n\n.calc-side-card.compact ul {\n  padding-left: 1.1rem;\n  margin: 0;\n  display: grid;\n  gap: 0.35rem;\n  color: var(--text-muted);\n}\n\n.calc-bullet-list {\n  list-style: disc;\n}\n\n.calc-side-card ol {\n  display: grid;\n  gap: 0.6rem;\n  padding-left: 1.2rem;\n}\n\n.calc-side-card ol strong {\n  display: block;\n}\n\n.calc-grid-section {\n  display: grid;\n  gap: 1.25rem;\n}\n\n.calc-scenario-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.calc-scenario-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n  display: grid;\n  gap: 0.75rem;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);\n}\n\n.calc-scenario-card h3 {\n  margin: 0.35rem 0;\n}\n\n.calc-scenario-card p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.calc-scenario-card .ghost-btn {\n  width: fit-content;\n}\n\n.calc-scenario-kicker {\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--primary-dark);\n  margin: 0;\n}\n\n.apply-page {\n  padding-top: 4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 3rem;\n}\n\n.apply-hero {\n  background: linear-gradient(120deg, #f7f3ff, #fff2e1);\n  border-radius: 36px;\n  padding: 2.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.apply-highlights {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 1rem;\n}\n\n.apply-highlights div {\n  background: #fff;\n  padding: 1rem;\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n}\n\n.apply-highlights span {\n  display: block;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.apply-highlights strong {\n  font-size: 1.2rem;\n}\n\n.apply-content {\n  display: grid;\n  grid-template-columns: minmax(0, 3fr) minmax(260px, 1fr);\n  gap: 2rem;\n}\n\n.apply-form {\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 2.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1.25rem;\n}\n\n.form-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-weight: 600;\n}\n\n.form-grid input,\n.form-grid select {\n  border-radius: 14px;\n  border: 1px solid var(--border-soft);\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n}\n\n.slider-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.25rem;\n}\n\n.slider-grid>div {\n  border: 1px solid var(--border-soft);\n  border-radius: 20px;\n  padding: 1rem 1.25rem;\n  background: var(--surface-soft);\n}\n\n.slider-heading {\n  display: flex;\n  justify-content: space-between;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.slider-grid input[type='range'] {\n  width: 100%;\n  accent-color: var(--primary);\n}\n\n.apply-form .primary-btn {\n  width: max(240px, 40%);\n}\n\n.form-note {\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.form-note.success {\n  color: #0f9d58;\n  font-weight: 600;\n}\n\n.apply-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.summary-card,\n.contact-card {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.75rem;\n}\n\n.summary-card h2 {\n  margin-top: 0;\n}\n\n.summary-card div {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0.75rem;\n  font-size: 0.95rem;\n}\n\n.summary-card div strong {\n  color: var(--text-strong);\n}\n\n.contact-card a {\n  display: block;\n  color: var(--secondary);\n  font-weight: 600;\n  text-decoration: none;\n  margin-top: 0.35rem;\n}\n\n.company-overview {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n}\n\n.company-card {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 2rem;\n}\n\n.fact-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.fact-grid div {\n  border-radius: 20px;\n  border: 1px dashed var(--border-soft);\n  padding: 1rem 1.25rem;\n  background: var(--surface-soft);\n}\n\n.mission-list {\n  list-style: disc;\n  padding-left: 1.2rem;\n  color: var(--text-muted);\n}\n\n.office-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.25rem;\n}\n\n.contact-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.contact-strip div {\n  flex: 1;\n  min-width: 200px;\n  border-radius: 20px;\n  padding: 1rem 1.25rem;\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  color: var(--secondary);\n}\n\n.contact-channel-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.contact-channel {\n  border-radius: 22px;\n  padding: 1.25rem;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.8rem;\n  align-items: start;\n  position: relative;\n  overflow: hidden;\n  color: var(--secondary);\n  box-shadow: var(--shadow-soft);\n}\n\n.contact-channel::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 10% 10% 0%, rgba(255, 255, 255, 0.12), transparent 55%);\n  pointer-events: none;\n}\n\n.contact-channel:nth-child(1) {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n}\n\n.contact-channel:nth-child(2) {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n}\n\n.contact-channel:nth-child(3) {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n}\n\n.contact-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.16);\n  display: grid;\n  place-items: center;\n  font-size: 1.35rem;\n}\n\n.contact-channel h3 {\n  margin: 0;\n}\n\n.contact-channel p {\n  margin: 0.35rem 0 0.5rem;\n  color: var(--text-muted);\n}\n\n.contact-channel .primary-link {\n  color: var(--primary-dark);\n  font-weight: 700;\n}\n\n.careers-page,\n.newsroom-page {\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n  padding-top: 3rem;\n}\n\n.benefit-card {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n}\n\n.roles-section .roles-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.25rem;\n}\n\n.role-card {\n  background: #fff;\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.tag-row {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.tag-row span {\n  padding: 0.3rem 0.75rem;\n  border-radius: 999px;\n  background: var(--surface-soft);\n  font-size: 0.85rem;\n}\n\n.roles-section .ghost-btn {\n  align-self: flex-start;\n}\n\n.career-form-card {\n  margin-top: 1.5rem;\n  display: grid;\n  gap: 0.75rem;\n}\n\n.career-form {\n  display: grid;\n  gap: 1rem;\n}\n\n.career-form .form-grid label,\n.career-message {\n  font-weight: 600;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  color: var(--text-strong);\n}\n\n.career-form input,\n.career-form textarea {\n  border-radius: 14px;\n  border: 1px solid var(--border-soft);\n  padding: 0.75rem 0.95rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n  background: var(--surface);\n}\n\n.career-form input[type='file'] {\n  padding: 0.6rem;\n}\n\n.career-form textarea {\n  resize: vertical;\n}\n\n.section-note {\n  text-align: center;\n  color: var(--text-muted);\n  margin-top: 1rem;\n}\n\n.newsroom-page .press-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.25rem;\n}\n\n.press-card {\n  background: #fff;\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.media-kit {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n}\n\n.tag-row.wrap {\n  flex-wrap: wrap;\n}\n\n.timeline-section {\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 2.5rem;\n}\n\n.timeline-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.25rem;\n  margin-top: 1.5rem;\n}\n\n.timeline-grid article {\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n  background: var(--surface-soft);\n}\n\n.testimonials-section .testimonial-grid.wide {\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n}\n\n.contact-cta {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  border-radius: 32px;\n  padding: 2.5rem;\n  color: var(--secondary);\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.contact-buttons {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.contact-cta .ghost-btn {\n  border-color: rgba(247, 189, 32, 0.5);\n  color: var(--secondary);\n}\n\n.contact-form-shell {\n  background: linear-gradient(135deg, #f5f7ff, #fff7ef);\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.25rem;\n  box-shadow: var(--shadow-soft);\n}\n\n.contact-form-card {\n  background: linear-gradient(180deg, #ffffff 0%, #f7f9ff 100%);\n  border-radius: 26px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);\n}\n\n.contact-form-card h2 {\n  margin: 0.35rem 0 0.75rem;\n}\n\n.contact-form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 0.9rem 1rem;\n}\n\n.contact-form-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-weight: 600;\n}\n\n.contact-form-grid input,\n.contact-form-grid select,\n.contact-form-grid textarea {\n  border-radius: 14px;\n  border: 1px solid var(--border-soft);\n  padding: 0.75rem 0.95rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n}\n\n.contact-form-grid textarea {\n  resize: vertical;\n}\n\n.contact-form-grid .span-2 {\n  grid-column: 1 / -1;\n}\n\n.contact-info-card {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n  display: grid;\n  gap: 0.8rem;\n  color: var(--secondary);\n}\n\n.contact-info-card ul {\n  margin: 0;\n  padding-left: 1.15rem;\n  color: var(--text-muted);\n  display: grid;\n  gap: 0.35rem;\n}\n\n.contact-quick-links {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.contact-info-card .ghost-btn,\n.support-cta-band .ghost-btn {\n  border-color: rgba(247, 189, 32, 0.5);\n  color: var(--secondary);\n}\n\n.contact-info-card .primary-link {\n  color: var(--primary-dark);\n  font-weight: 700;\n}\n\n.support-cta-band {\n  background: linear-gradient(120deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  border-radius: 28px;\n  padding: 2rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.25rem;\n  align-items: center;\n  box-shadow: var(--shadow-soft);\n}\n\n.support-cta-band p {\n  margin: 0.4rem 0 0.75rem;\n  color: var(--text-muted);\n}\n\n.support-cta-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.support-info-cards+.branch-locator {\n  margin-top: 1rem;\n}\n\n.branch-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.branch-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n  padding: 1.1rem;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n  display: grid;\n  gap: 0.4rem;\n}\n\n.branch-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.35rem 0.8rem;\n  border-radius: 999px;\n  background: var(--surface-soft);\n  font-weight: 700;\n}\n\n.policy-card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.policy-card {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  border-radius: 20px;\n  padding: 1.2rem;\n  position: relative;\n  overflow: hidden;\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-soft);\n}\n\n.policy-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 20% 20% 0%, rgba(255, 255, 255, 0.1), transparent 55%);\n  pointer-events: none;\n}\n\n.policy-card h3 {\n  margin: 0.35rem 0 0.25rem;\n}\n\n.policy-card p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.policy-tag {\n  display: inline-flex;\n  padding: 0.3rem 0.75rem;\n  border-radius: 12px;\n  background: rgba(247, 189, 32, 0.16);\n  border: 1px solid rgba(17, 17, 17, 0.08);\n  font-weight: 700;\n  font-size: 0.85rem;\n}\n\n.support-timeline {\n  background: linear-gradient(135deg, #f7f9ff, #fff8ef);\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.75rem;\n  display: grid;\n  gap: 1.1rem;\n  box-shadow: var(--shadow-soft);\n}\n\n.timeline-head h2 {\n  margin: 0.35rem 0 0.25rem;\n}\n\n.timeline-flow {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n  position: relative;\n}\n\n.timeline-node {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n  padding: 1.1rem;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.8rem;\n  align-items: start;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);\n}\n\n.timeline-connector {\n  display: none;\n}\n\n.timeline-node h3 {\n  margin: 0 0 0.35rem;\n}\n\n.timeline-node p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.timeline-node .step-number {\n  background: var(--primary);\n  color: var(--secondary);\n  border-radius: 12px;\n  width: 42px;\n  height: 42px;\n  display: grid;\n  place-items: center;\n  font-weight: 800;\n  box-shadow: 0 12px 28px rgba(247, 189, 32, 0.35);\n}\n\n@media (min-width: 900px) {\n  .timeline-flow {\n    grid-template-columns: repeat(3, 1fr);\n  }\n\n  .timeline-connector {\n    display: block;\n    height: 2px;\n    background: linear-gradient(90deg, rgba(6, 148, 254, 0.25), rgba(246, 130, 31, 0.25));\n    align-self: center;\n  }\n}\n\n.eligibility-calculator {\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.eligibility-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.25rem;\n}\n\n.eligibility-grid label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-weight: 600;\n}\n\n.eligibility-grid input[type='number'],\n.eligibility-grid input[type='date'],\n.eligibility-grid input[type='text'] {\n  border-radius: 14px;\n  border: 1px solid var(--border-soft);\n  padding: 0.75rem 1rem;\n  font-size: 0.95rem;\n}\n\n.eligibility-summary {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n  background: var(--surface-soft);\n  border-radius: 24px;\n  padding: 1.5rem;\n}\n\n.eligibility-summary div {\n  background: #fff;\n  border-radius: 20px;\n  padding: 1rem;\n  border: 1px solid var(--border-soft);\n}\n\n.eligibility-summary p {\n  grid-column: 1 / -1;\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n.credit-score-widget {\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 2rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 2rem;\n}\n\n.credit-form {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.credit-form label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  font-weight: 600;\n}\n\n.credit-form input {\n  border-radius: 14px;\n  border: 1px solid var(--border-soft);\n  padding: 0.75rem 1rem;\n}\n\n.credit-form button {\n  grid-column: 1 / -1;\n  width: fit-content;\n}\n\n.credit-score-result {\n  background: linear-gradient(165deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  border-radius: 28px;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.score-circle {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  border: 6px solid rgba(247, 189, 32, 0.45);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n}\n\n.score-circle span {\n  font-size: 1rem;\n}\n\n.success-banner {\n  background: rgba(247, 189, 32, 0.2);\n  border-radius: 999px;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n}\n\n\n.info-page {\n  padding-top: 3rem;\n}\n\n.info-hero {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 2.5rem;\n  align-items: stretch;\n  margin-bottom: 2.5rem;\n}\n\n.info-copy {\n  border-radius: 32px;\n  padding: 2.5rem;\n  border: 1px solid var(--border-soft);\n  background: #fff;\n}\n\n.info-hero-card {\n  position: relative;\n  overflow: hidden;\n  background: linear-gradient(135deg, #fff4e7 0%, #eef4ff 100%);\n  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.12);\n}\n\n.info-hero-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 20% 20% 0%, rgba(246, 130, 31, 0.16), transparent 50%);\n  pointer-events: none;\n}\n\n.info-hero-card h1 {\n  margin: 0.35rem 0 0.75rem;\n}\n\n.info-hero-card p {\n  margin: 0;\n  color: var(--text-muted);\n  line-height: 1.7;\n}\n\n.info-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.9rem;\n  border-radius: 999px;\n  background: rgba(6, 148, 254, 0.1);\n  color: var(--secondary);\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.info-highlight-chips {\n  margin-top: 1.25rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.info-highlight-chips span {\n  background: rgba(255, 255, 255, 0.75);\n  border: 1px solid var(--border-soft);\n  border-radius: 999px;\n  padding: 0.55rem 0.95rem;\n  font-weight: 700;\n  color: var(--text-strong);\n  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.08);\n}\n\n.info-speed-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 0.6rem;\n  margin-top: 1rem;\n}\n\n.info-speed-row div {\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid var(--border-soft);\n  border-radius: 14px;\n  padding: 0.65rem 0.9rem;\n  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);\n}\n\n.info-speed-row strong {\n  display: block;\n  font-size: 1.05rem;\n}\n\n.info-speed-row span {\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.info-helper {\n  margin: 0.9rem 0 0;\n  color: var(--text-muted);\n  font-weight: 600;\n}\n\n.info-cta {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin: 1.5rem 0;\n}\n\n.info-visual {\n  display: flex;\n}\n\n.info-hero-visual {\n  position: relative;\n}\n\n.info-visual-card {\n  background: linear-gradient(145deg, #ffffff, #fff7da);\n  border-radius: 28px;\n  padding: 1.75rem;\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-soft);\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n}\n\n.info-visual-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);\n  pointer-events: none;\n}\n\n.info-visual img {\n  width: 100%;\n  max-width: 320px;\n  display: block;\n  margin: 0 auto;\n  filter: drop-shadow(0 18px 35px rgba(0, 0, 0, 0.25));\n}\n\n.info-hero.theme-cash .info-hero-card {\n  background: linear-gradient(135deg, #fffdf5, #fff7da);\n  border: 1px solid rgba(247, 189, 32, 0.35);\n}\n\n.info-hero.theme-cash .info-visual-card {\n  background: linear-gradient(145deg, #ffffff, #fff7da);\n  border-color: var(--border-soft);\n}\n\n.info-hero.theme-cash .info-speed-row div {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: rgba(247, 189, 32, 0.35);\n}\n\n.info-visual-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.info-visual-stats div {\n  background: var(--surface);\n  border: 1px solid var(--border-soft);\n  border-radius: 16px;\n  padding: 0.9rem 1rem;\n  text-align: center;\n  color: var(--secondary);\n  box-shadow: var(--shadow-soft);\n}\n\n.info-visual-stats strong {\n  display: block;\n  color: var(--secondary);\n  font-size: 1.4rem;\n}\n\n.info-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n  background: linear-gradient(135deg, #f7f9ff, #fff7ef);\n  border-radius: 24px;\n  padding: 1.5rem;\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-soft);\n}\n\n.info-stats div {\n  text-align: center;\n}\n\n.info-stats strong {\n  display: block;\n  font-size: 1.6rem;\n  color: var(--text-strong);\n}\n\n.info-section {\n  margin: 2.5rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n}\n\n.info-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.info-action-card {\n  background: linear-gradient(135deg, #ffffff, #f7f9ff);\n  border: 1px solid var(--border-soft);\n  border-radius: 18px;\n  padding: 1.1rem;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.75rem;\n  align-items: start;\n  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);\n}\n\n.info-action-icon {\n  width: 42px;\n  height: 42px;\n  border-radius: 14px;\n  background: var(--surface-soft);\n  display: grid;\n  place-items: center;\n  font-size: 1.2rem;\n  border: 1px solid var(--border-soft);\n}\n\n.info-value-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1rem;\n}\n\n.info-value-card {\n  background: #fff;\n  border-radius: 22px;\n  padding: 1.5rem;\n  border: 1px solid var(--border-soft);\n  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.info-value-index {\n  font-size: 0.85rem;\n  letter-spacing: 0.08em;\n  color: var(--secondary);\n  font-weight: 800;\n}\n\n.info-value-card h3 {\n  margin: 0;\n}\n\n.info-value-card p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.info-step-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.info-step {\n  background: linear-gradient(180deg, #ffffff 0%, #f6fbff 100%);\n  border-radius: 20px;\n  border: 1px solid var(--border-soft);\n  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.08);\n  padding: 1.3rem 1.4rem;\n  display: flex;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.info-step-number {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: var(--primary);\n  color: var(--secondary);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  box-shadow: 0 10px 20px rgba(247, 189, 32, 0.35);\n}\n\n.info-step h3 {\n  margin: 0 0 0.35rem;\n}\n\n.info-step p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.info-guardrail {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  border-radius: 26px;\n  padding: 1.75rem;\n  display: grid;\n  gap: 1rem;\n  border: 1px solid var(--border-soft);\n  box-shadow: var(--shadow-soft);\n}\n\n.info-guardrail-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.info-guardrail-item {\n  display: flex;\n  gap: 0.75rem;\n  align-items: flex-start;\n  padding: 0.85rem 1rem;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 16px;\n  border: 1px solid var(--border-soft);\n}\n\n.info-bullet-dot {\n  width: 12px;\n  height: 12px;\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  border-radius: 50%;\n  display: inline-flex;\n  margin-top: 0.2rem;\n  flex-shrink: 0;\n}\n\n.info-guardrail-item strong {\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.info-guardrail-item p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.info-faq .faq-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.faq-grid details {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n  padding: 1rem 1.15rem;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.faq-grid summary {\n  cursor: pointer;\n  font-weight: 700;\n}\n\n.faq-grid p {\n  margin: 0.6rem 0 0;\n  color: var(--text-muted);\n}\n\n.site-footer {\n  margin-top: 0;\n  /* Remove gap above footer */\n  background: linear-gradient(to right, #FFF9E6 0%, #FFE082 35%, #D4A017 100%);\n  color: var(--text-strong, #0b0b0b);\n  padding: clamp(3rem, 8vw, 4.5rem) clamp(1.5rem, 8vw, 5rem);\n  position: relative;\n  overflow: hidden;\n}\n\n.site-footer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-primary);\n}\n\n.footer-inner {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(1.5rem, 3vw, 2.75rem);\n  align-items: stretch;\n  position: relative;\n  z-index: 1;\n}\n\n.footer-content {\n  display: flex;\n  flex-wrap: wrap;\n  gap: clamp(1.25rem, 2.5vw, 3rem);\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid rgba(17, 17, 17, 0.12);\n}\n\n.footer-brand {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.footer-brand .brand {\n  font-size: 1.35rem;\n}\n\n.footer-brand img {\n  height: 100px;\n  width: auto;\n  max-width: 200px;\n  object-fit: contain;\n  transform: scale(1.1);\n  transform-origin: left center;\n}\n\n.footer-brand p {\n  margin: 0;\n  color: var(--text-muted, #4a4a4a);\n  line-height: 1.6;\n}\n\n.footer-brand,\n.footer-links,\n.footer-visit {\n  flex: 1 1 240px;\n}\n\n.footer-social {\n  display: flex;\n  gap: 0.6rem;\n}\n\n.footer-social a {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(247, 189, 32, 0.1);\n  border: 1px solid rgba(247, 189, 32, 0.3);\n  transition: transform 0.2s ease, background 0.2s ease;\n  text-decoration: none;\n  font-size: 1.1rem;\n}\n\n.footer-social img {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.footer-social a:hover {\n  transform: translateY(-2px);\n  background: var(--gradient-primary);\n}\n\n.footer-links {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 1rem 1.5rem;\n}\n\n.footer-links-column {\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n}\n\n.footer-links-title {\n  margin: 0;\n  letter-spacing: 0.12em;\n  font-size: 0.85rem;\n  text-transform: uppercase;\n  color: var(--secondary, #111);\n  font-weight: 700;\n}\n\n.footer-links-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.footer-link {\n  font-weight: 500;\n  font-size: 0.95rem;\n  color: var(--text-muted, #4a4a4a);\n  padding: 0.2rem 0;\n  transition: color 0.2s ease;\n  text-decoration: none;\n}\n\n.footer-link:hover,\n.footer-link.active {\n  color: var(--primary-dark, #e8a91a);\n}\n\n.footer-map {\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.15);\n  border: 1px solid rgba(247, 189, 32, 0.2);\n  min-height: 320px;\n  height: clamp(280px, 35vw, 360px);\n  width: 100%;\n}\n\n.footer-visit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.footer-visit h3 {\n  margin: 0;\n  font-size: 1.6rem;\n  color: var(--secondary, #111);\n}\n\n.footer-visit p {\n  margin: 0;\n  color: var(--text-muted, #4a4a4a);\n}\n\n.footer-address-secondary {\n  margin-top: 1.25rem !important;\n  padding-top: 1.25rem;\n  border-top: 1px solid rgba(247, 189, 32, 0.2);\n}\n\n.footer-map iframe {\n  width: 100%;\n  height: 100%;\n  min-height: 320px;\n  border: 0;\n  display: block;\n}\n\n.footer-contact {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  font-weight: 600;\n  color: var(--secondary, #111);\n}\n\n.footer-cta {\n  margin-top: 0.75rem;\n  align-self: flex-start;\n  padding: 0.65rem 1.6rem;\n  border-radius: 999px;\n  background: var(--gradient-primary);\n  color: var(--secondary, #111);\n  font-weight: 700;\n  box-shadow: 0 16px 36px rgba(247, 189, 32, 0.35);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  text-decoration: none;\n}\n\n.footer-cta:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 22px 44px rgba(247, 189, 32, 0.45);\n}\n\n.footer-bottom {\n  margin-top: clamp(2rem, 5vw, 2.75rem);\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(17, 17, 17, 0.1);\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  color: var(--text-muted, #4a4a4a);\n  position: relative;\n  z-index: 1;\n}\n\n.footer-bottom-links {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.footer-bottom-links a {\n  color: var(--text-muted, #4a4a4a);\n  font-size: 0.9rem;\n  transition: color 0.2s ease;\n  text-decoration: none;\n}\n\n.footer-bottom-links a:hover {\n  color: var(--primary-dark, #e8a91a);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .footer-content {\n    flex-direction: column;\n  }\n\n  .footer-brand,\n  .footer-links,\n  .footer-visit {\n    flex: 1 1 100%;\n  }\n\n  .footer-bottom {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n\n.solutions-page {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  padding-top: 2.5rem;\n}\n\n.solutions-hero {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  align-items: center;\n  padding: 2.5rem;\n  border-radius: 28px;\n  background:\n    radial-gradient(circle at 10% 10% 0%, rgba(245, 180, 0, 0.22), transparent 45%),\n    linear-gradient(135deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  box-shadow: var(--shadow-soft);\n}\n\n.solutions-hero__content h1 {\n  margin: 0.25rem 0 0.75rem;\n  font-size: clamp(2rem, 3vw, 2.8rem);\n}\n\n.solutions-hero__content p {\n  margin: 0 0 1rem;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.audience-pills {\n  display: flex;\n  gap: 0.6rem;\n  flex-wrap: wrap;\n  margin: 1rem 0;\n}\n\n.audience-pills button {\n  border-radius: 999px;\n  border: 1px solid var(--border-soft);\n  background: rgba(0, 0, 0, 0.03);\n  color: var(--secondary);\n  padding: 0.45rem 0.95rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.audience-pills button.selected {\n  border-color: rgba(247, 189, 32, 0.6);\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  color: var(--secondary);\n  font-weight: 700;\n}\n\n.solution-metrics {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.solution-metrics div {\n  background: var(--surface);\n  border: 1px solid var(--border-soft);\n  border-radius: 14px;\n  padding: 0.85rem 1rem;\n  display: grid;\n  gap: 0.25rem;\n  text-align: left;\n}\n\n.solutions-hero__visual {\n  position: relative;\n  display: grid;\n  gap: 0.75rem;\n  justify-items: center;\n}\n\n.solutions-hero__tile {\n  width: 100%;\n  max-width: 320px;\n  border-radius: 14px;\n  padding: 1rem;\n  border: 1px solid var(--border-soft);\n  background: var(--surface);\n  box-shadow: var(--shadow-soft);\n}\n\n.solutions-hero__tile strong {\n  font-size: 1.8rem;\n}\n\n.solutions-section {\n  padding: 1rem 0 0;\n}\n\n.solution-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1rem;\n}\n\n.solution-card {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  border-radius: 20px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n  box-shadow: var(--shadow-soft);\n  display: grid;\n  gap: 0.6rem;\n}\n\n.solution-card__meta {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n}\n\n.solution-card ul {\n  margin: 0.25rem 0 0;\n  padding-left: 1rem;\n  color: var(--text-muted);\n  display: grid;\n  gap: 0.25rem;\n}\n\n.solution-card__footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 0.4rem;\n  color: var(--primary-dark);\n}\n\n.industry-grid,\n.journey-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.industry-card,\n.journey-grid article {\n  background: #fff;\n  border: 1px solid var(--border-soft);\n  border-radius: 18px;\n  padding: 1.2rem;\n  box-shadow: 0 14px 35px rgba(13, 15, 20, 0.08);\n}\n\n.journey-grid article span {\n  display: inline-block;\n  background: var(--surface-soft);\n  padding: 0.3rem 0.7rem;\n  border-radius: 999px;\n  font-weight: 700;\n}\n\n.journey-grid article ul {\n  margin: 0.5rem 0 0;\n  padding-left: 1.1rem;\n  color: var(--text-muted);\n  display: grid;\n  gap: 0.25rem;\n}\n\n.partner-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.partner-grid strong {\n  display: block;\n  margin-bottom: 0.35rem;\n}\n\n.partner-grid span {\n  display: inline-block;\n  margin: 0.15rem 0.35rem 0.15rem 0;\n  padding: 0.35rem 0.65rem;\n  border-radius: 999px;\n  background: var(--surface-soft);\n  border: 1px solid var(--border-soft);\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .solutions-hero {\n    padding: 1.75rem;\n  }\n\n  .solution-card {\n    padding: 1rem;\n  }\n}\n\n.footer-map-col {\n  justify-self: end;\n  align-self: start;\n  max-width: 400px;\n  width: 100%;\n  display: grid;\n  gap: 0.75rem;\n}\n\n.footer-links-grid h4 {\n  margin: 0 0 0.8rem;\n}\n\n.footer-links-grid ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.footer-links-grid a {\n  color: var(--text-muted);\n  text-decoration: none;\n}\n\n\n@media (max-width: 768px) {\n  .hero-block {\n    padding: 2rem;\n    margin-top: 1.5rem;\n  }\n\n  .hero-form-row {\n    flex-direction: column;\n  }\n\n  .calculator-block {\n    grid-template-columns: 1fr;\n  }\n\n  .download-card {\n    padding: 2.5rem;\n  }\n\n  .offerings-block {\n    padding: 2rem;\n  }\n\n  .apply-content {\n    grid-template-columns: 1fr;\n  }\n\n  .apply-form {\n    padding: 1.75rem;\n  }\n\n  .apply-hero {\n    padding: 2rem;\n  }\n\n  .calculator-body {\n    grid-template-columns: 1fr;\n  }\n\n  .hero-visual {\n    grid-template-columns: 1fr;\n  }\n\n  .calculator-hero {\n    padding: 2rem;\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .calculator-hero.credit-hero {\n    grid-template-columns: 1fr;\n    padding: 1.5rem;\n    border-radius: 24px;\n  }\n\n  .calc-hero-copy {\n    order: 1;\n  }\n\n  .credit-hero-card {\n    width: 100%;\n    max-width: 100%;\n    order: 2;\n    margin: 0;\n    box-sizing: border-box;\n  }\n\n  .hero-mini-stats {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 0.75rem;\n  }\n\n  .credit-score-widget {\n    padding: 1.75rem;\n  }\n\n  .contact-cta {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .carousel {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 520px) {\n  .hero-grid {\n    gap: 1.5rem;\n  }\n\n  .stats-bar {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .steps-grid article,\n  .why-grid article,\n  .product-card,\n  .offering-card,\n  .tool-card,\n  .blog-grid article {\n    padding: 1.25rem;\n  }\n\n  .apply-form .primary-btn {\n    width: 100%;\n  }\n\n  .calculator-hero,\n  .calc-side-card,\n  .eligibility-calculator {\n    padding: 1.5rem;\n  }\n\n  .calculator-hero.credit-hero {\n    padding: 1.25rem;\n  }\n\n  .credit-hero-card {\n    padding: 1.25rem;\n  }\n\n  .calc-hero-copy {\n    gap: 0.5rem;\n  }\n\n  .calc-chip-row {\n    gap: 0.5rem;\n    flex-wrap: wrap;\n  }\n\n  .calc-chip {\n    flex: 1 1 calc(50% - 0.5rem);\n    min-width: calc(50% - 0.5rem);\n  }\n\n  .credit-form {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-buttons {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .contact-buttons .primary-btn,\n  .contact-buttons .ghost-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n.about-hero {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n  padding: 3rem;\n  border-radius: 36px;\n  background: linear-gradient(120deg, #e9ffff, #fff2e1, #fef0f4);\n  align-items: center;\n}\n\n.about-hero-illustration {\n  justify-self: center;\n}\n\n.hero-stat-grid {\n  list-style: none;\n  padding: 0;\n  margin: 2rem 0 0;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n.hero-stat-grid li {\n  background: #fff;\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n}\n\n.hero-stat-grid strong {\n  display: block;\n  font-size: 1.4rem;\n}\n\n.pillars-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-top: 1.25rem;\n}\n\n.pillar-card {\n  background: #fff;\n  border-radius: 20px;\n  border: 1px solid var(--border-soft);\n  padding: 1.1rem;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.pillar-card h3 {\n  margin: 0 0 0.35rem;\n}\n\n.pillar-card p {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.about-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n  gap: 1.5rem;\n}\n\n.insight-card {\n  background: var(--surface-soft);\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.75rem;\n}\n\n.insight-card ul {\n  padding-left: 1.2rem;\n  color: var(--text-muted);\n}\n\n.mission-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n}\n\n.mission-card {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.75rem;\n}\n\n.impact-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n  margin: 1rem 0 2rem;\n}\n\n.impact-grid article {\n  background: linear-gradient(135deg, #f7f9ff, #fff7ef);\n  border: 1px solid var(--border-soft);\n  border-radius: 18px;\n  padding: 1rem;\n  text-align: center;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.impact-grid strong {\n  display: block;\n  font-size: 1.4rem;\n}\n\n.leadership-grid {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n  display: grid;\n  gap: 1rem;\n  box-shadow: var(--shadow-soft);\n}\n\n.leadership-head h2 {\n  margin: 0.3rem 0 0.2rem;\n}\n\n.leader-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 0.9rem;\n}\n\n.leader-card {\n  background: var(--surface-soft);\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n  padding: 1rem;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.8rem;\n  align-items: center;\n}\n\n.leader-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, var(--primary), var(--primary-dark));\n  color: var(--secondary);\n  display: grid;\n  place-items: center;\n  font-weight: 800;\n}\n\n.leader-card h3 {\n  margin: 0;\n}\n\n.leader-card p {\n  margin: 0;\n  font-weight: 700;\n}\n\n.leader-card span {\n  color: var(--text-muted);\n}\n\n.quiz-page {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  padding-top: 3rem;\n}\n\n.quiz-hero {\n  background:\n    radial-gradient(circle at 0% 0% 0%, rgba(247, 189, 32, 0.18), transparent 50%),\n    radial-gradient(circle at 90% 10% 0%, rgba(232, 169, 26, 0.16), transparent 50%),\n    linear-gradient(120deg, #ffffff, #fff8e0);\n  color: var(--secondary);\n  border-radius: 32px;\n  padding: 2rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.5rem;\n  align-items: start;\n  box-shadow: var(--shadow-soft);\n}\n\n.quiz-hero__copy {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.quiz-hero__copy p {\n  margin: 0;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.quiz-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.quiz-badges span {\n  background: var(--surface);\n  border: 1px solid var(--border-soft);\n  padding: 0.55rem 0.85rem;\n  border-radius: 14px;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.quiz-hero__card {\n  background: var(--surface);\n  border: 1px solid var(--border-soft);\n  border-radius: 20px;\n  padding: 1.25rem;\n  display: grid;\n  gap: 0.75rem;\n  box-shadow: var(--shadow-soft);\n}\n\n.quiz-stats-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 0.6rem;\n}\n\n.quiz-stats-row div {\n  background: var(--surface);\n  border-radius: 12px;\n  border: 1px solid var(--border-soft);\n  padding: 0.65rem 0.8rem;\n  text-align: center;\n}\n\n.quiz-note {\n  margin: 0;\n  color: var(--text-muted);\n}\n\n.quiz-body {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.25rem;\n}\n\n.quiz-card {\n  background: #fff;\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.1);\n  display: grid;\n  gap: 1rem;\n}\n\n.quiz-questions {\n  display: grid;\n  gap: 1rem;\n}\n\n.quiz-question {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.8rem;\n  align-items: start;\n}\n\n.quiz-question__index {\n  width: 36px;\n  height: 36px;\n  border-radius: 12px;\n  background: var(--primary);\n  color: var(--secondary);\n  display: grid;\n  place-items: center;\n  font-weight: 800;\n  box-shadow: 0 12px 28px rgba(247, 189, 32, 0.35);\n}\n\n.quiz-options {\n  display: grid;\n  gap: 0.55rem;\n}\n\n.quiz-option {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.55rem;\n  align-items: center;\n  border: 1px solid var(--border-soft);\n  border-radius: 14px;\n  padding: 0.65rem 0.8rem;\n  background: var(--surface-soft);\n}\n\n.quiz-option.selected {\n  border-color: var(--secondary);\n  background: #eef6ff;\n}\n\n.quiz-option input {\n  accent-color: var(--secondary);\n}\n\n.quiz-aside {\n  display: grid;\n  gap: 0.9rem;\n}\n\n.quiz-tip-card {\n  background: #fff;\n  border-radius: 18px;\n  border: 1px solid var(--border-soft);\n  padding: 1.1rem;\n  box-shadow: 0 16px 36px rgba(15, 23, 42, 0.08);\n}\n\n.quiz-tip-card ul {\n  margin: 0.5rem 0 0;\n  padding-left: 1.1rem;\n  color: var(--text-muted);\n  display: grid;\n  gap: 0.35rem;\n}\n\n.reach-section .office-card {\n  background: #fff;\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n}\n\n.partner-showcase {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n  align-items: stretch;\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 2rem;\n}\n\n.ally-hero {\n  background: linear-gradient(135deg, rgba(233, 255, 255, 0.7), rgba(255, 242, 225, 0.7));\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.ally-list {\n  list-style: none;\n  padding: 0;\n  margin: 1.5rem 0 0;\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.ally-list li {\n  background: var(--surface-soft);\n  border-radius: 20px;\n  padding: 1rem;\n  flex: 1;\n  min-width: 140px;\n  text-align: center;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);\n}\n\n.ally-carousel {\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1rem;\n  background: #fefefe;\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);\n}\n\n.carousel {\n  display: grid;\n  grid-template-columns: minmax(220px, 1fr) minmax(260px, 1.4fr);\n  gap: 1.25rem;\n  align-items: stretch;\n}\n\n.carousel-visual {\n  position: relative;\n  border-radius: 24px;\n  overflow: hidden;\n}\n\n.carousel-slide {\n  border-radius: 24px;\n  height: 100%;\n  min-height: 220px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--secondary);\n  font-weight: 700;\n  font-size: 1.6rem;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  box-shadow: inset 0 0 60px rgba(0, 0, 0, 0.25);\n  animation: pulseBackground 6s ease-in-out infinite;\n}\n\n.about-cta {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  color: var(--secondary);\n  border-radius: 28px;\n  padding: 1.75rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow: var(--shadow-soft);\n}\n\n.about-cta p {\n  margin: 0.25rem 0;\n  color: var(--text-muted);\n}\n\n.about-cta-actions {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n@keyframes pulseBackground {\n  0% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.02);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n.carousel-control {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.85);\n  color: var(--text-strong);\n  font-size: 1.5rem;\n  cursor: pointer;\n  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.2);\n  transition: transform 0.2s ease;\n}\n\n.carousel-control:hover {\n  transform: translateY(-50%) scale(1.05);\n}\n\n.carousel-control.prev {\n  left: 1rem;\n}\n\n.carousel-control.next {\n  right: 1rem;\n}\n\n.carousel-content {\n  background: #fff;\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n}\n\n.carousel-content ul {\n  margin: 0;\n  padding-left: 1.2rem;\n  color: var(--text-muted);\n}\n\n.carousel-dots {\n  grid-column: 1 / -1;\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  margin-top: 0.5rem;\n}\n\n.carousel-dots button {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(15, 23, 42, 0.2);\n}\n\n.carousel-dots button.active {\n  background: var(--secondary);\n}\n\n.value-blocks {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.25rem;\n}\n\n.value-blocks article {\n  background: #fff;\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n  position: relative;\n  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.08);\n}\n\n.value-blocks article .eyebrow {\n  margin-bottom: 0.35rem;\n}\n\n.testimonial-showcase {\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 2.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.testimonial-header {\n  max-width: 720px;\n}\n\n.testimonial-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.25rem;\n}\n\n.testimonial-cards article {\n  background: var(--surface-soft);\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.25rem;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n}\n\n.inclusion-section {\n  background: linear-gradient(135deg, #fef6ee, #e9ffff);\n  border-radius: 32px;\n  padding: 2.5rem;\n  display: grid;\n  gap: 2rem;\n}\n\n.impact-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n.impact-grid .impact-card {\n  padding: 1.5rem;\n  border-radius: 24px;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  background: #fff;\n  text-align: center;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n}\n\n.governance-section {\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 2.5rem;\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08);\n}\n\n.governance-section .journey-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 1.5rem;\n}\n\n.governance-section .journey-grid article {\n  padding: 1.5rem;\n  border-radius: 24px;\n  background: var(--surface-soft);\n  border: 1px solid var(--border-soft);\n}\n\n.about-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n}\n\n.insight-card {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.75rem;\n  box-shadow: 0 10px 32px rgba(15, 23, 42, 0.06);\n}\n\n.mission-section {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 1.5rem;\n}\n\n.mission-card {\n  background: #fff;\n  border-radius: 28px;\n  border: 1px solid var(--border-soft);\n  padding: 1.75rem;\n}\n\n.reach-section {\n  background: #fff;\n  border-radius: 32px;\n  border: 1px solid var(--border-soft);\n  padding: 2.5rem;\n  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.06);\n}\n\n.office-card {\n  background: var(--surface-soft);\n  border-radius: 24px;\n  border: 1px solid var(--border-soft);\n  padding: 1.5rem;\n}\n\n/* ===== Personal Loan Page Styles ===== */\n.personal-loan-page {\n  padding-top: 0;\n  background: #fff;\n}\n\n/* Hero Section */\n.personal-loan-hero {\n  background: linear-gradient(135deg, #fffef9 0%, #fff7e6 50%, #ffffff 100%);\n  padding: 5rem 0 6rem;\n  position: relative;\n  overflow: hidden;\n  margin-top: 80px;\n}\n\n.personal-loan-hero::before {\n  content: '';\n  position: absolute;\n  top: -30%;\n  right: -15%;\n  width: 800px;\n  height: 800px;\n  background: radial-gradient(circle, rgba(247, 189, 32, 0.12) 0%, transparent 60%);\n  border-radius: 50%;\n  animation: float 20s ease-in-out infinite;\n}\n\n@keyframes float {\n\n  0%,\n  100% {\n    transform: translate(0, 0) scale(1);\n  }\n\n  50% {\n    transform: translate(-20px, 20px) scale(1.05);\n  }\n}\n\n.hero-content-wrapper {\n  width: min(1240px, 94vw);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.3fr 1fr;\n  gap: 5rem;\n  align-items: center;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-badge {\n  display: inline-block;\n  padding: 0.6rem 1.5rem;\n  background: linear-gradient(135deg, #f7bd20, #ffed4e);\n  color: var(--secondary);\n  font-weight: 800;\n  font-size: 0.85rem;\n  border-radius: 999px;\n  margin-bottom: 1.75rem;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  box-shadow: 0 4px 15px rgba(247, 189, 32, 0.3);\n  animation: pulse 2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n\n  0%,\n  100% {\n    transform: scale(1);\n  }\n\n  50% {\n    transform: scale(1.02);\n  }\n}\n\n.hero-text h1 {\n  font-size: clamp(2.5rem, 5vw, 4rem);\n  line-height: 1.15;\n  margin: 0 0 1.5rem;\n  color: var(--secondary);\n  font-weight: 800;\n  letter-spacing: -0.5px;\n}\n\n.hero-description {\n  font-size: 1.15rem;\n  line-height: 1.8;\n  color: #555;\n  margin-bottom: 2.5rem;\n  max-width: 600px;\n}\n\n.hero-features {\n  display: flex;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  margin-bottom: 2.5rem;\n}\n\n.feature-pill {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.75rem 1.5rem;\n  background: #fff;\n  border: 2px solid rgba(247, 189, 32, 0.25);\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--secondary);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: all 0.3s ease;\n}\n\n.feature-pill:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(247, 189, 32, 0.2);\n  border-color: var(--primary);\n}\n\n.feature-pill .icon {\n  font-size: 1.3rem;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.loan-highlight-card {\n  background: linear-gradient(135deg, #fff 0%, #fffdf5 100%);\n  padding: 3rem 2.5rem;\n  border-radius: 28px;\n  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.12);\n  border: 2px solid rgba(247, 189, 32, 0.15);\n  position: relative;\n  overflow: hidden;\n}\n\n.loan-highlight-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--gradient-primary);\n}\n\n.highlight-amount {\n  font-size: 3.5rem;\n  font-weight: 900;\n  background: linear-gradient(135deg, #f7bd20, #ffa500);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.highlight-label {\n  color: #666;\n  font-size: 1.05rem;\n  margin-bottom: 2.5rem;\n  font-weight: 600;\n}\n\n.highlight-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  padding-top: 2rem;\n  border-top: 2px solid rgba(247, 189, 32, 0.2);\n}\n\n.stat-item {\n  text-align: center;\n  padding: 1rem;\n  background: rgba(247, 189, 32, 0.05);\n  border-radius: 12px;\n}\n\n.stat-item strong {\n  display: block;\n  font-size: 1.75rem;\n  color: var(--secondary);\n  margin-bottom: 0.35rem;\n  font-weight: 800;\n}\n\n.stat-item span {\n  color: #666;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n/* Section Block Base */\n.section-block {\n  padding: 5rem 0;\n}\n\n.section-heading {\n  text-align: center;\n  max-width: 700px;\n  margin: 0 auto 3.5rem;\n}\n\n.section-heading h2 {\n  font-size: clamp(2rem, 4vw, 2.75rem);\n  font-weight: 800;\n  color: var(--secondary);\n  margin: 0 0 1rem;\n  line-height: 1.2;\n}\n\n.section-heading p {\n  font-size: 1.1rem;\n  color: #666;\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* Eligibility Section */\n.eligibility-section {\n  background: linear-gradient(to bottom, #fff 0%, #fffef9 100%);\n}\n\n.eligibility-grid {\n  width: min(1240px, 94vw);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.75rem;\n}\n\n.eligibility-card {\n  padding: 2rem 1.75rem;\n  background: #fff;\n  border-radius: 20px;\n  border: 2px solid rgba(247, 189, 32, 0.15);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n}\n\n.eligibility-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-primary);\n  border-radius: 20px 20px 0 0;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.eligibility-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 16px 40px rgba(247, 189, 32, 0.15);\n  border-color: var(--primary);\n}\n\n.eligibility-card:hover::before {\n  opacity: 1;\n}\n\n.eligibility-label {\n  font-size: 0.8rem;\n  font-weight: 800;\n  color: var(--primary-dark);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 1rem;\n}\n\n.eligibility-value {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--secondary);\n  line-height: 1.6;\n}\n\n/* Documents Section */\n.documents-section {\n  background: linear-gradient(135deg, #fffef9 0%, #fff7e6 100%);\n}\n\n.documents-grid {\n  width: min(1240px, 94vw);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 2rem;\n}\n\n.document-card {\n  padding: 2.25rem 2rem;\n  background: #fff;\n  border-radius: 20px;\n  border: 2px solid rgba(17, 17, 17, 0.06);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);\n  transition: all 0.3s ease;\n}\n\n.document-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.1);\n  border-color: rgba(247, 189, 32, 0.3);\n}\n\n.document-icon {\n  font-size: 2.75rem;\n  margin-bottom: 1.25rem;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\n}\n\n.document-card h3 {\n  font-size: 1.15rem;\n  margin: 0 0 1.25rem;\n  color: var(--secondary);\n  font-weight: 800;\n}\n\n.document-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.document-card li {\n  padding: 0.65rem 0;\n  color: #555;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  border-bottom: 1px solid rgba(17, 17, 17, 0.06);\n  font-weight: 500;\n}\n\n.document-card li:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.document-card li::before {\n  content: '✓';\n  color: var(--primary-dark);\n  font-weight: bold;\n  margin-right: 0.75rem;\n}\n\n/* Fees Section */\n.fees-section {\n  background: #fff;\n}\n\n.fees-table-wrapper {\n  width: min(1240px, 94vw);\n  margin: 0 auto;\n  overflow-x: auto;\n  border-radius: 20px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.08);\n  border: 2px solid rgba(247, 189, 32, 0.15);\n}\n\n.fees-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.fees-table thead {\n  background: linear-gradient(135deg, #f7bd20, #ffed4e);\n}\n\n.fees-table th {\n  padding: 1.5rem 1.75rem;\n  text-align: left;\n  font-weight: 800;\n  color: var(--secondary);\n  font-size: 1rem;\n  letter-spacing: 0.3px;\n}\n\n.fees-table td {\n  padding: 1.5rem 1.75rem;\n  border-bottom: 1px solid rgba(17, 17, 17, 0.06);\n}\n\n.fees-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.fee-type {\n  font-weight: 700;\n  color: var(--secondary);\n  width: 35%;\n  font-size: 0.95rem;\n}\n\n.fee-charge {\n  color: #555;\n  line-height: 1.7;\n  font-size: 0.95rem;\n}\n\n.fees-table tbody tr {\n  transition: background 0.2s ease;\n}\n\n.fees-table tbody tr:hover {\n  background: rgba(247, 189, 32, 0.04);\n}\n\n/* Apply Steps Section */\n.apply-steps-section {\n  background: linear-gradient(to bottom, #fffef9 0%, #fff 100%);\n}\n\n.steps-timeline {\n  width: min(1240px, 94vw);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 2.5rem;\n}\n\n.step-card {\n  padding: 2.5rem 2rem;\n  background: #fff;\n  border-radius: 20px;\n  border: 2px solid rgba(247, 189, 32, 0.15);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.step-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 16px 40px rgba(247, 189, 32, 0.2);\n}\n\n.step-number {\n  width: 56px;\n  height: 56px;\n  background: linear-gradient(135deg, #f7bd20, #ffed4e);\n  color: var(--secondary);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 900;\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 6px 20px rgba(247, 189, 32, 0.3);\n}\n\n.step-card h3 {\n  margin: 0 0 1rem;\n  font-size: 1.35rem;\n  color: var(--secondary);\n  font-weight: 800;\n}\n\n.step-card p {\n  margin: 0;\n  color: #555;\n  line-height: 1.7;\n  font-size: 1rem;\n}\n\n/* CTA Section */\n.personal-loan-cta {\n  background: linear-gradient(135deg, #fffef9 0%, #fff7e6 50%, #ffffff 100%);\n  text-align: center;\n  padding: 5rem 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.personal-loan-cta::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(247, 189, 32, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.cta-content {\n  max-width: 800px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.cta-content h2 {\n  font-size: clamp(2rem, 4vw, 3rem);\n  margin: 0 0 1rem;\n  font-weight: 800;\n  color: #f7bd20;\n}\n\n.cta-content p {\n  font-size: 1.2rem;\n  color: #f7bd20;\n  margin: 0 0 2.5rem;\n  line-height: 1.7;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1.25rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n/* Button size variants */\n.primary-btn.large,\n.ghost-btn.large {\n  padding: 1.1rem 2.5rem;\n  font-size: 1.1rem;\n  font-weight: 700;\n  border-radius: 999px;\n  box-shadow: 0 6px 24px rgba(247, 189, 32, 0.25);\n  transition: all 0.3s ease;\n}\n\n.primary-btn.large:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 32px rgba(247, 189, 32, 0.35);\n}\n\n.ghost-btn.large:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .hero-content-wrapper {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n\n  .loan-highlight-card {\n    max-width: 450px;\n    margin: 0 auto;\n  }\n\n  .section-block {\n    padding: 4rem 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .personal-loan-hero {\n    padding: 3rem 0 4rem;\n  }\n\n  .hero-text h1 {\n    font-size: 2.25rem;\n  }\n\n  .hero-description {\n    font-size: 1.05rem;\n  }\n\n  .eligibility-grid,\n  .documents-grid,\n  .steps-timeline {\n    grid-template-columns: 1fr;\n  }\n\n  .fees-table-wrapper {\n    font-size: 0.9rem;\n    border-radius: 12px;\n  }\n\n  .fees-table th,\n  .fees-table td {\n    padding: 1rem;\n  }\n\n  .hero-actions,\n  .cta-buttons {\n    flex-direction: column;\n  }\n\n  .hero-actions .primary-btn,\n  .hero-actions .ghost-btn,\n  .cta-buttons .primary-btn,\n  .cta-buttons .ghost-btn {\n    width: 100%;\n  }\n\n  .section-heading h2 {\n    font-size: 1.75rem;\n  }\n\n  .section-block {\n    padding: 3.5rem 0;\n  }\n}\n\n*/ .personal-loan-page {\n  padding-top: 0;\n}\n\n/* Hero Section */\n.personal-loan-hero {\n  background: linear-gradient(135deg, #fff6d6, #fffbea, #ffffff);\n  padding: 4rem 0;\n  position: relative;\n  overflow: hidden;\n}\n\n.personal-loan-hero::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -20%;\n  width: 600px;\n  height: 600px;\n  background: radial-gradient(circle, rgba(247, 189, 32, 0.15) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.hero-content-wrapper {\n  width: min(1240px, 94vw);\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1.2fr 1fr;\n  gap: 4rem;\n  align-items: center;\n}\n\n.hero-badge {\n  display: inline-block;\n  padding: 0.5rem 1.25rem;\n  background: var(--gradient-primary);\n  color: var(--secondary);\n  font-weight: 700;\n  font-size: 0.9rem;\n  border-radius: 999px;\n  margin-bottom: 1.5rem;\n}\n\n.hero-text h1 {\n  font-size: clamp(2.5rem, 5vw, 3.5rem);\n  line-height: 1.1;\n  margin: 0 0 1.5rem;\n  color: var(--secondary);\n}\n\n.hero-description {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: var(--text-muted);\n  margin-bottom: 2rem;\n}\n\n.hero-features {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 2rem;\n}\n\n.feature-pill {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.65rem 1.25rem;\n  background: rgba(247, 189, 32, 0.1);\n  border: 1px solid rgba(247, 189, 32, 0.3);\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.feature-pill .icon {\n  font-size: 1.2rem;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.loan-highlight-card {\n  background: #fff;\n  padding: 2.5rem;\n  border-radius: 24px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(247, 189, 32, 0.2);\n}\n\n.highlight-amount {\n  font-size: 3rem;\n  font-weight: 800;\n  color: var(--primary-dark);\n  margin-bottom: 0.5rem;\n}\n\n.highlight-label {\n  color: var(--text-muted);\n  font-size: 1rem;\n  margin-bottom: 2rem;\n}\n\n.highlight-stats {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1.5rem;\n  padding-top: 2rem;\n  border-top: 1px solid rgba(17, 17, 17, 0.1);\n}\n\n.stat-item {\n  text-align: center;\n}\n\n.stat-item strong {\n  display: block;\n  font-size: 1.5rem;\n  color: var(--secondary);\n  margin-bottom: 0.25rem;\n}\n\n.stat-item span {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n/* Eligibility Section */\n.eligibility-section {\n  background: #fff;\n}\n\n.eligibility-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n}\n\n.eligibility-card {\n  padding: 1.75rem;\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  border-radius: 16px;\n  border: 1px solid rgba(247, 189, 32, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.eligibility-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.1);\n}\n\n.eligibility-label {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--primary-dark);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 0.75rem;\n}\n\n.eligibility-value {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: var(--secondary);\n  line-height: 1.5;\n}\n\n/* Documents Section */\n.documents-section {\n  background: linear-gradient(135deg, #fffdf5, #fff7da);\n}\n\n.documents-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n}\n\n.document-card {\n  padding: 2rem;\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid rgba(17, 17, 17, 0.08);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.document-icon {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n}\n\n.document-card h3 {\n  font-size: 1.1rem;\n  margin: 0 0 1rem;\n  color: var(--secondary);\n}\n\n.document-card ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.document-card li {\n  padding: 0.5rem 0;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  border-bottom: 1px solid rgba(17, 17, 17, 0.05);\n}\n\n.document-card li:last-child {\n  border-bottom: none;\n}\n\n/* Fees Section */\n.fees-section {\n  background: #fff;\n}\n\n.fees-table-wrapper {\n  overflow-x: auto;\n  border-radius: 16px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n}\n\n.fees-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #fff;\n}\n\n.fees-table thead {\n  background: var(--gradient-primary);\n}\n\n.fees-table th {\n  padding: 1.25rem;\n  text-align: left;\n  font-weight: 700;\n  color: var(--secondary);\n  font-size: 1rem;\n}\n\n.fees-table td {\n  padding: 1.25rem;\n  border-bottom: 1px solid rgba(17, 17, 17, 0.05);\n}\n\n.fees-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.fee-type {\n  font-weight: 600;\n  color: var(--secondary);\n  width: 30%;\n}\n\n.fee-charge {\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n.fees-table tbody tr:hover {\n  background: rgba(247, 189, 32, 0.05);\n}\n\n/* Apply Steps Section */\n.apply-steps-section {\n  background: linear-gradient(135deg, #fff6d6, #fffbea);\n}\n\n.steps-timeline {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n}\n\n.step-card {\n  padding: 2rem;\n  background: #fff;\n  border-radius: 16px;\n  border: 1px solid rgba(247, 189, 32, 0.2);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n\n.step-number {\n  width: 48px;\n  height: 48px;\n  background: var(--gradient-primary);\n  color: var(--secondary);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 800;\n  font-size: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.step-card h3 {\n  margin: 0 0 0.75rem;\n  font-size: 1.25rem;\n  color: var(--secondary);\n}\n\n.step-card p {\n  margin: 0;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n/* CTA Section */\n.personal-loan-cta {\n  background: linear-gradient(135deg, #ffffff, #fff7da);\n  text-align: center;\n  padding: 4rem 2rem;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .hero-content-wrapper {\n    grid-template-columns: 1fr;\n    gap: 3rem;\n  }\n\n  .loan-highlight-card {\n    max-width: 400px;\n    margin: 0 auto;\n  }\n}\n\n@media (max-width: 768px) {\n  .personal-loan-hero {\n    padding: 3rem 0;\n  }\n\n  .hero-text h1 {\n    font-size: 2rem;\n  }\n\n  .eligibility-grid,\n  .documents-grid,\n  .steps-timeline {\n    grid-template-columns: 1fr;\n  }\n\n  .fees-table-wrapper {\n    font-size: 0.9rem;\n  }\n\n  .fees-table th,\n  .fees-table td {\n    padding: 0.875rem;\n  }\n\n  .hero-actions {\n    flex-direction: column;\n  }\n\n  .hero-actions .primary-btn,\n  .hero-actions .ghost-btn {\n    width: 100%;\n  }\n}\n\n/* Button size variants */\n.primary-btn.large,\n.ghost-btn.large {\n  padding: 1rem 2rem;\n  font-size: 1.1rem;\n}\n\n.cta-buttons {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.cta-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.cta-content h2 {\n  font-size: 2.5rem;\n  margin: 0 0 1rem;\n}\n\n.cta-content p {\n  font-size: 1.1rem;\n  color: #f7bd20;\n  margin: 0 0 2rem;\n}\n\n/* Additional Visual Enhancements for Personal Loan Page */\n.card-icon {\n  font-size: 4rem;\n  text-align: center;\n  margin-bottom: 1.5rem;\n  filter: drop-shadow(0 4px 8px rgba(247, 189, 32, 0.3));\n  animation: float-icon 3s ease-in-out infinite;\n}\n\n@keyframes float-icon {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n.stat-icon {\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.trust-badges {\n  display: flex;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 2px solid rgba(247, 189, 32, 0.2);\n}\n\n.badge-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--secondary);\n}\n\n.badge-icon {\n  font-size: 1.2rem;\n}\n\n.section-icon {\n  font-size: 3.5rem;\n  margin-bottom: 1rem;\n  filter: drop-shadow(0 4px 8px rgba(247, 189, 32, 0.2));\n}\n\n.card-number {\n  position: absolute;\n  top: -15px;\n  right: 20px;\n  width: 40px;\n  height: 40px;\n  background: linear-gradient(135deg, #f7bd20, #ffed4e);\n  color: var(--secondary);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 900;\n  font-size: 1.1rem;\n  box-shadow: 0 4px 12px rgba(247, 189, 32, 0.4);\n}\n\n/* Improve fees table visual */\n.fees-table thead th:first-child {\n  border-radius: 20px 0 0 0;\n}\n\n.fees-table thead th:last-child {\n  border-radius: 0 20px 0 0;\n}\n\n/* Add more visual appeal */\n.loan-highlight-card {\n  animation: card-float 6s ease-in-out infinite;\n}\n\n@keyframes card-float {\n\n  0%,\n  100% {\n    transform: translateY(0) rotate(0deg);\n  }\n\n  50% {\n    transform: translateY(-8px) rotate(1deg);\n  }\n}\n\n/* Illustration Styles */\n.hero-illustration {\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.hero-illustration img {\n  width: 100%;\n  max-width: 400px;\n  height: auto;\n  border-radius: 20px;\n  box-shadow: 0 12px 40px rgba(247, 189, 32, 0.2);\n  animation: float-illustration 4s ease-in-out infinite;\n}\n\n@keyframes float-illustration {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-15px);\n  }\n}\n\n.section-illustration {\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.section-illustration img {\n  width: 100%;\n  max-width: 280px;\n  height: auto;\n  filter: drop-shadow(0 8px 24px rgba(247, 189, 32, 0.15));\n  animation: subtle-float 6s ease-in-out infinite;\n}\n\n@keyframes subtle-float {\n\n  0%,\n  100% {\n    transform: translateY(0);\n  }\n\n  50% {\n    transform: translateY(-8px);\n  }\n}\n\n.hero-visual {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .hero-illustration img {\n    max-width: 300px;\n  }\n\n  .section-illustration img {\n    max-width: 200px;\n  }\n}\n\n/* ==========================================\n   About Page Styles - Modern & Clean\n   ========================================== */\n\n/* About Hero Section */\n.about-hero-modern {\n  margin-top: 2rem;\n  padding: 4rem 3rem;\n  border-radius: 40px;\n  background: linear-gradient(135deg,\n      rgba(255, 251, 234, 0.95) 0%,\n      rgba(255, 248, 225, 0.85) 50%,\n      rgba(255, 243, 214, 0.75) 100%);\n  box-shadow: 0 26px 80px rgba(15, 23, 42, 0.12);\n  position: relative;\n  overflow: hidden;\n}\n\n.about-hero-content {\n  max-width: 900px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.about-hero-content .hero-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 1.25rem;\n  background: rgba(247, 189, 32, 0.2);\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: var(--secondary);\n  margin-bottom: 1.5rem;\n}\n\n.about-hero-content h1 {\n  font-size: clamp(2.4rem, 5vw, 4rem);\n  line-height: 1.15;\n  margin: 0 0 1.5rem;\n  color: var(--text-strong);\n}\n\n.about-hero-content .gradient-text {\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.about-hero-content .hero-subtitle {\n  font-size: 1.1rem;\n  line-height: 1.7;\n  color: var(--text-muted);\n  margin-bottom: 2rem;\n  max-width: 800px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.hero-cta-group {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n  margin-bottom: 3rem;\n}\n\n.about-hero-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1.5rem;\n  margin-top: 3rem;\n}\n\n.stat-card {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 1.5rem;\n  text-align: center;\n  border: 1px solid rgba(247, 189, 32, 0.2);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.15);\n}\n\n.stat-value {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--primary-dark);\n  margin-bottom: 0.5rem;\n}\n\n.stat-label {\n  font-size: 0.95rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n/* Values Section */\n.values-section {\n  margin-top: 5rem;\n}\n\n.values-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 2rem;\n}\n\n.value-card {\n  background: white;\n  border-radius: 24px;\n  padding: 2rem;\n  border: 1px solid var(--border-soft);\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.value-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 150px;\n  height: 150px;\n  background: var(--gradient-glow);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  pointer-events: none;\n}\n\n.value-card:hover {\n  transform: translateY(-6px);\n  box-shadow: var(--shadow-soft);\n  border-color: rgba(247, 189, 32, 0.4);\n}\n\n.value-card:hover::before {\n  opacity: 1;\n}\n\n.value-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  display: block;\n}\n\n.value-card h3 {\n  font-size: 1.4rem;\n  margin: 0 0 0.75rem;\n  color: var(--text-strong);\n}\n\n.value-card p {\n  color: var(--text-muted);\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* Journey Timeline Section */\n.journey-section {\n  margin-top: 5rem;\n}\n\n.journey-timeline {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem 0;\n}\n\n.timeline-item {\n  display: grid;\n  grid-template-columns: 80px 1fr;\n  gap: 2rem;\n  margin-bottom: 3rem;\n  position: relative;\n}\n\n.timeline-marker {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.timeline-dot {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: var(--gradient-primary);\n  border: 4px solid rgba(247, 189, 32, 0.2);\n  z-index: 2;\n  flex-shrink: 0;\n}\n\n.timeline-line {\n  width: 2px;\n  height: 100%;\n  background: linear-gradient(to bottom, rgba(247, 189, 32, 0.3), rgba(247, 189, 32, 0.1));\n  margin-top: 0.5rem;\n  flex-grow: 1;\n}\n\n.timeline-content {\n  background: white;\n  border-radius: 20px;\n  padding: 1.75rem 2rem;\n  border: 1px solid var(--border-soft);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.timeline-content:hover {\n  transform: translateX(6px);\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);\n}\n\n.timeline-year {\n  display: inline-block;\n  padding: 0.35rem 1rem;\n  background: var(--gradient-primary);\n  color: var(--secondary);\n  border-radius: 999px;\n  font-weight: 700;\n  font-size: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.timeline-content h3 {\n  font-size: 1.4rem;\n  margin: 0 0 0.75rem;\n  color: var(--text-strong);\n}\n\n.timeline-content p {\n  color: var(--text-muted);\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* Mission & Vision Section */\n.mission-vision-section {\n  margin-top: 5rem;\n}\n\n.mission-vision-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 2.5rem;\n}\n\n.mission-card.modern,\n.vision-card.modern {\n  background: linear-gradient(135deg, #ffffff 0%, #fff9e6 100%);\n  border-radius: 32px;\n  padding: 3rem 2.5rem;\n  border: 1px solid var(--border-soft);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.mission-card.modern:hover,\n.vision-card.modern:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 30px 70px rgba(15, 23, 42, 0.15);\n}\n\n.mission-card .card-badge,\n.vision-card .card-badge {\n  display: inline-block;\n  padding: 0.4rem 1rem;\n  background: rgba(247, 189, 32, 0.15);\n  border-radius: 999px;\n  font-weight: 600;\n  font-size: 0.85rem;\n  color: var(--secondary);\n  margin-bottom: 1.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n}\n\n.mission-card h2,\n.vision-card h2 {\n  font-size: 1.9rem;\n  margin: 0 0 1.25rem;\n  color: var(--text-strong);\n}\n\n.mission-card p,\n.vision-card p {\n  color: var(--text-muted);\n  line-height: 1.8;\n  margin: 0;\n  font-size: 1.05rem;\n}\n\n/* Leadership Team Section */\n.leadership-section {\n  margin-top: 5rem;\n}\n\n.team-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.team-card {\n  background: white;\n  border-radius: 24px;\n  padding: 2rem;\n  border: 1px solid var(--border-soft);\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.team-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-soft);\n  border-color: rgba(247, 189, 32, 0.4);\n}\n\n.team-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: var(--gradient-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--secondary);\n  flex-shrink: 0;\n}\n\n.team-info h3 {\n  font-size: 1.3rem;\n  margin: 0 0 0.35rem;\n  color: var(--text-strong);\n}\n\n.team-role {\n  color: var(--primary-dark);\n  font-weight: 600;\n  font-size: 0.95rem;\n  margin: 0 0 0.5rem;\n}\n\n.team-focus {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n/* Legal & Compliance Section */\n.legal-section {\n  margin-top: 5rem;\n}\n\n.legal-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 2rem;\n}\n\n.legal-card {\n  background: white;\n  border-radius: 24px;\n  padding: 2.5rem;\n  border: 1px solid var(--border-soft);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.legal-card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-soft);\n}\n\n.legal-card h3 {\n  font-size: 1.5rem;\n  margin: 0 0 1.5rem;\n  color: var(--text-strong);\n}\n\n.legal-info {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 0;\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.info-row:last-child {\n  border-bottom: none;\n}\n\n.info-label {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.info-value {\n  color: var(--text-strong);\n  font-weight: 600;\n  text-align: right;\n}\n\n.certification-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.certification-list li {\n  padding: 0.75rem 0;\n  color: var(--text-muted);\n  font-size: 1rem;\n  border-bottom: 1px solid var(--border-soft);\n}\n\n.certification-list li:last-child {\n  border-bottom: none;\n}\n\n/* Office Locations Section */\n.office-section {\n  margin-top: 5rem;\n}\n\n.office-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  margin-bottom: 3rem;\n}\n\n.office-card.modern {\n  background: white;\n  border-radius: 24px;\n  padding: 2.5rem;\n  border: 1px solid var(--border-soft);\n  text-align: center;\n  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n.office-card.modern:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-soft);\n  border-color: rgba(247, 189, 32, 0.4);\n}\n\n.office-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.office-card h3 {\n  font-size: 1.3rem;\n  margin: 0 0 1rem;\n  color: var(--text-strong);\n}\n\n.office-address {\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin: 0 0 0.5rem;\n}\n\n.office-city {\n  color: var(--text-strong);\n  font-weight: 600;\n  margin: 0;\n}\n\n.contact-info-section {\n  background: linear-gradient(135deg, #fff 0%, #fff9e6 100%);\n  border-radius: 24px;\n  padding: 2.5rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 2rem;\n  border: 1px solid var(--border-soft);\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n}\n\n.contact-icon {\n  font-size: 2rem;\n  flex-shrink: 0;\n}\n\n.contact-item>div {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.contact-label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.contact-value {\n  font-size: 1.1rem;\n  color: var(--text-strong);\n  font-weight: 600;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.contact-value:hover {\n  color: var(--primary-dark);\n}\n\n/* About Page CTA */\n.about-cta {\n  margin-top: 5rem;\n  padding: 4rem 3rem;\n  background: var(--gradient-dark);\n  border-radius: 40px;\n  text-align: center;\n}\n\n.about-cta .cta-content h2 {\n  color: #f7bd20;\n  font-size: clamp(2rem, 4vw, 3rem);\n  margin-bottom: 1rem;\n}\n\n.about-cta .cta-content p {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1.1rem;\n  margin-bottom: 2rem;\n}\n\n.about-cta .cta-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: center;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .about-hero-modern {\n    padding: 2.5rem 1.5rem;\n  }\n\n  .about-hero-stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .mission-vision-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .timeline-item {\n    grid-template-columns: 60px 1fr;\n    gap: 1rem;\n  }\n\n  .team-card {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .contact-info-section {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .about-hero-stats {\n    grid-template-columns: 1fr;\n  }\n\n  .stat-value {\n    font-size: 2rem;\n  }\n\n  .hero-cta-group {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .hero-cta-group .primary-btn,\n  .hero-cta-group .ghost-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/* ============================================\n   COMPREHENSIVE MOBILE RESPONSIVE STYLES\n   ============================================ */\n\n/* Mobile-First Product Card Background Fix */\n.product-card {\n  background: rgba(255, 255, 255, 0.95) !important;\n  backdrop-filter: blur(10px);\n  box-shadow: 0 8px 32px rgba(15, 23, 42, 0.08);\n}\n\n.product-card.modern {\n  background: rgba(255, 255, 255, 0.98) !important;\n}\n\n/* Section Block Mobile Optimization */\n@media (max-width: 1024px) {\n  .section-block {\n    margin: 3rem 0;\n  }\n\n  .product-grid {\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 1.25rem;\n  }\n\n  .page {\n    width: min(1240px, 92vw);\n  }\n}\n\n/* Tablet Responsive Styles */\n@media (max-width: 768px) {\n\n  /* Hero Section */\n  .hero-block {\n    margin-top: 1rem;\n    padding: 2rem 1.5rem;\n    border-radius: 32px;\n  }\n\n  .hero-grid {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n\n  .hero-content h1 {\n    font-size: clamp(1.8rem, 5vw, 2.5rem);\n  }\n\n  .hero-content p {\n    font-size: 1rem;\n  }\n\n  .hero-cta {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .hero-cta .primary-btn,\n  .hero-cta .ghost-btn {\n    width: 100%;\n    text-align: center;\n    justify-content: center;\n    display: flex;\n  }\n\n  .hero-carousel {\n    height: 300px;\n  }\n\n  /* Section Headings */\n  .section-heading {\n    max-width: 100%;\n    margin: 0 auto 2rem;\n  }\n\n  .section-heading h2 {\n    font-size: clamp(1.6rem, 4vw, 2.2rem);\n  }\n\n  .section-heading p {\n    font-size: 0.95rem;\n  }\n\n  .eyebrow {\n    font-size: 0.7rem;\n  }\n\n  /* Product Grid */\n  .product-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .product-card {\n    min-height: 180px;\n    padding: 1.25rem;\n    border-radius: 20px;\n  }\n\n  .product-card img {\n    width: 56px;\n    height: 56px;\n  }\n\n  .product-card h3 {\n    font-size: 1.1rem;\n  }\n\n  .product-card p {\n    font-size: 0.9rem;\n  }\n\n  .product-badge {\n    font-size: 0.8rem;\n    padding: 0.3rem 0.7rem;\n  }\n\n  /* Stats Bar */\n  .stats-bar {\n    grid-template-columns: repeat(2, 1fr);\n    padding: 1.25rem;\n    gap: 0.75rem;\n    margin: 2rem 0;\n  }\n\n  .stats-bar strong {\n    font-size: 1.5rem;\n  }\n\n  /* Calculator Block */\n  .calculator-block {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .loan-calculator {\n    padding: 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .loan-calculator__inputs,\n  .loan-calculator__summary {\n    min-width: 100%;\n  }\n\n  /* Steps Grid */\n  .steps-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .steps-grid article {\n    padding: 1.5rem;\n  }\n\n  /* Offerings */\n  .offerings-block {\n    padding: 2rem 1.5rem;\n    border-radius: 28px;\n  }\n\n  .offering-grid {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n    gap: 1rem;\n  }\n\n  /* CTA Section */\n  .cta-section {\n    padding: 2rem 1.5rem;\n  }\n\n  .cta-buttons {\n    flex-direction: column;\n    gap: 0.75rem;\n    width: 100%;\n  }\n\n  .cta-buttons .primary-btn,\n  .cta-buttons .ghost-btn {\n    width: 100%;\n    text-align: center;\n    justify-content: center;\n    display: flex;\n  }\n\n  /* Testimonials */\n  .testimonials-carousel {\n    padding: 1rem;\n  }\n\n  .testimonial-card {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    padding: 1.5rem;\n    text-align: center;\n  }\n\n  .testimonial-avatar {\n    width: 60px;\n    height: 60px;\n    margin: 0 auto;\n  }\n\n  .testimonials-carousel-track {\n    min-height: 320px;\n  }\n}\n\n/* Mobile Phone Responsive Styles */\n@media (max-width: 480px) {\n\n  /* Page Container */\n  .page {\n    width: min(1240px, 90vw);\n    padding-bottom: 3rem;\n  }\n\n  .fibe-home {\n    padding-top: 1rem;\n  }\n\n  /* Hero Section */\n  .hero-block {\n    padding: 1.5rem 1rem;\n    border-radius: 24px;\n    margin-top: 0.5rem;\n  }\n\n  .hero-content h1 {\n    font-size: 1.75rem;\n    line-height: 1.2;\n  }\n\n  .hero-content p {\n    font-size: 0.9rem;\n    line-height: 1.6;\n  }\n\n  .hero-badges {\n    flex-direction: column;\n    gap: 0.5rem;\n    font-size: 0.85rem;\n  }\n\n  .hero-carousel {\n    height: 250px;\n    border-radius: 20px;\n  }\n\n  /* Buttons */\n  .primary-btn,\n  .ghost-btn {\n    font-size: 0.9rem;\n    padding: 0.7rem 1.5rem;\n  }\n\n  .primary-btn.large,\n  .ghost-btn.large {\n    font-size: 1rem;\n    padding: 0.85rem 1.75rem;\n  }\n\n  /* Section Headings */\n  .section-block {\n    margin: 2.5rem 0;\n  }\n\n  .section-heading {\n    margin: 0 auto 1.5rem;\n  }\n\n  .section-heading h2 {\n    font-size: 1.5rem;\n    margin: 0.5rem 0;\n  }\n\n  .section-heading p {\n    font-size: 0.9rem;\n    line-height: 1.6;\n  }\n\n  .eyebrow {\n    font-size: 0.65rem;\n    letter-spacing: 0.12em;\n  }\n\n  /* Product Cards */\n  .product-grid {\n    gap: 0.875rem;\n  }\n\n  .product-card {\n    padding: 1.125rem;\n    min-height: 160px;\n    border-radius: 18px;\n  }\n\n  .product-card img {\n    width: 48px;\n    height: 48px;\n    margin-bottom: 0.75rem;\n  }\n\n  .product-card h3 {\n    font-size: 1rem;\n    margin: 0.5rem 0;\n  }\n\n  .product-card p {\n    font-size: 0.85rem;\n    line-height: 1.5;\n  }\n\n  .product-badge {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.6rem;\n  }\n\n  .product-arrow {\n    font-size: 0.85rem;\n    margin-top: 0.5rem;\n  }\n\n  /* Stats Bar */\n  .stats-bar {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n    gap: 0.5rem;\n    border-radius: 20px;\n    margin: 1.5rem 0;\n  }\n\n  .stats-bar strong {\n    font-size: 1.35rem;\n  }\n\n  .stats-bar span {\n    font-size: 0.85rem;\n  }\n\n  /* CTA Section */\n  .cta-section {\n    padding: 1.5rem 1rem;\n    margin: 2rem 0;\n  }\n\n  .cta-content h2 {\n    font-size: 1.5rem;\n  }\n\n  .cta-content p {\n    font-size: 0.9rem;\n  }\n}\n\n/* Product Content Improvements */\n.product-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  flex: 1;\n}\n\n.product-content h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-strong);\n}\n\n.product-content p {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: var(--text-muted);\n}\n\n.product-badge {\n  display: inline-block;\n  padding: 0.35rem 0.85rem;\n  background: rgba(247, 189, 32, 0.15);\n  color: var(--secondary);\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  width: fit-content;\n}\n\n.product-arrow {\n  margin-top: 1rem;\n  font-weight: 600;\n  color: var(--primary-dark);\n  font-size: 0.9rem;\n}\n\n/* Prevent horizontal scroll */\n@media (max-width: 768px) {\n  body {\n    overflow-x: hidden;\n  }\n\n  .App {\n    overflow-x: hidden;\n  }\n\n  .page {\n    overflow-x: hidden;\n    padding-top: 90px !important;\n    /* Ensure space for fixed header */\n  }\n\n  .hero-grid,\n  .product-grid,\n  .stats-bar,\n  .calculator-block,\n  .steps-grid,\n  .offering-grid {\n    width: 100%;\n    max-width: 100%;\n  }\n}\n\n/* ============================================\n   MOBILE PAGE SYNC & OPTIMIZATION\n   ============================================ */\n\n/* Ensure all pages have proper spacing for fixed header */\n.page {\n  padding-top: 100px;\n  min-height: 100vh;\n}\n\n@media (max-width: 900px) {\n  .page {\n    padding-top: 90px;\n  }\n}\n\n@media (max-width: 640px) {\n  .page {\n    padding-top: 85px;\n  }\n}\n\n/* Global mobile card & background sync */\n@media (max-width: 768px) {\n\n  /* Ensure all hero sections have consistent styling */\n  [class*=\"-hero\"],\n  [class*=\"hero-\"] {\n    margin: 1rem 0 2rem !important;\n    padding: 2rem 1.5rem !important;\n    border-radius: 24px !important;\n  }\n\n  /* Ensure all section cards are consistent */\n  [class*=\"-section\"],\n  [class*=\"section-\"] {\n    padding: 2rem 1.5rem;\n    border-radius: 20px;\n  }\n\n  /* Ensure all content cards are consistent */\n  [class*=\"-card\"],\n  [class*=\"card-\"] {\n    border-radius: 18px !important;\n  }\n\n  /* Full width buttons on mobile */\n  .hero-cta .primary-btn,\n  .hero-cta .ghost-btn,\n  [class*=\"cta\"] .primary-btn,\n  [class*=\"cta\"] .ghost-btn {\n    width: 100%;\n    justify-content: center;\n    display: flex;\n  }\n\n  /* Consistent section heading sizes */\n  .section-heading h2,\n  [class*=\"-section\"] h2 {\n    font-size: clamp(1.6rem, 4vw, 2.2rem) !important;\n  }\n\n  /* Consistent eyebrow sizes */\n  .eyebrow,\n  [class*=\"eyebrow\"] {\n    font-size: 0.75rem !important;\n  }\n\n  /* Grid mobile optimization */\n  [class*=\"-grid\"],\n  [class*=\"grid-\"] {\n    grid-template-columns: 1fr !important;\n    gap: 1.25rem !important;\n  }\n\n  /* Ensure no overflow on any container */\n  * {\n    max-width: 100%;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n/* Small mobile adjustments */\n@media (max-width: 480px) {\n  .page {\n    width: min(1280px, 94vw) !important;\n    padding-top: 80px;\n  }\n\n  [class*=\"-hero\"],\n  [class*=\"hero-\"] {\n    padding: 1.5rem 1rem !important;\n    border-radius: 20px !important;\n  }\n\n  .section-heading h2,\n  [class*=\"-section\"] h2 {\n    font-size: 1.5rem !important;\n  }\n\n  .primary-btn,\n  .ghost-btn {\n    font-size: 0.9rem;\n    padding: 0.75rem 1.5rem;\n  }\n}\n\n/* Ensure proper background colors everywhere */\n@media (max-width: 768px) {\n  body {\n    background: linear-gradient(135deg,\n        rgba(255, 251, 234, 0.4) 0%,\n        rgba(255, 248, 225, 0.3) 25%,\n        rgba(255, 243, 214, 0.2) 50%,\n        rgba(255, 237, 196, 0.3) 75%,\n        rgba(255, 232, 161, 0.4) 100%) !important;\n  }\n}\n\n/* ============================================\n   COMPREHENSIVE DEVICE OPTIMIZATION\n   ============================================ */\n\n/* Tablet Specific (iPad, tablets) */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .page {\n    width: min(1280px, 92vw);\n  }\n\n  /* Optimize grids for tablet */\n  [class*=\"-grid\"]:not(.form-grid),\n  [class*=\"grid-\"]:not(.form-grid) {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n\n  /* Form grids stay single column on tablet for better UX */\n  .form-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n/* Large Mobile / Small Tablet (iPhone Pro Max, small tablets) */\n@media (min-width: 481px) and (max-width: 768px) {\n  .page {\n    width: 100%;\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  /* Ensure touch targets are at least 44px */\n  button,\n  a,\n  input,\n  select,\n  textarea {\n    min-height: 44px;\n  }\n}\n\n/* Small Mobile (iPhone SE, small phones) */\n@media (max-width: 480px) {\n  .page {\n    width: 100% !important;\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n    padding-top: 80px;\n  }\n\n  /* Reduce font sizes slightly for small screens */\n  html {\n    font-size: 15px;\n  }\n\n  /* Adjust Hero Spacing */\n  [class*=\"-hero\"],\n  [class*=\"hero-\"] {\n    padding: 1.5rem 1rem !important;\n    border-radius: 20px !important;\n  }\n\n  .hero-content h1 {\n    font-size: 2rem !important;\n  }\n\n  /* Ensure buttons are easily tappable */\n  .primary-btn,\n  .ghost-btn,\n  button {\n    min-height: 48px;\n    padding: 0.875rem 1.5rem;\n    width: 100%;\n    justify-content: center;\n    display: flex;\n    align-items: center;\n  }\n\n  /* Full width tables with scroll */\n  table {\n    display: block;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n}\n\n/* Landscape Mode Optimization */\n@media (max-height: 500px) and (orientation: landscape) {\n  .page {\n    padding-top: 70px;\n  }\n\n  [class*=\"-hero\"],\n  [class*=\"hero-\"] {\n    padding: 1.5rem 2rem !important;\n  }\n\n  /* Reduce vertical spacing in landscape */\n  section {\n    margin: 2rem 0;\n  }\n}\n\n/* High DPI / Retina Displays */\n@media (-webkit-min-device-pixel-ratio: 2),\n(min-resolution: 192dpi) {\n\n  /* Ensure images are sharp on retina displays */\n  img {\n    image-rendering: -webkit-optimize-contrast;\n    image-rendering: crisp-edges;\n  }\n}\n\n/* Touch Device Optimization */\n@media (hover: none) and (pointer: coarse) {\n\n  /* Larger touch targets for touch devices */\n  a,\n  button,\n  input,\n  select {\n    min-height: 44px;\n    min-width: 44px;\n  }\n\n  /* Remove hover effects on touch devices */\n  *:hover {\n    transform: none !important;\n  }\n\n  /* But keep active states */\n  *:active {\n    opacity: 0.8;\n  }\n}\n\n/* Safe Area for Devices with Notches (iPhone X, etc.) */\n@supports (padding: max(0px)) {\n  .page {\n    padding-left: max(1rem, env(safe-area-inset-left)) !important;\n    padding-right: max(1rem, env(safe-area-inset-right)) !important;\n  }\n\n  .fibe-header {\n    padding-left: max(1rem, env(safe-area-inset-left));\n    padding-right: max(1rem, env(safe-area-inset-right));\n  }\n}\n\n/* Ensure Carousel Visibility on Mobile */\n@media (max-width: 768px) {\n  .hero-visual {\n    display: flex !important;\n    width: 100%;\n    margin-top: 2rem;\n    position: relative;\n    z-index: 1;\n  }\n\n  .hero-carousel {\n    display: block !important;\n    width: 100% !important;\n    height: 300px !important;\n    opacity: 1 !important;\n    visibility: visible !important;\n    overflow: hidden;\n    position: relative;\n    background: rgba(255, 255, 255, 0.5);\n    /* Placeholder background */\n  }\n\n  .carousel-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .carousel-track {\n    width: 100%;\n    height: 100%;\n  }\n\n  /* ===== Landing hero - responsive adjustments ===== */\n  @media (max-width: 900px) {\n    .hero-block {\n      padding: 1.5rem;\n      border-radius: 20px;\n    }\n\n    .hero-grid {\n      grid-template-columns: 1fr;\n      gap: 1.25rem;\n      align-items: start;\n    }\n\n    .hero-content h1 {\n      font-size: clamp(1.6rem, 6vw, 2.4rem);\n      line-height: 1.15;\n      margin-bottom: 0.75rem;\n    }\n\n    .hero-content p {\n      font-size: 0.98rem;\n    }\n\n    .hero-visual {\n      order: 2;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .hero-carousel {\n      height: auto !important;\n      min-height: 180px;\n    }\n\n    .carousel-image {\n      max-width: 420px;\n      width: 100%;\n      height: auto;\n      border-radius: 12px;\n    }\n\n    .hero-cta {\n      justify-content: center;\n    }\n\n    .hero-badges {\n      display: flex;\n      justify-content: center;\n      gap: 0.75rem;\n      flex-wrap: wrap;\n    }\n  }\n\n  @media (max-width: 480px) {\n    .hero-block {\n      padding: 1rem;\n      border-radius: 14px;\n    }\n\n    .hero-content h1 {\n      font-size: clamp(1.4rem, 7.5vw, 1.9rem);\n    }\n\n    .carousel-image {\n      max-width: 320px;\n    }\n  }\n}\n\n/* Prevent zoom on input focus (iOS) */\n@media (max-width: 768px) {\n\n  input[type=\"text\"],\n  input[type=\"email\"],\n  input[type=\"tel\"],\n  input[type=\"number\"],\n  input[type=\"date\"],\n  select,\n  textarea {\n    font-size: 16px !important;\n  }\n}\n\n/* Ensure smooth scrolling on all devices */\nhtml {\n  scroll-behavior: smooth;\n  -webkit-overflow-scrolling: touch;\n  background: #D4A017;\n  min-height: 100vh;\n}\n\n/* Optimize for print */\n@media print {\n\n  .fibe-header,\n  .site-footer,\n  .primary-btn,\n  .ghost-btn,\n  nav,\n  [class*=\"cta\"] {\n    display: none !important;\n  }\n\n  .page {\n    padding-top: 0 !important;\n  }\n\n  * {\n    background: white !important;\n    color: black !important;\n  }\n}\n\n/* Accessibility - Reduced Motion */\n@media (prefers-reduced-motion: reduce) {\n\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n/* Final Overflow Prevention */\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  overflow-x: hidden;\n  width: 100%;\n  position: relative;\n}\n\n.page,\nsection,\ndiv {\n  max-width: 100%;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n}\n\n/* Ensure all images are responsive */\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Ensure iframes are responsive */\niframe {\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
